// data format should be like this but  values are inccorect

const data = [
  {
    title: "terafic", //OK
    id: 201,
    value: 39,
  },
  {
    title: "TARH", //OK
    id: 203,
    value: [
      {
        name: "زوج و فرد",
        state: true,
      },
      {
        name: "ترافیک",
        state: true,
      },
    ],
  },
  {
    title: "FUEL", //OK
    id: 204,
    value: [
      {
        name: "پمپ بنزین وصال",
        dist: 826.85418447271,
        lon: 51.4006007254432,
        lat: 35.7013851913736,
      },
      {
        name: "جایگاه شرکتی شماره ۲۲",
        dist: 1206.73183218021,
        lon: 51.3898334114828,
        lat: 35.7174325905416,
      },
    ],
  },
  {
    title: "CNG", //OK
    id: 205,
    value: [
      {
        name: "جایگاه گاز طبیعی بیهقی",
        dist: 3752.25657088839,
        lon: 51.418992,
        lat: 35.7355774,
      },
      {
        name: "جایگاه CNG",
        dist: 5162.18823828324,
        lon: 51.366439,
        lat: 35.6676671,
      },
      {
        name: "جایگاه CNG فدایان اسلام",
        dist: 8554.51614228776,
        lon: 51.4348101,
        lat: 35.637478,
      },
    ],
  },
  {
    title: "metro", //OK
    id: 301,
    value: [
      {
        dist: 814.30398048,
        name: "میدان انقلاب اسلامی",
        lon: 51.3919374,
        lat: 35.7009551,
      },
      {
        dist: 1115.29908649,
        name: "تئاترشهر",
        lon: 51.4052124,
        lat: 35.7013101,
      },
      {
        dist: 1118.95684593,
        name: "میدان ولیعصر",
        lon: 51.4070144,
        lat: 35.7116098,
      },
    ],
  },
  {
    title: "BRT", //OK
    id: 302,
    value: [
      {
        name: "میدان انقلاب - سامانه ۱ تندرو",
        dist: 35.7009754,
        lon: "1",
        lat: 51.3925198,
      },
      {
        name: "دانشگاه تهران - سامانه ۱ تندرو",
        dist: 35.7011279,
        lon: "1",
        lat: 51.3999952,
      },
      {
        name: "طالقانی، شمال به جنوب - سامانه ۷ تندرو",
        dist: 35.7070521,
        lon: "7",
        lat: 51.4061266,
      },
    ],
  },
  {
    title: "BUS", //OK
    id: 303,
    value: [
      {
        dist: 147.52322371,
        name: "حجاب",
        lon: 51.3964539238761,
        lat: 35.7087817175608,
      },
      {
        dist: 227.98206653,
        name: "شانزده آذر",
        lon: 51.3931064809238,
        lat: 35.7075298876606,
      },
      {
        dist: 250.9005902,
        name: "وصال",
        lon: 51.3979363825078,
        lat: 35.7088931636335,
      },
    ],
  },
  {
    title: "taxi", //OK
    id: 304,
    value: [
      {
        dist: 709.8843949,
        name: "ایستگاه تاکسی انقلاب - ونک",
        lon: 51.3905766,
        lat: 35.702745,
      },
      {
        dist: 1631.71314208,
        name: "فاطمی - میدان صنعت",
        lon: 51.4040623,
        lat: 35.7206154,
      },
      {
        dist: 1882.49508732,
        name: null,
        lon: 51.4144708,
        lat: 35.7148848,
      },
    ],
  },
  {
    title: "BUSLINE", //OK
    id: 305,
    value: [
      {
        dist: 11.87271906,
        source: "پایانه شهید براری",
        destination: "میدان ولی\u200cعصرعج",
        coor: {
          type: "MultiLineString",
          coordinates: [
            [
              [
                51.4915985538828,
                35.6930979499128
              ],
              [
                51.491583623772,
                35.6930483725515
              ],
              [
                51.491559162237,
                35.6930453140319
              ],
              [
                51.4913367280224,
                35.6930152096628
              ],
              [
                51.4912227824821,
                35.6929987781442
              ],
              [
                51.4911698633377,
                35.6929594317273
              ],
              [
                51.4911142726618,
                35.6929253801005
              ],
              [
                51.4910629284933,
                35.6928995918125
              ],
              [
                51.4910087493274,
                35.6928772173167
              ],
              [
                51.4909517351595,
                35.6928582566096
              ],
              [
                51.4908918859844,
                35.6928427096872
              ],
              [
                51.4903824874353,
                35.6928252024799
              ],
              [
                51.4901456929264,
                35.6928074364064
              ],
              [
                51.4898714231447,
                35.6927899278656
              ],
              [
                51.4893689998143,
                35.692757852804
              ],
              [
                51.4887668817729,
                35.6927194101288
              ],
              [
                51.4886190864501,
                35.692654029735
              ],
              [
                51.4884585179964,
                35.6926975935578
              ],
              [
                51.4865065426426,
                35.6925442596845
              ],
              [
                51.4850279808783,
                35.6924162249459
              ],
              [
                51.4849437628884,
                35.6923632391251
              ],
              [
                51.4848477406184,
                35.6924022355201
              ],
              [
                51.4840911268226,
                35.6923502558323
              ],
              [
                51.4829484473648,
                35.6922633841655
              ],
              [
                51.4804668302966,
                35.6920812708394
              ],
              [
                51.4799541955734,
                35.6920397381956
              ],
              [
                51.478853013963,
                35.6919437116673
              ],
              [
                51.4787264608293,
                35.6918818329904
              ],
              [
                51.478530609354,
                35.6919274714201
              ],
              [
                51.4762798482727,
                35.6917581838914
              ],
              [
                51.4758246834596,
                35.6917322704454
              ],
              [
                51.474929471544,
                35.6916695276176
              ],
              [
                51.4739495809972,
                35.6916084757109
              ],
              [
                51.4731758446813,
                35.6915488245894
              ],
              [
                51.4716263728396,
                35.6914293520487
              ],
              [
                51.4701586032445,
                35.6913228575667
              ],
              [
                51.4680378104226,
                35.6911437313071
              ],
              [
                51.4673438765804,
                35.6910851118621
              ],
              [
                51.4663756229884,
                35.6910133498852
              ],
              [
                51.465242163995,
                35.6909066430324
              ],
              [
                51.4650159651797,
                35.6908328853834
              ],
              [
                51.464750373472,
                35.6908569188574
              ],
              [
                51.4639457803163,
                35.6907771399435
              ],
              [
                51.4634667465064,
                35.6907426512185
              ],
              [
                51.4628850891106,
                35.6906939406865
              ],
              [
                51.4619782573496,
                35.6906078632992
              ],
              [
                51.4611656367935,
                35.6905736253719
              ],
              [
                51.4610608457502,
                35.6905175025811
              ],
              [
                51.4609374755579,
                35.6905613786632
              ],
              [
                51.4607157360212,
                35.6905489879301
              ],
              [
                51.4603633336591,
                35.690529296522
              ],
              [
                51.4595983992206,
                35.6904834654093
              ],
              [
                51.4593008362298,
                35.6904699171105
              ],
              [
                51.4584088477813,
                35.6904142646848
              ],
              [
                51.4578075980872,
                35.6903918885675
              ],
              [
                51.4572930545428,
                35.6903670026689
              ],
              [
                51.4572515419897,
                35.6903649946345
              ],
              [
                51.457028018766,
                35.6903541835377
              ],
              [
                51.4569755382948,
                35.6903516454124
              ],
              [
                51.4563141957042,
                35.6903196531289
              ],
              [
                51.4548492859467,
                35.690216987654
              ],
              [
                51.4531218521757,
                35.6900895917454
              ],
              [
                51.4521014521265,
                35.690020976667
              ],
              [
                51.4520682484541,
                35.6900261369741
              ],
              [
                51.4520399984083,
                35.6900332640649
              ],
              [
                51.4520267885398,
                35.6900369319165
              ],
              [
                51.4520149836162,
                35.690041421288
              ],
              [
                51.4519998359473,
                35.6900471818875
              ],
              [
                51.4519867969273,
                35.6900521402302
              ],
              [
                51.4519723734562,
                35.690060106204
              ],
              [
                51.4519585162976,
                35.6900677589868
              ],
              [
                51.4519466774758,
                35.6900762327906
              ],
              [
                51.4519289462012,
                35.6900889231061
              ],
              [
                51.4519191017086,
                35.6900982730195
              ],
              [
                51.4519073751582,
                35.6901094098188
              ],
              [
                51.4518961591239,
                35.6901222938665
              ],
              [
                51.4518884174333,
                35.6901335284094
              ],
              [
                51.4518756483702,
                35.6901520615995
              ],
              [
                51.451858088232,
                35.6901886336898
              ],
              [
                51.4518458533292,
                35.6902258466859
              ],
              [
                51.4516858126105,
                35.6916891709595
              ],
              [
                51.4516543177956,
                35.6919767879309
              ],
              [
                51.4516087228761,
                35.6923933712707
              ],
              [
                51.4507540395861,
                35.6923446983263
              ],
              [
                51.449891798336,
                35.6922957987053
              ],
              [
                51.4496598863272,
                35.6922785081381
              ],
              [
                51.4492065830936,
                35.6922448466413
              ],
              [
                51.4474951624419,
                35.6921311315123
              ],
              [
                51.4474567554703,
                35.6918515898733
              ],
              [
                51.4474094977227,
                35.6912466388488
              ],
              [
                51.4474045798496,
                35.6911843732899
              ],
              [
                51.4473604197778,
                35.6905198434379
              ],
              [
                51.4473351763566,
                35.6900792059323
              ],
              [
                51.4473025167019,
                35.6900262716453
              ],
              [
                51.4472845786001,
                35.6900010556278
              ],
              [
                51.4472718465661,
                35.6899844389671
              ],
              [
                51.4472389880385,
                35.6899455591416
              ],
              [
                51.4472110612738,
                35.6899162291068
              ],
              [
                51.4471637745143,
                35.6898726512568
              ],
              [
                51.4471211089022,
                35.6898386135257
              ],
              [
                51.4470479620579,
                35.6897894243425
              ],
              [
                51.4469282919212,
                35.6897282574465
              ],
              [
                51.446860513037,
                35.6897113176369
              ],
              [
                51.4467919296144,
                35.6896989412308
              ],
              [
                51.446610980813,
                35.6897245292753
              ],
              [
                51.4463343906034,
                35.6897831630685
              ],
              [
                51.4461288838063,
                35.6898337995203
              ],
              [
                51.4458446712905,
                35.6899452627265
              ],
              [
                51.4456404277546,
                35.6900627920744
              ],
              [
                51.4452703538219,
                35.6903194613348
              ],
              [
                51.4450031471936,
                35.6905492124033
              ],
              [
                51.4445023037921,
                35.6910214118131
              ],
              [
                51.4443554973152,
                35.6911587719652
              ],
              [
                51.4440430120233,
                35.691427309426
              ],
              [
                51.4439014548789,
                35.6915287412581
              ],
              [
                51.4437119670941,
                35.6916408707449
              ],
              [
                51.4435609013354,
                35.6917098685507
              ],
              [
                51.4433401034168,
                35.6917603014282
              ],
              [
                51.4431243241926,
                35.691802553854
              ],
              [
                51.4421154727611,
                35.6919052453056
              ],
              [
                51.4411884302162,
                35.6920071578596
              ],
              [
                51.440303342176,
                35.6921063672325
              ],
              [
                51.4397750980198,
                35.6921647205166
              ],
              [
                51.4390053020227,
                35.6922555331921
              ],
              [
                51.4390033326381,
                35.6922557657822
              ],
              [
                51.4384509088833,
                35.6923209312191
              ],
              [
                51.4375714241541,
                35.6924375448941
              ],
              [
                51.4375017815205,
                35.6924438885449
              ],
              [
                51.4374633773343,
                35.6924465193224
              ],
              [
                51.4374411837176,
                35.6924477044719
              ],
              [
                51.4374200628477,
                35.6924486044101
              ],
              [
                51.4373938153301,
                35.6924494147762
              ],
              [
                51.437357844634,
                35.6924499719404
              ],
              [
                51.437295551834,
                35.6924538741976
              ],
              [
                51.437200514877,
                35.692457379615
              ],
              [
                51.4371580829399,
                35.6924583541988
              ],
              [
                51.4371208242999,
                35.692458852855
              ],
              [
                51.4370535766455,
                35.6924589076816
              ],
              [
                51.4369899000955,
                35.6924579559086
              ],
              [
                51.4369328378142,
                35.6924562741167
              ],
              [
                51.4368899078417,
                35.6924544914191
              ],
              [
                51.4368228343565,
                35.6924508127273
              ],
              [
                51.436052621296,
                35.6925607641288
              ],
              [
                51.4355557158376,
                35.6926316975037
              ],
              [
                51.4338612484334,
                35.6928132155091
              ],
              [
                51.4337375089524,
                35.6928031339581
              ],
              [
                51.4336538990541,
                35.6927873148988
              ],
              [
                51.4335783481425,
                35.6927630166572
              ],
              [
                51.4335247860532,
                35.6927390728663
              ],
              [
                51.4334607868695,
                35.6927014068227
              ],
              [
                51.4334062996456,
                35.6926590558794
              ],
              [
                51.4333801681027,
                35.6926341305632
              ],
              [
                51.4332806089089,
                35.6925251975819
              ],
              [
                51.433229780852,
                35.6924512726471
              ],
              [
                51.4329745987406,
                35.6916286982809
              ],
              [
                51.4327503989498,
                35.6910006400914
              ],
              [
                51.432684494537,
                35.690702172411
              ],
              [
                51.4326311373715,
                35.690683371445
              ],
              [
                51.4325772123797,
                35.6906683727715
              ],
              [
                51.4325227195543,
                35.6906571763899
              ],
              [
                51.4324676588877,
                35.6906497822994
              ],
              [
                51.4324121433715,
                35.6906461939239
              ],
              [
                51.4323560622917,
                35.6906463924846
              ],
              [
                51.4322994156401,
                35.6906503779807
              ],
              [
                51.4322422034086,
                35.6906581504115
              ],
              [
                51.4321717453073,
                35.6906999012165
              ],
              [
                51.4320985659259,
                35.6907378799064
              ],
              [
                51.4320133476939,
                35.6907759487149
              ],
              [
                51.4319247138138,
                35.6908092828684
              ],
              [
                51.4311700147529,
                35.6910070989245
              ],
              [
                51.4306146331796,
                35.6910605349051
              ],
              [
                51.4304063311328,
                35.6910702258352
              ],
              [
                51.4302674954681,
                35.6910826498386
              ],
              [
                51.4300752752694,
                35.6911375789382
              ],
              [
                51.4295324455923,
                35.6913399057892
              ],
              [
                51.4290888586344,
                35.6915084773149
              ],
              [
                51.4285926836134,
                35.6916867773282
              ],
              [
                51.4282541229405,
                35.6918096467368
              ],
              [
                51.4277421920316,
                35.6919951564585
              ],
              [
                51.4271818127004,
                35.6921989659681
              ],
              [
                51.4259799362519,
                35.6926416934086
              ],
              [
                51.4245615025284,
                35.6931684521189
              ],
              [
                51.4244756908116,
                35.6932003190888
              ],
              [
                51.4244325025347,
                35.6932163572343
              ],
              [
                51.4236893774202,
                35.6934837737245
              ],
              [
                51.4226829406935,
                35.6938403767042
              ],
              [
                51.4215298844908,
                35.6942337457446
              ],
              [
                51.4208525932424,
                35.6944555882202
              ],
              [
                51.4197686865668,
                35.6948413160661
              ],
              [
                51.4197569429184,
                35.694841740211
              ],
              [
                51.4197049413206,
                35.6948436165998
              ],
              [
                51.4195129496788,
                35.694850544075
              ],
              [
                51.4185414241212,
                35.6949012571216
              ],
              [
                51.417265522945,
                35.6949610314931
              ],
              [
                51.4156909806471,
                35.6950437724437
              ],
              [
                51.4147114042616,
                35.6950862739293
              ],
              [
                51.4142883200037,
                35.6951056227607
              ],
              [
                51.4135805547243,
                35.6951245167358
              ],
              [
                51.413174070896,
                35.6951474048359
              ],
              [
                51.4120754988687,
                35.6952091184443
              ],
              [
                51.4108598535323,
                35.6952733901016
              ],
              [
                51.4104966978841,
                35.695284647995
              ],
              [
                51.410157998821,
                35.6952894081505
              ],
              [
                51.4095792637045,
                35.6953335769028
              ],
              [
                51.4091249256862,
                35.6953565916088
              ],
              [
                51.4078512932369,
                35.6954052856503
              ],
              [
                51.4067075947456,
                35.695472134288
              ],
              [
                51.4054726619617,
                35.6955407103025
              ],
              [
                51.4044727243912,
                35.6955841528124
              ],
              [
                51.4031728525622,
                35.6956500607408
              ],
              [
                51.4017712302307,
                35.695720588766
              ],
              [
                51.4000608958002,
                35.6958135974471
              ],
              [
                51.3995609029051,
                35.6958310033231
              ],
              [
                51.3984645806394,
                35.6959004790964
              ],
              [
                51.3976096147884,
                35.6959561779192
              ],
              [
                51.3976860273352,
                35.6965093397827
              ],
              [
                51.397688908595,
                35.6965299866772
              ],
              [
                51.3977351426003,
                35.6968645453498
              ],
              [
                51.3977769986181,
                35.6971667876974
              ],
              [
                51.397854207799,
                35.6976858054729
              ],
              [
                51.3978613099291,
                35.6977323946153
              ],
              [
                51.3979431355305,
                35.6982835537567
              ],
              [
                51.3979977650087,
                35.6986502421024
              ],
              [
                51.3980142293012,
                35.698761954056
              ],
              [
                51.39809254622,
                35.6992859286517
              ],
              [
                51.398152588344,
                35.6997060865101
              ],
              [
                51.3982080519582,
                35.7000945228916
              ],
              [
                51.3982565642097,
                35.7004351118486
              ],
              [
                51.3982978859328,
                35.7010994223047
              ],
              [
                51.3977359446518,
                35.7024927929803
              ],
              [
                51.3974276182523,
                35.7032041153977
              ],
              [
                51.3972602864461,
                35.7035901776986
              ],
              [
                51.3971510525974,
                35.7038380857473
              ],
              [
                51.396893986234,
                35.7044213491527
              ],
              [
                51.3967535680222,
                35.7047414685495
              ],
              [
                51.3965442151664,
                35.7052204858691
              ],
              [
                51.3963014279534,
                35.7057760802716
              ],
              [
                51.3960396249394,
                35.7063754974075
              ],
              [
                51.3958303967736,
                35.7068537195361
              ],
              [
                51.395722252893,
                35.707100271953
              ],
              [
                51.3955734500802,
                35.707442025026
              ],
              [
                51.395438767868,
                35.7077512294964
              ],
              [
                51.3952886106597,
                35.7080956671879
              ],
              [
                51.3952127690907,
                35.7082719760087
              ],
              [
                51.3954761712537,
                35.7081939104187
              ],
              [
                51.3971008954624,
                35.7086484063849
              ],
              [
                51.3971740278324,
                35.7088435206159
              ],
              [
                51.3973730829189,
                35.7087335218563
              ],
              [
                51.3986769631946,
                35.7091030424097
              ],
              [
                51.3987243753558,
                35.7092862085978
              ],
              [
                51.3989612227994,
                35.7091682648746
              ],
              [
                51.4019163776649,
                35.709987807953
              ],
              [
                51.4040713434043,
                35.7106333126321
              ],
              [
                51.4042662504461,
                35.7108520140368
              ],
              [
                51.4046717301384,
                35.7107747088139
              ],
              [
                51.4054593134266,
                35.7109924707494
              ]
            ]
          ]
        },
      },
      {
        dist: 11.87271906,
        source: "میدان خراسان",
        destination: "میدان انقلاب اسلامی",
        coor: {
          type: "MultiLineString",
          coordinates: [
            [
              [
                51.4456401031146,
                35.6664225376785
              ],
              [
                51.4456360861688,
                35.6663713234035
              ],
              [
                51.4456107888338,
                35.6660486764881
              ],
              [
                51.4456071779014,
                35.6660027181448
              ],
              [
                51.4455714161799,
                35.6656360731258
              ],
              [
                51.4455189497512,
                35.665634280948
              ],
              [
                51.4454726185425,
                35.6656175376653
              ],
              [
                51.4454316069309,
                35.665599126497
              ],
              [
                51.4453989581453,
                35.6655785204563
              ],
              [
                51.4453611397189,
                35.6655453953777
              ],
              [
                51.4453268120392,
                35.6655006037334
              ],
              [
                51.4453006641936,
                35.665441354754
              ],
              [
                51.445292114272,
                35.6653963208042
              ],
              [
                51.4452913577203,
                35.6653645373287
              ],
              [
                51.4452972353823,
                35.6653215075595
              ],
              [
                51.4453120513402,
                35.665277455641
              ],
              [
                51.4453426886493,
                35.6652263575308
              ],
              [
                51.4453803695213,
                35.6651868013506
              ],
              [
                51.4454215382193,
                35.6651575478742
              ],
              [
                51.4454711414364,
                35.6651344484043
              ],
              [
                51.4455225280749,
                35.6651209276076
              ],
              [
                51.445560572031,
                35.6651167168621
              ],
              [
                51.44561384181,
                35.6651185890009
              ],
              [
                51.4456642006528,
                35.6651288841528
              ],
              [
                51.4457103497832,
                35.665146507133
              ],
              [
                51.4457774389806,
                35.6651908446908
              ],
              [
                51.4458154539589,
                35.6652322955208
              ],
              [
                51.4458443549931,
                35.6652823176733
              ],
              [
                51.4459428401083,
                35.6652880264142
              ],
              [
                51.4460100760103,
                35.6652877774013
              ],
              [
                51.4462277133215,
                35.6652607298972
              ],
              [
                51.4471306772008,
                35.6651494041315
              ],
              [
                51.447394326735,
                35.6651168982723
              ],
              [
                51.4475372338467,
                35.6651005435295
              ],
              [
                51.4476305874312,
                35.6650881714248
              ],
              [
                51.4493026691396,
                35.6648891140382
              ],
              [
                51.449657602801,
                35.6648448487885
              ],
              [
                51.4499204748831,
                35.6648045050913
              ],
              [
                51.4501481461989,
                35.6647428217593
              ],
              [
                51.4501781977449,
                35.6647253421077
              ],
              [
                51.4502967496874,
                35.6646563853461
              ],
              [
                51.4507079186413,
                35.6644020121902
              ],
              [
                51.4509730386989,
                35.6642224524205
              ],
              [
                51.4514644593502,
                35.6638896196036
              ],
              [
                51.4516508607181,
                35.6638623097426
              ],
              [
                51.4517578087459,
                35.6639323425653
              ],
              [
                51.4517757235792,
                35.6639944359372
              ],
              [
                51.4519066212047,
                35.664439020183
              ],
              [
                51.4519664172916,
                35.6646422570959
              ],
              [
                51.4520108087919,
                35.6647930170873
              ],
              [
                51.4520732144158,
                35.6650049476276
              ],
              [
                51.4521187078007,
                35.6651596120228
              ],
              [
                51.4521772841718,
                35.6653587482352
              ],
              [
                51.4522242992828,
                35.6655184884843
              ],
              [
                51.4522832427638,
                35.6657187566088
              ],
              [
                51.4523353807419,
                35.6658955716708
              ],
              [
                51.4524534642271,
                35.6663248096719
              ],
              [
                51.4525154488434,
                35.6665502074285
              ],
              [
                51.4526347896104,
                35.6669839738965
              ],
              [
                51.4527067506375,
                35.6672626576419
              ],
              [
                51.4527614598535,
                35.6674745625622
              ],
              [
                51.4528488993216,
                35.6678129087105
              ],
              [
                51.4525128008098,
                35.6678493378048
              ],
              [
                51.4522474713355,
                35.6678778786677
              ],
              [
                51.4520109706109,
                35.6679034011555
              ],
              [
                51.4519870803526,
                35.6679059784442
              ],
              [
                51.4515197431988,
                35.6679524916162
              ],
              [
                51.4511252775457,
                35.6679987471197
              ],
              [
                51.4505642446766,
                35.6680538945062
              ],
              [
                51.4503027063074,
                35.6680795605213
              ],
              [
                51.4500658520622,
                35.6681029499497
              ],
              [
                51.4498145947238,
                35.6681276514002
              ],
              [
                51.4497406513069,
                35.668134898141
              ],
              [
                51.449405884826,
                35.6681677963161
              ],
              [
                51.448876423807,
                35.6682198110552
              ],
              [
                51.4488700508445,
                35.6682204389078
              ],
              [
                51.4487176326019,
                35.66823536643
              ],
              [
                51.4486699131156,
                35.6682402471756
              ],
              [
                51.4483217822495,
                35.6682758023693
              ],
              [
                51.4480891487533,
                35.6682995932617
              ],
              [
                51.4480667271605,
                35.6683018604568
              ],
              [
                51.4477303928797,
                35.6683362123459
              ],
              [
                51.4473595657942,
                35.6683740852043
              ],
              [
                51.446938474999,
                35.6684090851483
              ],
              [
                51.4468944529983,
                35.6684126927838
              ],
              [
                51.4466643624356,
                35.6684317667545
              ],
              [
                51.4459796773883,
                35.6684857609266
              ],
              [
                51.445924683887,
                35.6685260062253
              ],
              [
                51.4458997591857,
                35.6685548372538
              ],
              [
                51.4458855606264,
                35.6685911418871
              ],
              [
                51.4458763073091,
                35.6686335376886
              ],
              [
                51.4459111784072,
                35.669086676899
              ],
              [
                51.4459284571614,
                35.6693190977794
              ],
              [
                51.4459564320631,
                35.6696953926468
              ],
              [
                51.4459774908935,
                35.6699786291815
              ],
              [
                51.445998724117,
                35.6702641867634
              ],
              [
                51.4460295158275,
                35.670678342499
              ],
              [
                51.4460641727233,
                35.6711444784666
              ],
              [
                51.4460720806328,
                35.6712500829283
              ],
              [
                51.4460787094002,
                35.6713392724512
              ],
              [
                51.4461114414496,
                35.6717796828219
              ],
              [
                51.4461118189578,
                35.6717847756607
              ],
              [
                51.446124661256,
                35.6719575994465
              ],
              [
                51.446168388449,
                35.6725987594875
              ],
              [
                51.4462223704534,
                35.6730820565899
              ],
              [
                51.4462286046786,
                35.6731654166667
              ],
              [
                51.4462328690379,
                35.6732224301612
              ],
              [
                51.4462344729126,
                35.6736130033509
              ],
              [
                51.446234779643,
                35.6736877603504
              ],
              [
                51.4462360765223,
                35.6740035224182
              ],
              [
                51.4462426440148,
                35.6742110507549
              ],
              [
                51.4462775989277,
                35.6746569390716
              ],
              [
                51.4463267086315,
                35.6748807942741
              ],
              [
                51.4463511173779,
                35.675222567508
              ],
              [
                51.4464131372155,
                35.6760896467124
              ],
              [
                51.4464205384049,
                35.6761727346242
              ],
              [
                51.4464567688186,
                35.6765794365921
              ],
              [
                51.4464895955626,
                35.676985644424
              ],
              [
                51.4465255027418,
                35.6774940680667
              ],
              [
                51.4465265644052,
                35.6775090925661
              ],
              [
                51.4465535466259,
                35.6778921671278
              ],
              [
                51.4465546119824,
                35.6779072574315
              ],
              [
                51.4465862303745,
                35.6783546229043
              ],
              [
                51.4466165080337,
                35.6787842175958
              ],
              [
                51.4465430855998,
                35.6788893715906
              ],
              [
                51.4466294904833,
                35.6789976312543
              ],
              [
                51.4466612132308,
                35.6796796987179
              ],
              [
                51.446685697637,
                35.6798788382797
              ],
              [
                51.4467141965276,
                35.6801106201065
              ],
              [
                51.4467329017894,
                35.6803948430071
              ],
              [
                51.4467633149298,
                35.680860335549
              ],
              [
                51.4467953319506,
                35.6813482276864
              ],
              [
                51.4468231276074,
                35.6816836439829
              ],
              [
                51.4467430220856,
                35.681780798323
              ],
              [
                51.4468308775326,
                35.6818534793513
              ],
              [
                51.4468426056848,
                35.6820393336957
              ],
              [
                51.4468439113645,
                35.6820600447783
              ],
              [
                51.4468622382609,
                35.6823127009817
              ],
              [
                51.4468627388235,
                35.682319628176
              ],
              [
                51.4468761312793,
                35.6824999060343
              ],
              [
                51.4468930746873,
                35.6827279707933
              ],
              [
                51.4468966316227,
                35.6827758505465
              ],
              [
                51.4469008862843,
                35.6828331146132
              ],
              [
                51.4469220648899,
                35.6831180909525
              ],
              [
                51.4469330041855,
                35.6832652645055
              ],
              [
                51.4469480780036,
                35.6834681535529
              ],
              [
                51.446948732187,
                35.6834768627039
              ],
              [
                51.4469690890008,
                35.6837479803465
              ],
              [
                51.4470616616548,
                35.6850162117532
              ],
              [
                51.4471112315712,
                35.6856953043557
              ],
              [
                51.4470373748991,
                35.68579711691
              ],
              [
                51.4471278913788,
                35.6858964490575
              ],
              [
                51.4471792674711,
                35.6865545944016
              ],
              [
                51.4472038804126,
                35.6868868159257
              ],
              [
                51.4472268235024,
                35.687197428791
              ],
              [
                51.4472273580977,
                35.6872031152051
              ],
              [
                51.4472345873734,
                35.6873494927436
              ],
              [
                51.4472479066681,
                35.6876527596665
              ],
              [
                51.4472637480286,
                35.6878599870304
              ],
              [
                51.4472817608346,
                35.6880956618376
              ],
              [
                51.4473056568035,
                35.6884877470959
              ],
              [
                51.4473282026371,
                35.6888576914463
              ],
              [
                51.4473285493698,
                35.6888627843807
              ],
              [
                51.447339414397,
                35.6892172703447
              ],
              [
                51.4473697303269,
                35.6892655852611
              ],
              [
                51.4473932191932,
                35.6892984210728
              ],
              [
                51.447411139598,
                35.689377094019
              ],
              [
                51.447455295321,
                35.6894294121156
              ],
              [
                51.4475200002326,
                35.6894959681203
              ],
              [
                51.4475728879965,
                35.6895410974561
              ],
              [
                51.4476374053939,
                35.689574255832
              ],
              [
                51.4477472114314,
                35.6896173575434
              ],
              [
                51.4478565588809,
                35.6896806186512
              ],
              [
                51.4479599420285,
                35.689730503598
              ],
              [
                51.44800852085,
                35.6897329204237
              ],
              [
                51.4481383687804,
                35.6897393814948
              ],
              [
                51.4498075695572,
                35.689816658132
              ],
              [
                51.4499962618811,
                35.6898723599491
              ],
              [
                51.4502219361039,
                35.6899005252721
              ],
              [
                51.4503932603671,
                35.6899143402813
              ],
              [
                51.4516286622213,
                35.6899772738938
              ],
              [
                51.4516637354532,
                35.6899810472765
              ],
              [
                51.4516824760785,
                35.6899848720127
              ],
              [
                51.4517043755122,
                35.6899910661036
              ],
              [
                51.4517233175182,
                35.6899980674289
              ],
              [
                51.4517421772876,
                35.6900067524069
              ],
              [
                51.4517567840866,
                35.6900148321174
              ],
              [
                51.4517780252367,
                35.6900291352384
              ],
              [
                51.4517869981825,
                35.6900369187135
              ],
              [
                51.4518005958978,
                35.6900487169294
              ],
              [
                51.4518166401035,
                35.69006670378
              ],
              [
                51.4518271231869,
                35.6900810256292
              ],
              [
                51.4518337842866,
                35.6900923828305
              ],
              [
                51.4518447961814,
                35.6901165935962
              ],
              [
                51.4518502485817,
                35.6901344894601
              ],
              [
                51.451854077223,
                35.6901568581033
              ],
              [
                51.4518458533292,
                35.6902258466859
              ],
              [
                51.4516858126105,
                35.6916891709595
              ],
              [
                51.4517095760936,
                35.6919596245092
              ],
              [
                51.4516723341624,
                35.6920653552389
              ],
              [
                51.4516343382555,
                35.6921732247497
              ],
              [
                51.4515932364958,
                35.6923001122939
              ],
              [
                51.451484358578,
                35.6923607424713
              ],
              [
                51.4513047597299,
                35.6924311490166
              ],
              [
                51.4509781922433,
                35.6923763554031
              ],
              [
                51.4507540395861,
                35.6923446983263
              ],
              [
                51.449891798336,
                35.6922957987053
              ],
              [
                51.4496598863272,
                35.6922785081381
              ],
              [
                51.4492065830936,
                35.6922448466413
              ],
              [
                51.4474951624419,
                35.6921311315123
              ],
              [
                51.4474567554703,
                35.6918515898733
              ],
              [
                51.4474094977227,
                35.6912466388488
              ],
              [
                51.4474045798496,
                35.6911843732899
              ],
              [
                51.4473604197778,
                35.6905198434379
              ],
              [
                51.4473351763566,
                35.6900792059323
              ],
              [
                51.4473025167019,
                35.6900262716453
              ],
              [
                51.4472845786001,
                35.6900010556278
              ],
              [
                51.4472718465661,
                35.6899844389671
              ],
              [
                51.4472389880385,
                35.6899455591416
              ],
              [
                51.4472110612738,
                35.6899162291068
              ],
              [
                51.4471637745143,
                35.6898726512568
              ],
              [
                51.4471211089022,
                35.6898386135257
              ],
              [
                51.4470479620579,
                35.6897894243425
              ],
              [
                51.4469282919212,
                35.6897282574465
              ],
              [
                51.446860513037,
                35.6897113176369
              ],
              [
                51.4467919296144,
                35.6896989412308
              ],
              [
                51.446610980813,
                35.6897245292753
              ],
              [
                51.4463343906034,
                35.6897831630685
              ],
              [
                51.4461288838063,
                35.6898337995203
              ],
              [
                51.4458446712905,
                35.6899452627265
              ],
              [
                51.4456404277546,
                35.6900627920744
              ],
              [
                51.4452703538219,
                35.6903194613348
              ],
              [
                51.4450031471936,
                35.6905492124033
              ],
              [
                51.4445023037921,
                35.6910214118131
              ],
              [
                51.4443554973152,
                35.6911587719652
              ],
              [
                51.4440430120233,
                35.691427309426
              ],
              [
                51.4439014548789,
                35.6915287412581
              ],
              [
                51.4437119670941,
                35.6916408707449
              ],
              [
                51.4435609013354,
                35.6917098685507
              ],
              [
                51.4433401034168,
                35.6917603014282
              ],
              [
                51.4431243241926,
                35.691802553854
              ],
              [
                51.4421154727611,
                35.6919052453056
              ],
              [
                51.4411884302162,
                35.6920071578596
              ],
              [
                51.440303342176,
                35.6921063672325
              ],
              [
                51.4397750980198,
                35.6921647205166
              ],
              [
                51.4390053020227,
                35.6922555331921
              ],
              [
                51.4390033326381,
                35.6922557657822
              ],
              [
                51.4384509088833,
                35.6923209312191
              ],
              [
                51.4375714241541,
                35.6924375448941
              ],
              [
                51.4375017815205,
                35.6924438885449
              ],
              [
                51.4374633773343,
                35.6924465193224
              ],
              [
                51.4374411837176,
                35.6924477044719
              ],
              [
                51.4374200628477,
                35.6924486044101
              ],
              [
                51.4373938153301,
                35.6924494147762
              ],
              [
                51.437357844634,
                35.6924499719404
              ],
              [
                51.437295551834,
                35.6924538741976
              ],
              [
                51.436867181664,
                35.6925071895459
              ],
              [
                51.436052621296,
                35.6925607641288
              ],
              [
                51.4355557158376,
                35.6926316975037
              ],
              [
                51.4338612484334,
                35.6928132155091
              ],
              [
                51.4338400545181,
                35.6928216743679
              ],
              [
                51.4338203152893,
                35.6928295527392
              ],
              [
                51.4337967920969,
                35.6928389414527
              ],
              [
                51.4337681129639,
                35.6928503882326
              ],
              [
                51.4337472973145,
                35.692858696041
              ],
              [
                51.4337316187629,
                35.6928661621466
              ],
              [
                51.4337121975082,
                35.6928754107372
              ],
              [
                51.433691522112,
                35.692890028555
              ],
              [
                51.4336707982682,
                35.6929046817075
              ],
              [
                51.4336461526667,
                35.6929298980815
              ],
              [
                51.4336322333877,
                35.6929507894526
              ],
              [
                51.433615804821,
                35.6929812147039
              ],
              [
                51.4336074503339,
                35.6930069746772
              ],
              [
                51.4336026645579,
                35.6930302531263
              ],
              [
                51.433609282691,
                35.6930635067312
              ],
              [
                51.4336190491427,
                35.6930815438686
              ],
              [
                51.4336289562744,
                35.6930998419718
              ],
              [
                51.4336380450706,
                35.6931166282798
              ],
              [
                51.4336507410278,
                35.6931400754746
              ],
              [
                51.433662729188,
                35.6931622169495
              ],
              [
                51.4336730471458,
                35.6931792251362
              ],
              [
                51.4336860360479,
                35.6932006362877
              ],
              [
                51.4336997297613,
                35.6932232071024
              ],
              [
                51.4337147517114,
                35.6932479686043
              ],
              [
                51.4337382504366,
                35.6932867037134
              ],
              [
                51.433780404257,
                35.6933567465936
              ],
              [
                51.4345207560795,
                35.6945942569926
              ],
              [
                51.4345213115511,
                35.6945951863734
              ],
              [
                51.435028404393,
                35.6954230302402
              ],
              [
                51.4353631568887,
                35.6959591132135
              ],
              [
                51.435450595968,
                35.6961140173514
              ],
              [
                51.4354507064495,
                35.6961142117042
              ],
              [
                51.4359319383028,
                35.6969667334348
              ],
              [
                51.4359341659842,
                35.6969706790217
              ],
              [
                51.4361083354027,
                35.697259263592
              ],
              [
                51.4365105997243,
                35.6979257737928
              ],
              [
                51.4365494104347,
                35.6981110093641
              ],
              [
                51.4366830796463,
                35.6982266672599
              ],
              [
                51.4369736629842,
                35.6987508760921
              ],
              [
                51.4373773641273,
                35.6994326642199
              ],
              [
                51.4379336864386,
                35.700368496479
              ],
              [
                51.4379955620834,
                35.7005509580098
              ],
              [
                51.4385105053571,
                35.7017996875148
              ],
              [
                51.4385302207559,
                35.7018474967891
              ],
              [
                51.4385629815836,
                35.7019269382266
              ],
              [
                51.4389592916379,
                35.7028879518612
              ],
              [
                51.4390831774713,
                35.7031280036399
              ],
              [
                51.4392071421801,
                35.703499395505
              ],
              [
                51.4392322360098,
                35.7035745747526
              ],
              [
                51.4393489721348,
                35.703876952272
              ],
              [
                51.4394524718159,
                35.7041338059818
              ],
              [
                51.4395981984483,
                35.7044954515364
              ],
              [
                51.4398376577881,
                35.7051203892777
              ],
              [
                51.4400067820303,
                35.7055674900209
              ],
              [
                51.4400895688307,
                35.7057651672909
              ],
              [
                51.4401857283707,
                35.7060042381145
              ],
              [
                51.4402353690139,
                35.7061276529081
              ],
              [
                51.4402885368675,
                35.7062598384551
              ],
              [
                51.4403321568977,
                35.7062585176394
              ],
              [
                51.4403756282281,
                35.7062596722118
              ],
              [
                51.4404163213426,
                35.7062630108218
              ],
              [
                51.4404591980189,
                35.7062693624246
              ],
              [
                51.4404953066758,
                35.70627774654
              ],
              [
                51.4405416980042,
                35.7062946380062
              ],
              [
                51.4405937241085,
                35.7063207159452
              ],
              [
                51.4406443957118,
                35.7063527087183
              ],
              [
                51.4406675529974,
                35.7063707900568
              ],
              [
                51.4406891146316,
                35.7063901411599
              ],
              [
                51.4407089640813,
                35.7064106772533
              ],
              [
                51.4407270124034,
                35.7064322852344
              ],
              [
                51.4407431606639,
                35.7064548704583
              ],
              [
                51.4407573482854,
                35.7064783213745
              ],
              [
                51.4407696632653,
                35.7065028396195
              ],
              [
                51.4407795358726,
                35.7065273537098
              ],
              [
                51.4407873417283,
                35.7065530272608
              ],
              [
                51.4407927117821,
                35.7065787768065
              ],
              [
                51.4407954581485,
                35.7066036718765
              ],
              [
                51.4407961893158,
                35.7066319521236
              ],
              [
                51.4407920048922,
                35.7066841051017
              ],
              [
                51.4407863221721,
                35.7067108826835
              ],
              [
                51.4407749161615,
                35.706745812505
              ],
              [
                51.4407591331184,
                35.7067798640755
              ],
              [
                51.4407445123977,
                35.7068058904278
              ],
              [
                51.4407274899043,
                35.7068307245833
              ],
              [
                51.4407099624683,
                35.7068521874878
              ],
              [
                51.4406900573761,
                35.706873144483
              ],
              [
                51.4406687111691,
                35.7068926506481
              ],
              [
                51.4406457508829,
                35.706910902865
              ],
              [
                51.4406212776002,
                35.706927802287
              ],
              [
                51.4405954352715,
                35.7069432662355
              ],
              [
                51.4405683278551,
                35.706957215488
              ],
              [
                51.440540084272,
                35.7069695998821
              ],
              [
                51.4405108506602,
                35.7069803408283
              ],
              [
                51.4404807795512,
                35.7069893967298
              ],
              [
                51.440448712606,
                35.7069970681137
              ],
              [
                51.440418673077,
                35.7070022684633
              ],
              [
                51.4403799804647,
                35.707005931607
              ],
              [
                51.4403406719697,
                35.7070064218515
              ],
              [
                51.4402909186471,
                35.7070049755223
              ],
              [
                51.4402597790334,
                35.7070015763138
              ],
              [
                51.4402277619367,
                35.7069961307345
              ],
              [
                51.4401969115976,
                35.7069890332228
              ],
              [
                51.4401667307682,
                35.7069802012469
              ],
              [
                51.4401373815755,
                35.7069696685463
              ],
              [
                51.4401090130422,
                35.7069575027976
              ],
              [
                51.4400817575299,
                35.7069437451608
              ],
              [
                51.4400557298732,
                35.7069284694844
              ],
              [
                51.4400310810018,
                35.7069117486609
              ],
              [
                51.4400079180065,
                35.7068936727628
              ],
              [
                51.4399863600732,
                35.7068743161383
              ],
              [
                51.4399665075248,
                35.7068537881668
              ],
              [
                51.4399481635529,
                35.7068318410281
              ],
              [
                51.439932306338,
                35.7068095890533
              ],
              [
                51.4399184983891,
                35.7067863825219
              ],
              [
                51.4399067460028,
                35.70676228379
              ],
              [
                51.4392040465031,
                35.7068961634467
              ],
              [
                51.4381989847196,
                35.707114729426
              ],
              [
                51.4381127120423,
                35.7071612484228
              ],
              [
                51.4380516476677,
                35.7072123406474
              ],
              [
                51.4380308162423,
                35.7072539257029
              ],
              [
                51.438013510206,
                35.7072983596985
              ],
              [
                51.4379864615602,
                35.7074142959415
              ],
              [
                51.4379750298949,
                35.7086263877367
              ],
              [
                51.4379691936072,
                35.7092561964315
              ],
              [
                51.4376986193277,
                35.7093084807537
              ],
              [
                51.4376520276149,
                35.7093173860742
              ],
              [
                51.4372448543429,
                35.7093961185239
              ],
              [
                51.4370619894326,
                35.7094313773486
              ],
              [
                51.4358799666457,
                35.7096774125119
              ],
              [
                51.4355535542537,
                35.7092002994625
              ],
              [
                51.4355123509443,
                35.7091399897797
              ],
              [
                51.435491192097,
                35.7091113494328
              ],
              [
                51.4351682156543,
                35.7086746916005
              ],
              [
                51.4351636517285,
                35.7086684940689
              ],
              [
                51.4347747106874,
                35.7081423966019
              ],
              [
                51.4346802017797,
                35.7080146938845
              ],
              [
                51.4344715470166,
                35.7077321190567
              ],
              [
                51.4341682301526,
                35.7073209432384
              ],
              [
                51.4340429966932,
                35.707200106739
              ],
              [
                51.4339484103897,
                35.7071935422163
              ],
              [
                51.4338627438185,
                35.7071914283714
              ],
              [
                51.4337443455194,
                35.707190687496
              ],
              [
                51.4335759679804,
                35.7071886307525
              ],
              [
                51.4334066510362,
                35.7071839606254
              ],
              [
                51.4331165297548,
                35.7071684240061
              ],
              [
                51.4328111932919,
                35.7071656020926
              ],
              [
                51.432692513472,
                35.7071653309438
              ],
              [
                51.4320591064596,
                35.7071518170301
              ],
              [
                51.4319652452674,
                35.7071513478735
              ],
              [
                51.4315168178503,
                35.7071436326686
              ],
              [
                51.431170291401,
                35.7071365443868
              ],
              [
                51.4308840257821,
                35.7071297028276
              ],
              [
                51.430721711988,
                35.7071258234329
              ],
              [
                51.4298574593412,
                35.7071051642267
              ],
              [
                51.4294730169735,
                35.7071021556064
              ],
              [
                51.4289499616084,
                35.7070917027895
              ],
              [
                51.4282877675395,
                35.707073034945
              ],
              [
                51.4277500865078,
                35.7070578746584
              ],
              [
                51.4276041229008,
                35.7070538346717
              ],
              [
                51.4271466912404,
                35.7070456861579
              ],
              [
                51.4263610260058,
                35.7070354378877
              ],
              [
                51.4257665901635,
                35.7070193905203
              ],
              [
                51.424913384398,
                35.7069983240223
              ],
              [
                51.424562418439,
                35.70699206549
              ],
              [
                51.4243612622196,
                35.7069884786203
              ],
              [
                51.4235457631445,
                35.7069714106625
              ],
              [
                51.4226031701565,
                35.7069500914071
              ],
              [
                51.4219472874313,
                35.7069404531404
              ],
              [
                51.4210426887732,
                35.7069236075114
              ],
              [
                51.4197676041594,
                35.7069022151115
              ],
              [
                51.419401316913,
                35.7068899576402
              ],
              [
                51.4190853848206,
                35.7068805622266
              ],
              [
                51.4184895239827,
                35.7068617104535
              ],
              [
                51.4183403870746,
                35.7068554937258
              ],
              [
                51.4177077704281,
                35.7068375096746
              ],
              [
                51.4175864088319,
                35.7068392787353
              ],
              [
                51.4171337276312,
                35.7068237977114
              ],
              [
                51.4167425097694,
                35.7068210784562
              ],
              [
                51.4160768804276,
                35.7067996720496
              ],
              [
                51.4154779634486,
                35.7067842863042
              ],
              [
                51.4153921651667,
                35.7067223131111
              ],
              [
                51.4152827179125,
                35.70678689773
              ],
              [
                51.4131380900452,
                35.7067311560263
              ],
              [
                51.4123475453765,
                35.706710607611
              ],
              [
                51.412240778367,
                35.706708587626
              ],
              [
                51.4121712615048,
                35.7067071730155
              ],
              [
                51.4109937868794,
                35.7066832092602
              ],
              [
                51.4107414599744,
                35.7066797013113
              ],
              [
                51.4101636486389,
                35.7066655551072
              ],
              [
                51.4096736458491,
                35.7066493103335
              ],
              [
                51.4092911448729,
                35.7066369645655
              ],
              [
                51.4087457454245,
                35.7066199243059
              ],
              [
                51.4085551219845,
                35.7066138868216
              ],
              [
                51.4084347501246,
                35.7066100739184
              ],
              [
                51.4083274175933,
                35.7066068027192
              ],
              [
                51.4083111680781,
                35.7066064827667
              ],
              [
                51.4082626815431,
                35.7066055265153
              ],
              [
                51.4080862496979,
                35.7066020485684
              ],
              [
                51.4078409193979,
                35.7065972124658
              ],
              [
                51.4077128149063,
                35.7065946873257
              ],
              [
                51.4075853162656,
                35.7065921735221
              ],
              [
                51.4074778868492,
                35.7065900550795
              ],
              [
                51.4073565177073,
                35.7065879314258
              ],
              [
                51.4072067860217,
                35.7065847089486
              ],
              [
                51.4069729326189,
                35.7065800973264
              ],
              [
                51.4067112611621,
                35.7065749363901
              ],
              [
                51.4065288225199,
                35.7065712573609
              ],
              [
                51.4062503247743,
                35.7065562298015
              ],
              [
                51.4060368990376,
                35.7064596188879
              ],
              [
                51.4058439180892,
                35.7065571455278
              ],
              [
                51.4049592852535,
                35.7065507581252
              ],
              [
                51.4038471141096,
                35.7065275641183
              ],
              [
                51.4038445155636,
                35.7065331151651
              ],
              [
                51.4038417640451,
                35.7065385828734
              ],
              [
                51.4038377351152,
                35.706545900507
              ],
              [
                51.4038347240795,
                35.7065512013824
              ],
              [
                51.4038313513543,
                35.7065564610946
              ],
              [
                51.4038266008872,
                35.7065634042668
              ],
              [
                51.403821588692,
                35.7065701806135
              ],
              [
                51.4038176509274,
                35.706575190666
              ],
              [
                51.4038135588664,
                35.7065800741059
              ],
              [
                51.4038093602653,
                35.7065848749531
              ],
              [
                51.4038049060912,
                35.7065896333792
              ],
              [
                51.4037988138208,
                35.7065957425348
              ],
              [
                51.4037939971195,
                35.7066002939
              ],
              [
                51.4037891795628,
                35.7066046757611
              ],
              [
                51.4037841548719,
                35.7066089753669
              ],
              [
                51.4037788741895,
                35.7066131496028
              ],
              [
                51.4037719028045,
                35.706618545811
              ],
              [
                51.4037646175362,
                35.7066237356965
              ],
              [
                51.403757024785,
                35.7066286732547
              ],
              [
                51.4037492764225,
                35.7066334427293
              ],
              [
                51.4037412694481,
                35.7066380056957
              ],
              [
                51.4037331561794,
                35.7066423156597
              ],
              [
                51.4037267897673,
                35.706645359283
              ],
              [
                51.4037205754859,
                35.7066483194457
              ],
              [
                51.4037141547348,
                35.7066511098922
              ],
              [
                51.4037076838387,
                35.7066538211631
              ],
              [
                51.4036988969078,
                35.7066571668356
              ],
              [
                51.4036899552666,
                35.7066603038478
              ],
              [
                51.4036832236171,
                35.7066623839484
              ],
              [
                51.4036763345687,
                35.7066643798231
              ],
              [
                51.403667133084,
                35.7066668468914
              ],
              [
                51.4036577764529,
                35.7066690187443
              ],
              [
                51.4036484163468,
                35.7066709399546
              ],
              [
                51.4036412681334,
                35.7066721811294
              ],
              [
                51.4036340662182,
                35.7066732953539
              ],
              [
                51.4036277086576,
                35.7066741488798
              ],
              [
                51.4036215128363,
                35.7066748512906
              ],
              [
                51.4036132657893,
                35.7066756507427
              ],
              [
                51.403603968679,
                35.7066762535533
              ],
              [
                51.4035942934213,
                35.7066766205022
              ],
              [
                51.4035870333726,
                35.7066767286982
              ],
              [
                51.4035765840017,
                35.7066765978359
              ],
              [
                51.4035693233542,
                35.7066763679211
              ],
              [
                51.4035620636724,
                35.7066758909557
              ],
              [
                51.403552486404,
                35.706675082747
              ],
              [
                51.4035452216976,
                35.706674266784
              ],
              [
                51.4035380118448,
                35.7066733676865
              ],
              [
                51.4035285326732,
                35.7066718441533
              ],
              [
                51.4035214226166,
                35.7066705669368
              ],
              [
                51.4035143623604,
                35.706669081276
              ],
              [
                51.4035049837152,
                35.7066668856886
              ],
              [
                51.403498023669,
                35.7066651039558
              ],
              [
                51.4034912197492,
                35.7066631539958
              ],
              [
                51.4034821454574,
                35.7066603704244
              ],
              [
                51.4034732242455,
                35.7066572527355
              ],
              [
                51.4034644058726,
                35.7066539219162
              ],
              [
                51.4034579058751,
                35.7066512983185
              ],
              [
                51.4034514569883,
                35.7066485068457
              ],
              [
                51.4034430477809,
                35.7066445471179
              ],
              [
                51.4034348395963,
                35.7066403342589
              ],
              [
                51.4034288004973,
                35.7066370373994
              ],
              [
                51.4034228127226,
                35.7066336150409
              ],
              [
                51.403416925111,
                35.7066301066913
              ],
              [
                51.403411245595,
                35.7066264326454
              ],
              [
                51.4034038091878,
                35.7066213759755
              ],
              [
                51.403396573817,
                35.7066160688794
              ],
              [
                51.403389547416,
                35.7066105501007
              ],
              [
                51.403380840986,
                35.7066031065595
              ],
              [
                51.4033747570875,
                35.7065974989662
              ],
              [
                51.4033678778037,
                35.7065906813441
              ],
              [
                51.4033633746922,
                35.706585950248
              ],
              [
                51.4033590792021,
                35.7065811787841
              ],
              [
                51.4033536393387,
                35.7065746051875
              ],
              [
                51.4033497009463,
                35.7065696215449
              ],
              [
                51.4033459204264,
                35.7065645967996
              ],
              [
                51.4033411994022,
                35.7065576430099
              ],
              [
                51.4033367377233,
                35.706550602696
              ],
              [
                51.40333351928,
                35.7065452397583
              ],
              [
                51.4033306090475,
                35.7065398352142
              ],
              [
                51.4033278022852,
                35.7065343428651
              ],
              [
                51.4033251489781,
                35.7065288103299
              ],
              [
                51.403322023874,
                35.7065213480813
              ],
              [
                51.4033191536976,
                35.7065138002249
              ],
              [
                51.4033165419787,
                35.7065062091257
              ],
              [
                51.403314340635,
                35.7064984489479
              ],
              [
                51.403312768273,
                35.7064926603335
              ],
              [
                51.4033115525332,
                35.7064867848691
              ],
              [
                51.4033101225798,
                35.7064789824347
              ],
              [
                51.4033090030294,
                35.7064711347801
              ],
              [
                51.4033085111414,
                35.7064652163167
              ],
              [
                51.4033079539855,
                35.7064568744869
              ],
              [
                51.4033078121635,
                35.7064493481433
              ],
              [
                51.4032148102919,
                35.7064222194911
              ],
              [
                51.4027317699518,
                35.70628131856
              ],
              [
                51.4017104270794,
                35.7059832775002
              ],
              [
                51.4007770383006,
                35.7057104591881
              ],
              [
                51.4003091596366,
                35.7055743884545
              ],
              [
                51.3989066642659,
                35.7052004009765
              ],
              [
                51.3987465550513,
                35.7050825481605
              ],
              [
                51.3985477585323,
                35.7051003826695
              ],
              [
                51.3970309512895,
                35.7046782511285
              ],
              [
                51.3970207579425,
                35.7046753030554
              ],
              [
                51.3970055894536,
                35.7046715364803
              ],
              [
                51.396998151042,
                35.7046697478332
              ],
              [
                51.3969891341134,
                35.704667964392
              ],
              [
                51.3969750280767,
                35.7046657865908
              ],
              [
                51.3969479925242,
                35.7046639543773
              ],
              [
                51.3969238061654,
                35.7046644570048
              ],
              [
                51.3969044776984,
                35.7046664322026
              ],
              [
                51.3968828176724,
                35.7046703698233
              ],
              [
                51.3968616948439,
                35.7046760845885
              ],
              [
                51.3968361004234,
                35.7046857830764
              ],
              [
                51.3968178638926,
                35.7046948532079
              ],
              [
                51.3968050424652,
                35.7047025124634
              ],
              [
                51.3967897318428,
                35.7047133392416
              ],
              [
                51.3967535680222,
                35.7047414685495
              ],
              [
                51.3965442151664,
                35.7052204858691
              ],
              [
                51.3963014279534,
                35.7057760802716
              ],
              [
                51.3960396249394,
                35.7063754974075
              ],
              [
                51.3958303967736,
                35.7068537195361
              ],
              [
                51.395722252893,
                35.707100271953
              ],
              [
                51.3955734500802,
                35.707442025026
              ],
              [
                51.395438767868,
                35.7077512294964
              ],
              [
                51.3952886106597,
                35.7080956671879
              ],
              [
                51.3952127690907,
                35.7082719760087
              ],
              [
                51.39496448429,
                35.7083443228584
              ],
              [
                51.3936119927041,
                35.7079815380046
              ],
              [
                51.3933084307279,
                35.7078963921008
              ],
              [
                51.39313981375,
                35.7078490961093
              ],
              [
                51.3927347316056,
                35.7077511732978
              ],
              [
                51.3924455277441,
                35.7077099365028
              ],
              [
                51.3921077375291,
                35.7076862245345
              ],
              [
                51.39180353189,
                35.7076872151963
              ],
              [
                51.3915485737753,
                35.7075774832135
              ],
              [
                51.3914538290421,
                35.7077156454609
              ],
              [
                51.3907320228642,
                35.7078930823381
              ],
              [
                51.3905260999438,
                35.7079339147505
              ],
              [
                51.3902158141522,
                35.7078847354126
              ],
              [
                51.3901743492765,
                35.707746603726
              ],
              [
                51.3902383219767,
                35.70733981544
              ],
              [
                51.390260333792,
                35.7071751394789
              ],
              [
                51.3902879840673,
                35.7069595859819
              ],
              [
                51.3903022995794,
                35.7068498010566
              ],
              [
                51.3903932921705,
                35.7061491048275
              ],
              [
                51.3903994448105,
                35.7061018934586
              ],
              [
                51.3904421091238,
                35.705773354579
              ],
              [
                51.3904809256544,
                35.7054744007778
              ],
              [
                51.390522195046,
                35.7051734463849
              ],
              [
                51.3905622633082,
                35.7048805816978
              ],
              [
                51.3905987489531,
                35.7046138470888
              ],
              [
                51.3906270810006,
                35.7044074301588
              ],
              [
                51.3906478788691,
                35.7042557198552
              ],
              [
                51.3906597568876,
                35.704173987119
              ],
              [
                51.3906803735889,
                35.7040318419065
              ],
              [
                51.3907682220394,
                35.7034270438845
              ],
              [
                51.3908593207745,
                35.7028001731452
              ],
              [
                51.3908959303757,
                35.7025220773894
              ]
            ]
          ]
        },
      },
      {
        dist: 11.87271906,
        source: "پایانه شهید براری",
        destination: "میدان ولی\u200cعصرعج",
        coor: {
          type: "MultiLineString",
          coordinates: [
            [
              [51.4915985538828, 35.6930979499128],
              [51.491583623772, 35.6930483725515],
              [51.491559162237, 35.6930453140319],
              [51.4913367280224, 35.6930152096628],
              [51.4912227824821, 35.6929987781442],
              [51.4911698633772, 35.6929594317516],
              [51.4911142726618, 35.6929253801005],
              [51.4910629284933, 35.6928995918125],
              [51.4910087493274, 35.6928772173167],
              [51.4909517351595, 35.6928582566096],
              [51.4908918859844, 35.6928427096872],
              [51.4903824874353, 35.6928252024799],
              [51.4901456929264, 35.6928074364064],
              [51.4898714231447, 35.6927899278656],
              [51.4893689998143, 35.692757852804],
              [51.4887668817729, 35.6927194101288],
              [51.4886190864501, 35.692654029735],
              [51.4884585179964, 35.6926975935578],
              [51.4865065426426, 35.6925442596845],
              [51.4850279808783, 35.6924162249459],
              [51.4849437628884, 35.6923632391251],
              [51.4848477406184, 35.6924022355201],
              [51.4840911268226, 35.6923502558323],
              [51.4829484473648, 35.6922633841655],
              [51.4804668302966, 35.6920812708394],
              [51.4799541955734, 35.6920397381956],
              [51.478853013963, 35.6919437116673],
              [51.4787264608293, 35.6918818329904],
              [51.478530609354, 35.6919274714201],
              [51.4762798482727, 35.6917581838914],
              [51.4758246834596, 35.6917322704454],
              [51.474929471544, 35.6916695276176],
              [51.4739495809972, 35.6916084757109],
              [51.4731758446813, 35.6915488245894],
              [51.4716263728396, 35.6914293520487],
              [51.4701586032445, 35.6913228575667],
              [51.4680378104226, 35.6911437313071],
              [51.4673438765804, 35.6910851118621],
              [51.4663756229884, 35.6910133498852],
              [51.465242163995, 35.6909066430324],
              [51.4650159651797, 35.6908328853834],
              [51.464750373472, 35.6908569188574],
              [51.4639457803163, 35.6907771399435],
              [51.4634667465064, 35.6907426512185],
              [51.4628850891106, 35.6906939406865],
              [51.4619782573496, 35.6906078632992],
              [51.4611656367935, 35.6905736253719],
              [51.4610608457502, 35.6905175025811],
              [51.4609374755579, 35.6905613786632],
              [51.4607157360212, 35.6905489879301],
              [51.4603633336591, 35.690529296522],
              [51.4595983992206, 35.6904834654093],
              [51.4593008362298, 35.6904699171105],
              [51.4584088477813, 35.6904142646848],
              [51.4578075980872, 35.6903918885675],
              [51.4572930545428, 35.6903670026689],
              [51.4572515419897, 35.6903649946345],
              [51.457028018766, 35.6903541835377],
              [51.4569755382948, 35.6903516454124],
              [51.4563141957042, 35.6903196531289],
              [51.4548492859467, 35.690216987654],
              [51.4531218521757, 35.6900895917454],
              [51.4521014521265, 35.690020976667],
              [51.4520682484541, 35.6900261369741],
              [51.4520399984083, 35.6900332640649],
              [51.4520267885398, 35.6900369319165],
              [51.4520149836162, 35.690041421288],
              [51.4519998359473, 35.6900471818875],
              [51.4519867969273, 35.6900521402302],
              [51.4519723734562, 35.690060106204],
              [51.4519585162976, 35.6900677589868],
              [51.4519466774758, 35.6900762327906],
              [51.4519289462012, 35.6900889231061],
              [51.4519191017086, 35.6900982730195],
              [51.4519073751582, 35.6901094098188],
              [51.4518961591239, 35.6901222938665],
              [51.4518884174333, 35.6901335284094],
              [51.4518756483702, 35.6901520615995],
              [51.451858088232, 35.6901886336898],
              [51.4518458533292, 35.6902258466859],
              [51.4516858126105, 35.6916891709595],
              [51.4517095760936, 35.6919596245092],
              [51.4516723341624, 35.6920653552389],
              [51.4516343382555, 35.6921732247497],
              [51.4515932364958, 35.6923001122939],
              [51.451484358578, 35.6923607424713],
              [51.4513047597299, 35.6924311490166],
              [51.4509781922433, 35.6923763554031],
              [51.4507540395861, 35.6923446983263],
              [51.449891798336, 35.6922957987053],
              [51.4496598863272, 35.6922785081381],
              [51.4492065830936, 35.6922448466413],
              [51.4474951624419, 35.6921311315123],
              [51.4474567554703, 35.6918515898733],
              [51.4474094977227, 35.6912466388488],
              [51.4474045798496, 35.6911843732899],
              [51.4473604197778, 35.6905198434379],
              [51.4473351763566, 35.6900792059323],
              [51.4473025167019, 35.6900262716453],
              [51.4472845786001, 35.6900010556278],
              [51.4472718465661, 35.6899844389671],
              [51.4472389880385, 35.6899455591416],
              [51.4472110612738, 35.6899162291068],
              [51.4471637745143, 35.6898726512568],
              [51.4471211089022, 35.6898386135257],
              [51.4470479620579, 35.6897894243425],
              [51.4469282919212, 35.6897282574465],
              [51.446860513037, 35.6897113176369],
              [51.4467919296144, 35.6896989412308],
              [51.446610980813, 35.6897245292753],
              [51.4463343906034, 35.6897831630685],
              [51.4461288838063, 35.6898337995203],
              [51.4458446712905, 35.6899452627265],
              [51.4456404277546, 35.6900627920744],
              [51.4452703538219, 35.6903194613348],
              [51.4450031471936, 35.6905492124033],
              [51.4445023037921, 35.6910214118131],
              [51.4443554973152, 35.6911587719652],
              [51.4440430120233, 35.691427309426],
              [51.4439014548789, 35.6915287412581],
              [51.4437119670941, 35.6916408707449],
              [51.4435609013354, 35.6917098685507],
              [51.4433401034168, 35.6917603014282],
              [51.4431243241926, 35.691802553854],
              [51.4421154727611, 35.6919052453056],
              [51.4411884302162, 35.6920071578596],
              [51.440303342176, 35.6921063672325],
              [51.4397750980198, 35.6921647205166],
              [51.4390053020227, 35.6922555331921],
              [51.4390033326381, 35.6922557657822],
              [51.4384509088833, 35.6923209312191],
              [51.4375714241541, 35.6924375448941],
              [51.4375017815205, 35.6924438885449],
              [51.4374633773343, 35.6924465193224],
              [51.4374411837176, 35.6924477044719],
              [51.4374200628477, 35.6924486044101],
              [51.4373938153301, 35.6924494147762],
              [51.437357844634, 35.6924499719404],
              [51.437295551834, 35.6924538741976],
              [51.436867181664, 35.6925071895459],
              [51.436052621296, 35.6925607641288],
              [51.4355557158376, 35.6926316975037],
              [51.4338612484334, 35.6928132155091],
              [51.4337375089524, 35.6928031339581],
              [51.4336538990541, 35.6927873148988],
              [51.4335783481425, 35.6927630166572],
              [51.4335247860532, 35.6927390728663],
              [51.4334607868695, 35.6927014068227],
              [51.4334062996456, 35.6926590558794],
              [51.4333801681027, 35.6926341305632],
              [51.4332806089089, 35.6925251975819],
              [51.433229780852, 35.6924512726471],
              [51.4329745987406, 35.6916286982809],
              [51.4327503989498, 35.6910006400914],
              [51.432684494537, 35.690702172411],
              [51.4326311373715, 35.690683371445],
              [51.4325772123797, 35.6906683727715],
              [51.4325227195543, 35.6906571763899],
              [51.4324676588877, 35.6906497822994],
              [51.4324121433715, 35.6906461939239],
              [51.4323560622917, 35.6906463924846],
              [51.4322994156401, 35.6906503779807],
              [51.4322422034086, 35.6906581504115],
              [51.4321717453073, 35.6906999012165],
              [51.4320985659259, 35.6907378799064],
              [51.4320133476939, 35.6907759487149],
              [51.4319247138138, 35.6908092828684],
              [51.4311700147529, 35.6910070989245],
              [51.4306146331796, 35.6910605349051],
              [51.4304063311328, 35.6910702258352],
              [51.4302674954681, 35.6910826498386],
              [51.4300752752694, 35.6911375789382],
              [51.4291008595858, 35.6914905740965],
              [51.4288300222004, 35.6915907791977],
              [51.4287141650617, 35.6915636650107],
              [51.4286524297371, 35.6916653077079],
              [51.4280525544717, 35.6918804484537],
              [51.4279667342725, 35.6919093804207],
              [51.4278651848266, 35.6919498189682],
              [51.4277251193571, 35.6920061394985],
              [51.4266095684384, 35.6924037174541],
              [51.4257830370386, 35.692711520879],
              [51.425677953516, 35.6927476756069],
              [51.4255494861599, 35.6928015506458],
              [51.4247551039344, 35.6930915956288],
              [51.4246237155124, 35.6931307058358],
              [51.4244550755151, 35.6931010381797],
              [51.4244253756394, 35.6932102774079],
              [51.4242712906691, 35.693263444359],
              [51.4238965547369, 35.6934036772483],
              [51.4231084922041, 35.6936986670349],
              [51.4225471791068, 35.6938885794425],
              [51.4215112551746, 35.6942425928789],
              [51.4205525204868, 35.6945675512604],
              [51.4199284326206, 35.6947774733198],
              [51.4197741579879, 35.694760794727],
              [51.4196129570448, 35.6948224811274],
              [51.417469866318, 35.6949181987231],
              [51.4171823835182, 35.6949307398824],
              [51.4166292866533, 35.6949545083169],
              [51.4161965931222, 35.6949774756899],
              [51.4160898850669, 35.6949838088806],
              [51.415191025086, 35.6950238767291],
              [51.4142880021346, 35.6950687389634],
              [51.4133708136348, 35.6951064913206],
              [51.4132348792723, 35.6951165000192],
              [51.4131471669056, 35.6951203796713],
              [51.4130345981049, 35.6951243445493],
              [51.4126442989528, 35.6951459599262],
              [51.4124970328446, 35.6951512180647],
              [51.4120054408088, 35.6951708116454],
              [51.4118936078498, 35.6951117668411],
              [51.4117195995239, 35.6951209465673],
              [51.411719087026, 35.6951214460215],
              [51.4116487600645, 35.6951899239085],
              [51.4104895284785, 35.6952487504913],
              [51.4101503870777, 35.6952666056448],
              [51.409934014037, 35.6952733060839],
              [51.4097950973943, 35.6952810417282],
              [51.4091794224679, 35.6953302518121],
              [51.4088727920391, 35.6953462626196],
              [51.4088107609697, 35.6953493323777],
            ],
            [
              [51.4088105012901, 35.6953493449808],
              [51.4084971358405, 35.6953631263273],
              [51.4083359204908, 35.6953714706255],
              [51.407058737432, 35.6954176239193],
              [51.406779565399, 35.6954291329664],
              [51.405775237465, 35.6954847794826],
              [51.4041565579894, 35.6955642941521],
              [51.4040513487811, 35.6955696793548],
              [51.4026957848228, 35.6956460449657],
              [51.4019472747775, 35.6956812245314],
              [51.4002995566152, 35.6957735694726],
              [51.3996462335486, 35.6958071495637],
              [51.3988517967374, 35.6958525994175],
              [51.3988516133278, 35.6958526135497],
              [51.3986903616308, 35.6958631720891],
              [51.3985905880516, 35.6958673335425],
              [51.3978973080958, 35.6959020607],
              [51.3977533240169, 35.6959094475667],
              [51.3976042193914, 35.6959171261728],
              [51.3976860273352, 35.6965093397827],
              [51.397688908595, 35.6965299866772],
              [51.3977351426003, 35.6968645453498],
              [51.3977769986181, 35.6971667876974],
              [51.397854207799, 35.6976858054729],
              [51.3978613099291, 35.6977323946153],
              [51.3979431355305, 35.6982835537567],
              [51.3979977650087, 35.6986502421024],
              [51.3980142293012, 35.698761954056],
              [51.39809254622, 35.6992859286517],
              [51.398152588344, 35.6997060865101],
              [51.3982080519582, 35.7000945228916],
              [51.3982565642097, 35.7004351118486],
              [51.3982978859328, 35.7010994223047],
              [51.3977359446518, 35.7024927929803],
              [51.3974276182523, 35.7032041153977],
              [51.3972602864461, 35.7035901776986],
              [51.3971510525974, 35.7038380857473],
              [51.396893986234, 35.7044213491527],
              [51.3967535680222, 35.7047414685495],
              [51.3965442151664, 35.7052204858691],
              [51.3963014279534, 35.7057760802716],
              [51.3960396249394, 35.7063754974075],
              [51.3958303967736, 35.7068537195361],
              [51.395722252893, 35.707100271953],
              [51.3955734500802, 35.707442025026],
              [51.395438767868, 35.7077512294964],
              [51.3952886106597, 35.7080956671879],
              [51.3952127690907, 35.7082719760087],
              [51.3954761712537, 35.7081939104187],
              [51.3971008954624, 35.7086484063849],
              [51.3971740278324, 35.7088435206159],
              [51.3973730829189, 35.7087335218563],
              [51.3986769631946, 35.7091030424097],
              [51.3987243753558, 35.7092862085978],
              [51.3989612227994, 35.7091682648746],
              [51.4019163776649, 35.709987807953],
              [51.4040713434043, 35.7106333126321],
              [51.4042662504461, 35.7108520140368],
              [51.4046717301384, 35.7107747088139],
              [51.4054593134266, 35.7109924707494],
            ],
          ],
        },
      },
    ],
  },
  {
    title: "SCHOOL", //OK
    id: 401,
    value: [
      {
        name: "دانشگاه علوم پزشکی و خدمات بهداشتی درمانی تهران",
        dist: 50.2021738736061,
        lon: 51.3951856996604,
        lat: 35.707910100171,
      },
      {
        name: "مدرسه سعیدی",
        dist: 295.373464975109,
        lon: 51.3960583001505,
        lat: 35.7102758999129,
      },
      {
        name: "مدرسه نرجس",
        dist: 439.047526487466,
        lon: 51.4003769003737,
        lat: 35.706827200415,
      },
    ],
  },
  {
    title: "PARK", //OK
    id: 403,
    value: [
      {
        name: "بوستان لاله",
        dist: 424.865538525265,
        lon: 51.3928453669202,
        lat: 35.7107211902308,
      },
      {
        name: null,
        dist: 955.434488595044,
        lon: 51.4044202172193,
        lat: 35.7124046365648,
      },
      {
        name: "بوستان اقاقیا",
        dist: 1213.37806974252,
        lon: 51.3851997265862,
        lat: 35.7145114153696,
      },
    ],
  },
  {
    title: "PHARMACY", //OK
    id: 404,
    value: [
      {
        name: "داروخانه",
        dist: 292.879967258113,
        lon: 51.3984567,
        lat: 35.7089196,
      },
      {
        name: "داروخانه دکتر غفوری",
        dist: 534.159992641765,
        lon: 51.4010259,
        lat: 35.709585,
      },
      {
        name: "داروخانه فرانس پاستور",
        dist: 723.319057463895,
        lon: 51.4035392,
        lat: 35.7067076,
      },
    ],
  },
  {
    title: "GYM", //OK
    id: 405,
    value: [
      {
        name: "فدراسیون شطرنج",
        dist: 496.881962466303,
        lon: 51.3950676,
        lat: 35.7120919,
      },
      {
        name: "مجموعه فرهنگی و ورزشی شهرد خت",
        dist: 532.096451433996,
        lon: 51.3900626,
        lat: 35.7060899,
      },
      {
        name: "باشگاه اندیشه",
        dist: 754.207657121102,
        lon: 51.4004817,
        lat: 35.7021113,
      },
    ],
  },
  {
    title: "POOL", //OK
    id: 406,
    value: [
      {
        name: "استخر سازمان آب",
        dist: 819.498250804448,
        lon: 51.3942338724952,
        lat: 35.7149349079197,
      },
      {
        name: "استخر آریان",
        dist: 1608.38769071063,
        lon: 51.378342600131,
        lat: 35.7110110003574,
      },
      {
        name: null,
        dist: 1721.05027107105,
        lon: 51.4107965957863,
        lat: 35.698281378283,
      },
    ],
  },
  {
    title: "SHOP", //OK
    id: 407,
    value: [
      {
        name: "سوپر مارکت یاس",
        dist: 381.425046979719,
        lon: 51.3982974,
        lat: 35.7102974,
      },
      {
        name: "سوپر مارکت زنجیره\u200cای جانبو",
        dist: 388.668086323266,
        lon: 51.3981237,
        lat: 35.7104879,
      },
      {
        name: "دامداران",
        dist: 401.108771444689,
        lon: 51.3985182,
        lat: 35.7048962,
      },
    ],
  },
  {
    title: "HOTEL", //OK
    id: 409,
    value: [
      {
        name: "هتل",
        dist: 191.910233449935,
        lon: 51.3935117,
        lat: 35.7075261,
      },
      {
        name: "رستوران هتل",
        dist: 199.568297975788,
        lon: 51.3934324,
        lat: 35.7074686,
      },
      {
        name: "هتل امید",
        dist: 501.713593544614,
        lon: 51.3907651,
        lat: 35.7054655,
      },
    ],
  },
  {
    title: "ZOO", //OK
    id: 410,
    value: [
      {
        name: "باغ پرندگان",
        dist: 3181.59287283162,
        lon: 51.4148274,
        lat: 35.6836168,
      },
    ],
  },
  {
    title: "POLICE", //OK
    id: 501,
    value: [
      {
        name: "کلانتری ۱۰۷ فلسطین",
        dist: 1156.1600950492,
        lon: 51.4082983,
        lat: 35.7063006,
      },
    ],
  },
  {
    title: "FIRE", //OK
    id: 502,
    value: [
      {
        name: "ایستگاه آتش نشانی",
        dist: 237.099035002903,
        lon: 51.3930940627408,
        lat: 35.7081802762988,
      },
    ],
  },
  {
    title: "HOSPITAL", //OK
    id: 503,
    value: [
      {
        name: "  بیمارستان آریا ",
        dist: 224.056643756833,
        lon: 51.3978047610809,
        lat: 35.7085992209773,
      },
      {
        name: "  بیمارستان یاس سپید ",
        dist: 355.852050411772,
        lon: 51.3977517496436,
        lat: 35.7103362498181,
      },
      {
        name: "  بیمارستان پارس ",
        dist: 451.469396670681,
        lon: 51.3994320294647,
        lat: 35.7102696352355,
      },
    ],
  },
  {
    title: "BOHRAN", //OK
    id: 505,
    value: [
      {
        dist: 109.62876742,
        name: "پارکینگ دانشگاه تهران",
        lon: 51.3946654344878,
        lat: 35.707036076301,
      },
      {
        dist: 266.79809634,
        name: "مدرسه آیت ا.. سعیدی",
        lon: 51.3961634240458,
        lat: 35.7099966519837,
      },
      {
        dist: 327.40356663,
        name: "دانشگاه تهران",
        lon: 51.3929148349182,
        lat: 35.7056836083231,
      },
    ],
  },
  // {
  //   title: "ALUDEGI", //not recieved from back!...
  //   id: 601,
  //   value: [
  //     {
  //       name: "پمپ بنزین وصال",
  //       dist: 51.4006007254432,
  //       lon: 35.7013851913736,
  //       lat: 830.382521518651,
  //     },
  //
  //   ],
  // },
];

// ===================================================================================

const dataAliD6 = [
  {
    title: "TAXI",
    id: "304",
    value: [
      {
        dist: 709.8843949,
        name: "ایستگاه تاکسی انقلاب - ونک",
        lon: 51.3905766,
        lat: 35.702745,
      },
      {
        dist: 1631.71314208,
        name: "فاطمی - میدان صنعت",
        lon: 51.4040623,
        lat: 35.7206154,
      },
      {
        dist: 1882.49508732,
        name: null,
        lon: 51.4144708,
        lat: 35.7148848,
      },
    ],
  },
  {
    title: "METRO",
    id: "301",
    value: [
      {
        dist: 814.30398048,
        name: "میدان انقلاب اسلامی",
        lon: 51.3919374,
        lat: 35.7009551,
      },
      {
        dist: 1115.29908649,
        name: "تئاترشهر",
        lon: 51.4052124,
        lat: 35.7013101,
      },
      {
        dist: 1118.95684593,
        name: "میدان ولیعصر",
        lon: 51.4070144,
        lat: 35.7116098,
      },
    ],
  },
  {
    title: "BOHRAN",
    id: "505",
    value: [
      {
        dist: 109.62876742,
        name: "پارکینگ دانشگاه تهران",
        lon: 51.3946654344878,
        lat: 35.707036076301,
      },
      {
        dist: 266.79809634,
        name: "مدرسه آیت ا.. سعیدی",
        lon: 51.3961634240458,
        lat: 35.7099966519837,
      },
      {
        dist: 327.40356663,
        name: "دانشگاه تهران",
        lon: 51.3929148349182,
        lat: 35.7056836083231,
      },
    ],
  },
  {
    title: "BUS",
    id: "303",
    value: [
      {
        dist: 147.52322371,
        name: "حجاب",
        lon: 51.3964539238761,
        lat: 35.7087817175608,
      },
      {
        dist: 227.98206653,
        name: "شانزده آذر",
        lon: 51.3931064809238,
        lat: 35.7075298876606,
      },
      {
        dist: 250.9005902,
        name: "وصال",
        lon: 51.3979363825078,
        lat: 35.7088931636335,
      },
    ],
  },
  {
    title: "BUSLINE",
    id: "305",
    value: [
      {
        dist: 11.87271906,
        source: "پایانه شهید براری",
        destination: "میدان ولی\u200cعصرعج",
        coor: {
          type: "MultiLineString",
          coordinates: [
            [
              [51.4915985538828, 35.6930979499128],
              [51.491583623772, 35.6930483725515],
              [51.491559162237, 35.6930453140319],
              [51.4913367280224, 35.6930152096628],
              [51.4912227824821, 35.6929987781442],
              [51.4911698633377, 35.6929594317273],
              [51.4911142726618, 35.6929253801005],
              [51.4910629284933, 35.6928995918125],
              [51.4910087493274, 35.6928772173167],
              [51.4909517351595, 35.6928582566096],
              [51.4908918859844, 35.6928427096872],
              [51.4903824874353, 35.6928252024799],
              [51.4901456929264, 35.6928074364064],
              [51.4898714231447, 35.6927899278656],
              [51.4893689998143, 35.692757852804],
              [51.4887668817729, 35.6927194101288],
              [51.4886190864501, 35.692654029735],
              [51.4884585179964, 35.6926975935578],
              [51.4865065426426, 35.6925442596845],
              [51.4850279808783, 35.6924162249459],
              [51.4849437628884, 35.6923632391251],
              [51.4848477406184, 35.6924022355201],
              [51.4840911268226, 35.6923502558323],
              [51.4829484473648, 35.6922633841655],
              [51.4804668302966, 35.6920812708394],
              [51.4799541955734, 35.6920397381956],
              [51.478853013963, 35.6919437116673],
              [51.4787264608293, 35.6918818329904],
              [51.478530609354, 35.6919274714201],
              [51.4762798482727, 35.6917581838914],
              [51.4758246834596, 35.6917322704454],
              [51.474929471544, 35.6916695276176],
              [51.4739495809972, 35.6916084757109],
              [51.4731758446813, 35.6915488245894],
              [51.4716263728396, 35.6914293520487],
              [51.4701586032445, 35.6913228575667],
              [51.4680378104226, 35.6911437313071],
              [51.4673438765804, 35.6910851118621],
              [51.4663756229884, 35.6910133498852],
              [51.465242163995, 35.6909066430324],
              [51.4650159651797, 35.6908328853834],
              [51.464750373472, 35.6908569188574],
              [51.4639457803163, 35.6907771399435],
              [51.4634667465064, 35.6907426512185],
              [51.4628850891106, 35.6906939406865],
              [51.4619782573496, 35.6906078632992],
              [51.4611656367935, 35.6905736253719],
              [51.4610608457502, 35.6905175025811],
              [51.4609374755579, 35.6905613786632],
              [51.4607157360212, 35.6905489879301],
              [51.4603633336591, 35.690529296522],
              [51.4595983992206, 35.6904834654093],
              [51.4593008362298, 35.6904699171105],
              [51.4584088477813, 35.6904142646848],
              [51.4578075980872, 35.6903918885675],
              [51.4572930545428, 35.6903670026689],
              [51.4572515419897, 35.6903649946345],
              [51.457028018766, 35.6903541835377],
              [51.4569755382948, 35.6903516454124],
              [51.4563141957042, 35.6903196531289],
              [51.4548492859467, 35.690216987654],
              [51.4531218521757, 35.6900895917454],
              [51.4521014521265, 35.690020976667],
              [51.4520682484541, 35.6900261369741],
              [51.4520399984083, 35.6900332640649],
              [51.4520267885398, 35.6900369319165],
              [51.4520149836162, 35.690041421288],
              [51.4519998359473, 35.6900471818875],
              [51.4519867969273, 35.6900521402302],
              [51.4519723734562, 35.690060106204],
              [51.4519585162976, 35.6900677589868],
              [51.4519466774758, 35.6900762327906],
              [51.4519289462012, 35.6900889231061],
              [51.4519191017086, 35.6900982730195],
              [51.4519073751582, 35.6901094098188],
              [51.4518961591239, 35.6901222938665],
              [51.4518884174333, 35.6901335284094],
              [51.4518756483702, 35.6901520615995],
              [51.451858088232, 35.6901886336898],
              [51.4518458533292, 35.6902258466859],
              [51.4516858126105, 35.6916891709595],
              [51.4516543177956, 35.6919767879309],
              [51.4516087228761, 35.6923933712707],
              [51.4507540395861, 35.6923446983263],
              [51.449891798336, 35.6922957987053],
              [51.4496598863272, 35.6922785081381],
              [51.4492065830936, 35.6922448466413],
              [51.4474951624419, 35.6921311315123],
              [51.4474567554703, 35.6918515898733],
              [51.4474094977227, 35.6912466388488],
              [51.4474045798496, 35.6911843732899],
              [51.4473604197778, 35.6905198434379],
              [51.4473351763566, 35.6900792059323],
              [51.4473025167019, 35.6900262716453],
              [51.4472845786001, 35.6900010556278],
              [51.4472718465661, 35.6899844389671],
              [51.4472389880385, 35.6899455591416],
              [51.4472110612738, 35.6899162291068],
              [51.4471637745143, 35.6898726512568],
              [51.4471211089022, 35.6898386135257],
              [51.4470479620579, 35.6897894243425],
              [51.4469282919212, 35.6897282574465],
              [51.446860513037, 35.6897113176369],
              [51.4467919296144, 35.6896989412308],
              [51.446610980813, 35.6897245292753],
              [51.4463343906034, 35.6897831630685],
              [51.4461288838063, 35.6898337995203],
              [51.4458446712905, 35.6899452627265],
              [51.4456404277546, 35.6900627920744],
              [51.4452703538219, 35.6903194613348],
              [51.4450031471936, 35.6905492124033],
              [51.4445023037921, 35.6910214118131],
              [51.4443554973152, 35.6911587719652],
              [51.4440430120233, 35.691427309426],
              [51.4439014548789, 35.6915287412581],
              [51.4437119670941, 35.6916408707449],
              [51.4435609013354, 35.6917098685507],
              [51.4433401034168, 35.6917603014282],
              [51.4431243241926, 35.691802553854],
              [51.4421154727611, 35.6919052453056],
              [51.4411884302162, 35.6920071578596],
              [51.440303342176, 35.6921063672325],
              [51.4397750980198, 35.6921647205166],
              [51.4390053020227, 35.6922555331921],
              [51.4390033326381, 35.6922557657822],
              [51.4384509088833, 35.6923209312191],
              [51.4375714241541, 35.6924375448941],
              [51.4375017815205, 35.6924438885449],
              [51.4374633773343, 35.6924465193224],
              [51.4374411837176, 35.6924477044719],
              [51.4374200628477, 35.6924486044101],
              [51.4373938153301, 35.6924494147762],
              [51.437357844634, 35.6924499719404],
              [51.437295551834, 35.6924538741976],
              [51.437200514877, 35.692457379615],
              [51.4371580829399, 35.6924583541988],
              [51.4371208242999, 35.692458852855],
              [51.4370535766455, 35.6924589076816],
              [51.4369899000955, 35.6924579559086],
              [51.4369328378142, 35.6924562741167],
              [51.4368899078417, 35.6924544914191],
              [51.4368228343565, 35.6924508127273],
              [51.436052621296, 35.6925607641288],
              [51.4355557158376, 35.6926316975037],
              [51.4338612484334, 35.6928132155091],
              [51.4337375089524, 35.6928031339581],
              [51.4336538990541, 35.6927873148988],
              [51.4335783481425, 35.6927630166572],
              [51.4335247860532, 35.6927390728663],
              [51.4334607868695, 35.6927014068227],
              [51.4334062996456, 35.6926590558794],
              [51.4333801681027, 35.6926341305632],
              [51.4332806089089, 35.6925251975819],
              [51.433229780852, 35.6924512726471],
              [51.4329745987406, 35.6916286982809],
              [51.4327503989498, 35.6910006400914],
              [51.432684494537, 35.690702172411],
              [51.4326311373715, 35.690683371445],
              [51.4325772123797, 35.6906683727715],
              [51.4325227195543, 35.6906571763899],
              [51.4324676588877, 35.6906497822994],
              [51.4324121433715, 35.6906461939239],
              [51.4323560622917, 35.6906463924846],
              [51.4322994156401, 35.6906503779807],
              [51.4322422034086, 35.6906581504115],
              [51.4321717453073, 35.6906999012165],
              [51.4320985659259, 35.6907378799064],
              [51.4320133476939, 35.6907759487149],
              [51.4319247138138, 35.6908092828684],
              [51.4311700147529, 35.6910070989245],
              [51.4306146331796, 35.6910605349051],
              [51.4304063311328, 35.6910702258352],
              [51.4302674954681, 35.6910826498386],
              [51.4300752752694, 35.6911375789382],
              [51.4295324455923, 35.6913399057892],
              [51.4290888586344, 35.6915084773149],
              [51.4285926836134, 35.6916867773282],
              [51.4282541229405, 35.6918096467368],
              [51.4277421920316, 35.6919951564585],
              [51.4271818127004, 35.6921989659681],
              [51.4259799362519, 35.6926416934086],
              [51.4245615025284, 35.6931684521189],
              [51.4244756908116, 35.6932003190888],
              [51.4244325025347, 35.6932163572343],
              [51.4236893774202, 35.6934837737245],
              [51.4226829406935, 35.6938403767042],
              [51.4215298844908, 35.6942337457446],
              [51.4208525932424, 35.6944555882202],
              [51.4197686865668, 35.6948413160661],
              [51.4197569429184, 35.694841740211],
              [51.4197049413206, 35.6948436165998],
              [51.4195129496788, 35.694850544075],
              [51.4185414241212, 35.6949012571216],
              [51.417265522945, 35.6949610314931],
              [51.4156909806471, 35.6950437724437],
              [51.4147114042616, 35.6950862739293],
              [51.4142883200037, 35.6951056227607],
              [51.4135805547243, 35.6951245167358],
              [51.413174070896, 35.6951474048359],
              [51.4120754988687, 35.6952091184443],
              [51.4108598535323, 35.6952733901016],
              [51.4104966978841, 35.695284647995],
              [51.410157998821, 35.6952894081505],
              [51.4095792637045, 35.6953335769028],
              [51.4091249256862, 35.6953565916088],
              [51.4078512932369, 35.6954052856503],
              [51.4067075947456, 35.695472134288],
              [51.4054726619617, 35.6955407103025],
              [51.4044727243912, 35.6955841528124],
              [51.4031728525622, 35.6956500607408],
              [51.4017712302307, 35.695720588766],
              [51.4000608958002, 35.6958135974471],
              [51.3995609029051, 35.6958310033231],
              [51.3984645806394, 35.6959004790964],
              [51.3976096147884, 35.6959561779192],
              [51.3976860273352, 35.6965093397827],
              [51.397688908595, 35.6965299866772],
              [51.3977351426003, 35.6968645453498],
              [51.3977769986181, 35.6971667876974],
              [51.397854207799, 35.6976858054729],
              [51.3978613099291, 35.6977323946153],
              [51.3979431355305, 35.6982835537567],
              [51.3979977650087, 35.6986502421024],
              [51.3980142293012, 35.698761954056],
              [51.39809254622, 35.6992859286517],
              [51.398152588344, 35.6997060865101],
              [51.3982080519582, 35.7000945228916],
              [51.3982565642097, 35.7004351118486],
              [51.3982978859328, 35.7010994223047],
              [51.3977359446518, 35.7024927929803],
              [51.3974276182523, 35.7032041153977],
              [51.3972602864461, 35.7035901776986],
              [51.3971510525974, 35.7038380857473],
              [51.396893986234, 35.7044213491527],
              [51.3967535680222, 35.7047414685495],
              [51.3965442151664, 35.7052204858691],
              [51.3963014279534, 35.7057760802716],
              [51.3960396249394, 35.7063754974075],
              [51.3958303967736, 35.7068537195361],
              [51.395722252893, 35.707100271953],
              [51.3955734500802, 35.707442025026],
              [51.395438767868, 35.7077512294964],
              [51.3952886106597, 35.7080956671879],
              [51.3952127690907, 35.7082719760087],
              [51.3954761712537, 35.7081939104187],
              [51.3971008954624, 35.7086484063849],
              [51.3971740278324, 35.7088435206159],
              [51.3973730829189, 35.7087335218563],
              [51.3986769631946, 35.7091030424097],
              [51.3987243753558, 35.7092862085978],
              [51.3989612227994, 35.7091682648746],
              [51.4019163776649, 35.709987807953],
              [51.4040713434043, 35.7106333126321],
              [51.4042662504461, 35.7108520140368],
              [51.4046717301384, 35.7107747088139],
              [51.4054593134266, 35.7109924707494],
            ],
          ],
        },
      },
      {
        dist: 11.87271906,
        source: "میدان خراسان",
        destination: "میدان انقلاب اسلامی",
        coor: {
          type: "MultiLineString",
          coordinates: [
            [
              [51.4456401031146, 35.6664225376785],
              [51.4456360861688, 35.6663713234035],
              [51.4456107888338, 35.6660486764881],
              [51.4456071779014, 35.6660027181448],
              [51.4455714161799, 35.6656360731258],
              [51.4455189497512, 35.665634280948],
              [51.4454726185425, 35.6656175376653],
              [51.4454316069309, 35.665599126497],
              [51.4453989581453, 35.6655785204563],
              [51.4453611397189, 35.6655453953777],
              [51.4453268120392, 35.6655006037334],
              [51.4453006641936, 35.665441354754],
              [51.445292114272, 35.6653963208042],
              [51.4452913577203, 35.6653645373287],
              [51.4452972353823, 35.6653215075595],
              [51.4453120513402, 35.665277455641],
              [51.4453426886493, 35.6652263575308],
              [51.4453803695213, 35.6651868013506],
              [51.4454215382193, 35.6651575478742],
              [51.4454711414364, 35.6651344484043],
              [51.4455225280749, 35.6651209276076],
              [51.445560572031, 35.6651167168621],
              [51.44561384181, 35.6651185890009],
              [51.4456642006528, 35.6651288841528],
              [51.4457103497832, 35.665146507133],
              [51.4457774389806, 35.6651908446908],
              [51.4458154539589, 35.6652322955208],
              [51.4458443549931, 35.6652823176733],
              [51.4459428401083, 35.6652880264142],
              [51.4460100760103, 35.6652877774013],
              [51.4462277133215, 35.6652607298972],
              [51.4471306772008, 35.6651494041315],
              [51.447394326735, 35.6651168982723],
              [51.4475372338467, 35.6651005435295],
              [51.4476305874312, 35.6650881714248],
              [51.4493026691396, 35.6648891140382],
              [51.449657602801, 35.6648448487885],
              [51.4499204748831, 35.6648045050913],
              [51.4501481461989, 35.6647428217593],
              [51.4501781977449, 35.6647253421077],
              [51.4502967496874, 35.6646563853461],
              [51.4507079186413, 35.6644020121902],
              [51.4509730386989, 35.6642224524205],
              [51.4514644593502, 35.6638896196036],
              [51.4516508607181, 35.6638623097426],
              [51.4517578087459, 35.6639323425653],
              [51.4517757235792, 35.6639944359372],
              [51.4519066212047, 35.664439020183],
              [51.4519664172916, 35.6646422570959],
              [51.4520108087919, 35.6647930170873],
              [51.4520732144158, 35.6650049476276],
              [51.4521187078007, 35.6651596120228],
              [51.4521772841718, 35.6653587482352],
              [51.4522242992828, 35.6655184884843],
              [51.4522832427638, 35.6657187566088],
              [51.4523353807419, 35.6658955716708],
              [51.4524534642271, 35.6663248096719],
              [51.4525154488434, 35.6665502074285],
              [51.4526347896104, 35.6669839738965],
              [51.4527067506375, 35.6672626576419],
              [51.4527614598535, 35.6674745625622],
              [51.4528488993216, 35.6678129087105],
              [51.4525128008098, 35.6678493378048],
              [51.4522474713355, 35.6678778786677],
              [51.4520109706109, 35.6679034011555],
              [51.4519870803526, 35.6679059784442],
              [51.4515197431988, 35.6679524916162],
              [51.4511252775457, 35.6679987471197],
              [51.4505642446766, 35.6680538945062],
              [51.4503027063074, 35.6680795605213],
              [51.4500658520622, 35.6681029499497],
              [51.4498145947238, 35.6681276514002],
              [51.4497406513069, 35.668134898141],
              [51.449405884826, 35.6681677963161],
              [51.448876423807, 35.6682198110552],
              [51.4488700508445, 35.6682204389078],
              [51.4487176326019, 35.66823536643],
              [51.4486699131156, 35.6682402471756],
              [51.4483217822495, 35.6682758023693],
              [51.4480891487533, 35.6682995932617],
              [51.4480667271605, 35.6683018604568],
              [51.4477303928797, 35.6683362123459],
              [51.4473595657942, 35.6683740852043],
              [51.446938474999, 35.6684090851483],
              [51.4468944529983, 35.6684126927838],
              [51.4466643624356, 35.6684317667545],
              [51.4459796773883, 35.6684857609266],
              [51.445924683887, 35.6685260062253],
              [51.4458997591857, 35.6685548372538],
              [51.4458855606264, 35.6685911418871],
              [51.4458763073091, 35.6686335376886],
              [51.4459111784072, 35.669086676899],
              [51.4459284571614, 35.6693190977794],
              [51.4459564320631, 35.6696953926468],
              [51.4459774908935, 35.6699786291815],
              [51.445998724117, 35.6702641867634],
              [51.4460295158275, 35.670678342499],
              [51.4460641727233, 35.6711444784666],
              [51.4460720806328, 35.6712500829283],
              [51.4460787094002, 35.6713392724512],
              [51.4461114414496, 35.6717796828219],
              [51.4461118189578, 35.6717847756607],
              [51.446124661256, 35.6719575994465],
              [51.446168388449, 35.6725987594875],
              [51.4462223704534, 35.6730820565899],
              [51.4462286046786, 35.6731654166667],
              [51.4462328690379, 35.6732224301612],
              [51.4462344729126, 35.6736130033509],
              [51.446234779643, 35.6736877603504],
              [51.4462360765223, 35.6740035224182],
              [51.4462426440148, 35.6742110507549],
              [51.4462775989277, 35.6746569390716],
              [51.4463267086315, 35.6748807942741],
              [51.4463511173779, 35.675222567508],
              [51.4464131372155, 35.6760896467124],
              [51.4464205384049, 35.6761727346242],
              [51.4464567688186, 35.6765794365921],
              [51.4464895955626, 35.676985644424],
              [51.4465255027418, 35.6774940680667],
              [51.4465265644052, 35.6775090925661],
              [51.4465535466259, 35.6778921671278],
              [51.4465546119824, 35.6779072574315],
              [51.4465862303745, 35.6783546229043],
              [51.4466165080337, 35.6787842175958],
              [51.4465430855998, 35.6788893715906],
              [51.4466294904833, 35.6789976312543],
              [51.4466612132308, 35.6796796987179],
              [51.446685697637, 35.6798788382797],
              [51.4467141965276, 35.6801106201065],
              [51.4467329017894, 35.6803948430071],
              [51.4467633149298, 35.680860335549],
              [51.4467953319506, 35.6813482276864],
              [51.4468231276074, 35.6816836439829],
              [51.4467430220856, 35.681780798323],
              [51.4468308775326, 35.6818534793513],
              [51.4468426056848, 35.6820393336957],
              [51.4468439113645, 35.6820600447783],
              [51.4468622382609, 35.6823127009817],
              [51.4468627388235, 35.682319628176],
              [51.4468761312793, 35.6824999060343],
              [51.4468930746873, 35.6827279707933],
              [51.4468966316227, 35.6827758505465],
              [51.4469008862843, 35.6828331146132],
              [51.4469220648899, 35.6831180909525],
              [51.4469330041855, 35.6832652645055],
              [51.4469480780036, 35.6834681535529],
              [51.446948732187, 35.6834768627039],
              [51.4469690890008, 35.6837479803465],
              [51.4470616616548, 35.6850162117532],
              [51.4471112315712, 35.6856953043557],
              [51.4470373748991, 35.68579711691],
              [51.4471278913788, 35.6858964490575],
              [51.4471792674711, 35.6865545944016],
              [51.4472038804126, 35.6868868159257],
              [51.4472268235024, 35.687197428791],
              [51.4472273580977, 35.6872031152051],
              [51.4472345873734, 35.6873494927436],
              [51.4472479066681, 35.6876527596665],
              [51.4472637480286, 35.6878599870304],
              [51.4472817608346, 35.6880956618376],
              [51.4473056568035, 35.6884877470959],
              [51.4473282026371, 35.6888576914463],
              [51.4473285493698, 35.6888627843807],
              [51.447339414397, 35.6892172703447],
              [51.4473697303269, 35.6892655852611],
              [51.4473932191932, 35.6892984210728],
              [51.447411139598, 35.689377094019],
              [51.447455295321, 35.6894294121156],
              [51.4475200002326, 35.6894959681203],
              [51.4475728879965, 35.6895410974561],
              [51.4476374053939, 35.689574255832],
              [51.4477472114314, 35.6896173575434],
              [51.4478565588809, 35.6896806186512],
              [51.4479599420285, 35.689730503598],
              [51.44800852085, 35.6897329204237],
              [51.4481383687804, 35.6897393814948],
              [51.4498075695572, 35.689816658132],
              [51.4499962618811, 35.6898723599491],
              [51.4502219361039, 35.6899005252721],
              [51.4503932603671, 35.6899143402813],
              [51.4516286622213, 35.6899772738938],
              [51.4516637354532, 35.6899810472765],
              [51.4516824760785, 35.6899848720127],
              [51.4517043755122, 35.6899910661036],
              [51.4517233175182, 35.6899980674289],
              [51.4517421772876, 35.6900067524069],
              [51.4517567840866, 35.6900148321174],
              [51.4517780252367, 35.6900291352384],
              [51.4517869981825, 35.6900369187135],
              [51.4518005958978, 35.6900487169294],
              [51.4518166401035, 35.69006670378],
              [51.4518271231869, 35.6900810256292],
              [51.4518337842866, 35.6900923828305],
              [51.4518447961814, 35.6901165935962],
              [51.4518502485817, 35.6901344894601],
              [51.451854077223, 35.6901568581033],
              [51.4518458533292, 35.6902258466859],
              [51.4516858126105, 35.6916891709595],
              [51.4517095760936, 35.6919596245092],
              [51.4516723341624, 35.6920653552389],
              [51.4516343382555, 35.6921732247497],
              [51.4515932364958, 35.6923001122939],
              [51.451484358578, 35.6923607424713],
              [51.4513047597299, 35.6924311490166],
              [51.4509781922433, 35.6923763554031],
              [51.4507540395861, 35.6923446983263],
              [51.449891798336, 35.6922957987053],
              [51.4496598863272, 35.6922785081381],
              [51.4492065830936, 35.6922448466413],
              [51.4474951624419, 35.6921311315123],
              [51.4474567554703, 35.6918515898733],
              [51.4474094977227, 35.6912466388488],
              [51.4474045798496, 35.6911843732899],
              [51.4473604197778, 35.6905198434379],
              [51.4473351763566, 35.6900792059323],
              [51.4473025167019, 35.6900262716453],
              [51.4472845786001, 35.6900010556278],
              [51.4472718465661, 35.6899844389671],
              [51.4472389880385, 35.6899455591416],
              [51.4472110612738, 35.6899162291068],
              [51.4471637745143, 35.6898726512568],
              [51.4471211089022, 35.6898386135257],
              [51.4470479620579, 35.6897894243425],
              [51.4469282919212, 35.6897282574465],
              [51.446860513037, 35.6897113176369],
              [51.4467919296144, 35.6896989412308],
              [51.446610980813, 35.6897245292753],
              [51.4463343906034, 35.6897831630685],
              [51.4461288838063, 35.6898337995203],
              [51.4458446712905, 35.6899452627265],
              [51.4456404277546, 35.6900627920744],
              [51.4452703538219, 35.6903194613348],
              [51.4450031471936, 35.6905492124033],
              [51.4445023037921, 35.6910214118131],
              [51.4443554973152, 35.6911587719652],
              [51.4440430120233, 35.691427309426],
              [51.4439014548789, 35.6915287412581],
              [51.4437119670941, 35.6916408707449],
              [51.4435609013354, 35.6917098685507],
              [51.4433401034168, 35.6917603014282],
              [51.4431243241926, 35.691802553854],
              [51.4421154727611, 35.6919052453056],
              [51.4411884302162, 35.6920071578596],
              [51.440303342176, 35.6921063672325],
              [51.4397750980198, 35.6921647205166],
              [51.4390053020227, 35.6922555331921],
              [51.4390033326381, 35.6922557657822],
              [51.4384509088833, 35.6923209312191],
              [51.4375714241541, 35.6924375448941],
              [51.4375017815205, 35.6924438885449],
              [51.4374633773343, 35.6924465193224],
              [51.4374411837176, 35.6924477044719],
              [51.4374200628477, 35.6924486044101],
              [51.4373938153301, 35.6924494147762],
              [51.437357844634, 35.6924499719404],
              [51.437295551834, 35.6924538741976],
              [51.436867181664, 35.6925071895459],
              [51.436052621296, 35.6925607641288],
              [51.4355557158376, 35.6926316975037],
              [51.4338612484334, 35.6928132155091],
              [51.4338400545181, 35.6928216743679],
              [51.4338203152893, 35.6928295527392],
              [51.4337967920969, 35.6928389414527],
              [51.4337681129639, 35.6928503882326],
              [51.4337472973145, 35.692858696041],
              [51.4337316187629, 35.6928661621466],
              [51.4337121975082, 35.6928754107372],
              [51.433691522112, 35.692890028555],
              [51.4336707982682, 35.6929046817075],
              [51.4336461526667, 35.6929298980815],
              [51.4336322333877, 35.6929507894526],
              [51.433615804821, 35.6929812147039],
              [51.4336074503339, 35.6930069746772],
              [51.4336026645579, 35.6930302531263],
              [51.433609282691, 35.6930635067312],
              [51.4336190491427, 35.6930815438686],
              [51.4336289562744, 35.6930998419718],
              [51.4336380450706, 35.6931166282798],
              [51.4336507410278, 35.6931400754746],
              [51.433662729188, 35.6931622169495],
              [51.4336730471458, 35.6931792251362],
              [51.4336860360479, 35.6932006362877],
              [51.4336997297613, 35.6932232071024],
              [51.4337147517114, 35.6932479686043],
              [51.4337382504366, 35.6932867037134],
              [51.433780404257, 35.6933567465936],
              [51.4345207560795, 35.6945942569926],
              [51.4345213115511, 35.6945951863734],
              [51.435028404393, 35.6954230302402],
              [51.4353631568887, 35.6959591132135],
              [51.435450595968, 35.6961140173514],
              [51.4354507064495, 35.6961142117042],
              [51.4359319383028, 35.6969667334348],
              [51.4359341659842, 35.6969706790217],
              [51.4361083354027, 35.697259263592],
              [51.4365105997243, 35.6979257737928],
              [51.4365494104347, 35.6981110093641],
              [51.4366830796463, 35.6982266672599],
              [51.4369736629842, 35.6987508760921],
              [51.4373773641273, 35.6994326642199],
              [51.4379336864386, 35.700368496479],
              [51.4379955620834, 35.7005509580098],
              [51.4385105053571, 35.7017996875148],
              [51.4385302207559, 35.7018474967891],
              [51.4385629815836, 35.7019269382266],
              [51.4389592916379, 35.7028879518612],
              [51.4390831774713, 35.7031280036399],
              [51.4392071421801, 35.703499395505],
              [51.4392322360098, 35.7035745747526],
              [51.4393489721348, 35.703876952272],
              [51.4394524718159, 35.7041338059818],
              [51.4395981984483, 35.7044954515364],
              [51.4398376577881, 35.7051203892777],
              [51.4400067820303, 35.7055674900209],
              [51.4400895688307, 35.7057651672909],
              [51.4401857283707, 35.7060042381145],
              [51.4402353690139, 35.7061276529081],
              [51.4402885368675, 35.7062598384551],
              [51.4403321568977, 35.7062585176394],
              [51.4403756282281, 35.7062596722118],
              [51.4404163213426, 35.7062630108218],
              [51.4404591980189, 35.7062693624246],
              [51.4404953066758, 35.70627774654],
              [51.4405416980042, 35.7062946380062],
              [51.4405937241085, 35.7063207159452],
              [51.4406443957118, 35.7063527087183],
              [51.4406675529974, 35.7063707900568],
              [51.4406891146316, 35.7063901411599],
              [51.4407089640813, 35.7064106772533],
              [51.4407270124034, 35.7064322852344],
              [51.4407431606639, 35.7064548704583],
              [51.4407573482854, 35.7064783213745],
              [51.4407696632653, 35.7065028396195],
              [51.4407795358726, 35.7065273537098],
              [51.4407873417283, 35.7065530272608],
              [51.4407927117821, 35.7065787768065],
              [51.4407954581485, 35.7066036718765],
              [51.4407961893158, 35.7066319521236],
              [51.4407920048922, 35.7066841051017],
              [51.4407863221721, 35.7067108826835],
              [51.4407749161615, 35.706745812505],
              [51.4407591331184, 35.7067798640755],
              [51.4407445123977, 35.7068058904278],
              [51.4407274899043, 35.7068307245833],
              [51.4407099624683, 35.7068521874878],
              [51.4406900573761, 35.706873144483],
              [51.4406687111691, 35.7068926506481],
              [51.4406457508829, 35.706910902865],
              [51.4406212776002, 35.706927802287],
              [51.4405954352715, 35.7069432662355],
              [51.4405683278551, 35.706957215488],
              [51.440540084272, 35.7069695998821],
              [51.4405108506602, 35.7069803408283],
              [51.4404807795512, 35.7069893967298],
              [51.440448712606, 35.7069970681137],
              [51.440418673077, 35.7070022684633],
              [51.4403799804647, 35.707005931607],
              [51.4403406719697, 35.7070064218515],
              [51.4402909186471, 35.7070049755223],
              [51.4402597790334, 35.7070015763138],
              [51.4402277619367, 35.7069961307345],
              [51.4401969115976, 35.7069890332228],
              [51.4401667307682, 35.7069802012469],
              [51.4401373815755, 35.7069696685463],
              [51.4401090130422, 35.7069575027976],
              [51.4400817575299, 35.7069437451608],
              [51.4400557298732, 35.7069284694844],
              [51.4400310810018, 35.7069117486609],
              [51.4400079180065, 35.7068936727628],
              [51.4399863600732, 35.7068743161383],
              [51.4399665075248, 35.7068537881668],
              [51.4399481635529, 35.7068318410281],
              [51.439932306338, 35.7068095890533],
              [51.4399184983891, 35.7067863825219],
              [51.4399067460028, 35.70676228379],
              [51.4392040465031, 35.7068961634467],
              [51.4381989847196, 35.707114729426],
              [51.4381127120423, 35.7071612484228],
              [51.4380516476677, 35.7072123406474],
              [51.4380308162423, 35.7072539257029],
              [51.438013510206, 35.7072983596985],
              [51.4379864615602, 35.7074142959415],
              [51.4379750298949, 35.7086263877367],
              [51.4379691936072, 35.7092561964315],
              [51.4376986193277, 35.7093084807537],
              [51.4376520276149, 35.7093173860742],
              [51.4372448543429, 35.7093961185239],
              [51.4370619894326, 35.7094313773486],
              [51.4358799666457, 35.7096774125119],
              [51.4355535542537, 35.7092002994625],
              [51.4355123509443, 35.7091399897797],
              [51.435491192097, 35.7091113494328],
              [51.4351682156543, 35.7086746916005],
              [51.4351636517285, 35.7086684940689],
              [51.4347747106874, 35.7081423966019],
              [51.4346802017797, 35.7080146938845],
              [51.4344715470166, 35.7077321190567],
              [51.4341682301526, 35.7073209432384],
              [51.4340429966932, 35.707200106739],
              [51.4339484103897, 35.7071935422163],
              [51.4338627438185, 35.7071914283714],
              [51.4337443455194, 35.707190687496],
              [51.4335759679804, 35.7071886307525],
              [51.4334066510362, 35.7071839606254],
              [51.4331165297548, 35.7071684240061],
              [51.4328111932919, 35.7071656020926],
              [51.432692513472, 35.7071653309438],
              [51.4320591064596, 35.7071518170301],
              [51.4319652452674, 35.7071513478735],
              [51.4315168178503, 35.7071436326686],
              [51.431170291401, 35.7071365443868],
              [51.4308840257821, 35.7071297028276],
              [51.430721711988, 35.7071258234329],
              [51.4298574593412, 35.7071051642267],
              [51.4294730169735, 35.7071021556064],
              [51.4289499616084, 35.7070917027895],
              [51.4282877675395, 35.707073034945],
              [51.4277500865078, 35.7070578746584],
              [51.4276041229008, 35.7070538346717],
              [51.4271466912404, 35.7070456861579],
              [51.4263610260058, 35.7070354378877],
              [51.4257665901635, 35.7070193905203],
              [51.424913384398, 35.7069983240223],
              [51.424562418439, 35.70699206549],
              [51.4243612622196, 35.7069884786203],
              [51.4235457631445, 35.7069714106625],
              [51.4226031701565, 35.7069500914071],
              [51.4219472874313, 35.7069404531404],
              [51.4210426887732, 35.7069236075114],
              [51.4197676041594, 35.7069022151115],
              [51.419401316913, 35.7068899576402],
              [51.4190853848206, 35.7068805622266],
              [51.4184895239827, 35.7068617104535],
              [51.4183403870746, 35.7068554937258],
              [51.4177077704281, 35.7068375096746],
              [51.4175864088319, 35.7068392787353],
              [51.4171337276312, 35.7068237977114],
              [51.4167425097694, 35.7068210784562],
              [51.4160768804276, 35.7067996720496],
              [51.4154779634486, 35.7067842863042],
              [51.4153921651667, 35.7067223131111],
              [51.4152827179125, 35.70678689773],
              [51.4131380900452, 35.7067311560263],
              [51.4123475453765, 35.706710607611],
              [51.412240778367, 35.706708587626],
              [51.4121712615048, 35.7067071730155],
              [51.4109937868794, 35.7066832092602],
              [51.4107414599744, 35.7066797013113],
              [51.4101636486389, 35.7066655551072],
              [51.4096736458491, 35.7066493103335],
              [51.4092911448729, 35.7066369645655],
              [51.4087457454245, 35.7066199243059],
              [51.4085551219845, 35.7066138868216],
              [51.4084347501246, 35.7066100739184],
              [51.4083274175933, 35.7066068027192],
              [51.4083111680781, 35.7066064827667],
              [51.4082626815431, 35.7066055265153],
              [51.4080862496979, 35.7066020485684],
              [51.4078409193979, 35.7065972124658],
              [51.4077128149063, 35.7065946873257],
              [51.4075853162656, 35.7065921735221],
              [51.4074778868492, 35.7065900550795],
              [51.4073565177073, 35.7065879314258],
              [51.4072067860217, 35.7065847089486],
              [51.4069729326189, 35.7065800973264],
              [51.4067112611621, 35.7065749363901],
              [51.4065288225199, 35.7065712573609],
              [51.4062503247743, 35.7065562298015],
              [51.4060368990376, 35.7064596188879],
              [51.4058439180892, 35.7065571455278],
              [51.4049592852535, 35.7065507581252],
              [51.4038471141096, 35.7065275641183],
              [51.4038445155636, 35.7065331151651],
              [51.4038417640451, 35.7065385828734],
              [51.4038377351152, 35.706545900507],
              [51.4038347240795, 35.7065512013824],
              [51.4038313513543, 35.7065564610946],
              [51.4038266008872, 35.7065634042668],
              [51.403821588692, 35.7065701806135],
              [51.4038176509274, 35.706575190666],
              [51.4038135588664, 35.7065800741059],
              [51.4038093602653, 35.7065848749531],
              [51.4038049060912, 35.7065896333792],
              [51.4037988138208, 35.7065957425348],
              [51.4037939971195, 35.7066002939],
              [51.4037891795628, 35.7066046757611],
              [51.4037841548719, 35.7066089753669],
              [51.4037788741895, 35.7066131496028],
              [51.4037719028045, 35.706618545811],
              [51.4037646175362, 35.7066237356965],
              [51.403757024785, 35.7066286732547],
              [51.4037492764225, 35.7066334427293],
              [51.4037412694481, 35.7066380056957],
              [51.4037331561794, 35.7066423156597],
              [51.4037267897673, 35.706645359283],
              [51.4037205754859, 35.7066483194457],
              [51.4037141547348, 35.7066511098922],
              [51.4037076838387, 35.7066538211631],
              [51.4036988969078, 35.7066571668356],
              [51.4036899552666, 35.7066603038478],
              [51.4036832236171, 35.7066623839484],
              [51.4036763345687, 35.7066643798231],
              [51.403667133084, 35.7066668468914],
              [51.4036577764529, 35.7066690187443],
              [51.4036484163468, 35.7066709399546],
              [51.4036412681334, 35.7066721811294],
              [51.4036340662182, 35.7066732953539],
              [51.4036277086576, 35.7066741488798],
              [51.4036215128363, 35.7066748512906],
              [51.4036132657893, 35.7066756507427],
              [51.403603968679, 35.7066762535533],
              [51.4035942934213, 35.7066766205022],
              [51.4035870333726, 35.7066767286982],
              [51.4035765840017, 35.7066765978359],
              [51.4035693233542, 35.7066763679211],
              [51.4035620636724, 35.7066758909557],
              [51.403552486404, 35.706675082747],
              [51.4035452216976, 35.706674266784],
              [51.4035380118448, 35.7066733676865],
              [51.4035285326732, 35.7066718441533],
              [51.4035214226166, 35.7066705669368],
              [51.4035143623604, 35.706669081276],
              [51.4035049837152, 35.7066668856886],
              [51.403498023669, 35.7066651039558],
              [51.4034912197492, 35.7066631539958],
              [51.4034821454574, 35.7066603704244],
              [51.4034732242455, 35.7066572527355],
              [51.4034644058726, 35.7066539219162],
              [51.4034579058751, 35.7066512983185],
              [51.4034514569883, 35.7066485068457],
              [51.4034430477809, 35.7066445471179],
              [51.4034348395963, 35.7066403342589],
              [51.4034288004973, 35.7066370373994],
              [51.4034228127226, 35.7066336150409],
              [51.403416925111, 35.7066301066913],
              [51.403411245595, 35.7066264326454],
              [51.4034038091878, 35.7066213759755],
              [51.403396573817, 35.7066160688794],
              [51.403389547416, 35.7066105501007],
              [51.403380840986, 35.7066031065595],
              [51.4033747570875, 35.7065974989662],
              [51.4033678778037, 35.7065906813441],
              [51.4033633746922, 35.706585950248],
              [51.4033590792021, 35.7065811787841],
              [51.4033536393387, 35.7065746051875],
              [51.4033497009463, 35.7065696215449],
              [51.4033459204264, 35.7065645967996],
              [51.4033411994022, 35.7065576430099],
              [51.4033367377233, 35.706550602696],
              [51.40333351928, 35.7065452397583],
              [51.4033306090475, 35.7065398352142],
              [51.4033278022852, 35.7065343428651],
              [51.4033251489781, 35.7065288103299],
              [51.403322023874, 35.7065213480813],
              [51.4033191536976, 35.7065138002249],
              [51.4033165419787, 35.7065062091257],
              [51.403314340635, 35.7064984489479],
              [51.403312768273, 35.7064926603335],
              [51.4033115525332, 35.7064867848691],
              [51.4033101225798, 35.7064789824347],
              [51.4033090030294, 35.7064711347801],
              [51.4033085111414, 35.7064652163167],
              [51.4033079539855, 35.7064568744869],
              [51.4033078121635, 35.7064493481433],
              [51.4032148102919, 35.7064222194911],
              [51.4027317699518, 35.70628131856],
              [51.4017104270794, 35.7059832775002],
              [51.4007770383006, 35.7057104591881],
              [51.4003091596366, 35.7055743884545],
              [51.3989066642659, 35.7052004009765],
              [51.3987465550513, 35.7050825481605],
              [51.3985477585323, 35.7051003826695],
              [51.3970309512895, 35.7046782511285],
              [51.3970207579425, 35.7046753030554],
              [51.3970055894536, 35.7046715364803],
              [51.396998151042, 35.7046697478332],
              [51.3969891341134, 35.704667964392],
              [51.3969750280767, 35.7046657865908],
              [51.3969479925242, 35.7046639543773],
              [51.3969238061654, 35.7046644570048],
              [51.3969044776984, 35.7046664322026],
              [51.3968828176724, 35.7046703698233],
              [51.3968616948439, 35.7046760845885],
              [51.3968361004234, 35.7046857830764],
              [51.3968178638926, 35.7046948532079],
              [51.3968050424652, 35.7047025124634],
              [51.3967897318428, 35.7047133392416],
              [51.3967535680222, 35.7047414685495],
              [51.3965442151664, 35.7052204858691],
              [51.3963014279534, 35.7057760802716],
              [51.3960396249394, 35.7063754974075],
              [51.3958303967736, 35.7068537195361],
              [51.395722252893, 35.707100271953],
              [51.3955734500802, 35.707442025026],
              [51.395438767868, 35.7077512294964],
              [51.3952886106597, 35.7080956671879],
              [51.3952127690907, 35.7082719760087],
              [51.39496448429, 35.7083443228584],
              [51.3936119927041, 35.7079815380046],
              [51.3933084307279, 35.7078963921008],
              [51.39313981375, 35.7078490961093],
              [51.3927347316056, 35.7077511732978],
              [51.3924455277441, 35.7077099365028],
              [51.3921077375291, 35.7076862245345],
              [51.39180353189, 35.7076872151963],
              [51.3915485737753, 35.7075774832135],
              [51.3914538290421, 35.7077156454609],
              [51.3907320228642, 35.7078930823381],
              [51.3905260999438, 35.7079339147505],
              [51.3902158141522, 35.7078847354126],
              [51.3901743492765, 35.707746603726],
              [51.3902383219767, 35.70733981544],
              [51.390260333792, 35.7071751394789],
              [51.3902879840673, 35.7069595859819],
              [51.3903022995794, 35.7068498010566],
              [51.3903932921705, 35.7061491048275],
              [51.3903994448105, 35.7061018934586],
              [51.3904421091238, 35.705773354579],
              [51.3904809256544, 35.7054744007778],
              [51.390522195046, 35.7051734463849],
              [51.3905622633082, 35.7048805816978],
              [51.3905987489531, 35.7046138470888],
              [51.3906270810006, 35.7044074301588],
              [51.3906478788691, 35.7042557198552],
              [51.3906597568876, 35.704173987119],
              [51.3906803735889, 35.7040318419065],
              [51.3907682220394, 35.7034270438845],
              [51.3908593207745, 35.7028001731452],
              [51.3908959303757, 35.7025220773894],
            ],
          ],
        },
      },
      {
        dist: 11.87271906,
        source: "پایانه شهید براری",
        destination: "میدان ولی\u200cعصرعج",
        coor: {
          type: "MultiLineString",
          coordinates: [
            [
              [
                51.4915985538828,
                35.6930979499128
              ],
              [
                51.491583623772,
                35.6930483725515
              ],
              [
                51.491559162237,
                35.6930453140319
              ],
              [
                51.4913367280224,
                35.6930152096628
              ],
              [
                51.4912227824821,
                35.6929987781442
              ],
              [
                51.4911698633772,
                35.6929594317516
              ],
              [
                51.4911142726618,
                35.6929253801005
              ],
              [
                51.4910629284933,
                35.6928995918125
              ],
              [
                51.4910087493274,
                35.6928772173167
              ],
              [
                51.4909517351595,
                35.6928582566096
              ],
              [
                51.4908918859844,
                35.6928427096872
              ],
              [
                51.4903824874353,
                35.6928252024799
              ],
              [
                51.4901456929264,
                35.6928074364064
              ],
              [
                51.4898714231447,
                35.6927899278656
              ],
              [
                51.4893689998143,
                35.692757852804
              ],
              [
                51.4887668817729,
                35.6927194101288
              ],
              [
                51.4886190864501,
                35.692654029735
              ],
              [
                51.4884585179964,
                35.6926975935578
              ],
              [
                51.4865065426426,
                35.6925442596845
              ],
              [
                51.4850279808783,
                35.6924162249459
              ],
              [
                51.4849437628884,
                35.6923632391251
              ],
              [
                51.4848477406184,
                35.6924022355201
              ],
              [
                51.4840911268226,
                35.6923502558323
              ],
              [
                51.4829484473648,
                35.6922633841655
              ],
              [
                51.4804668302966,
                35.6920812708394
              ],
              [
                51.4799541955734,
                35.6920397381956
              ],
              [
                51.478853013963,
                35.6919437116673
              ],
              [
                51.4787264608293,
                35.6918818329904
              ],
              [
                51.478530609354,
                35.6919274714201
              ],
              [
                51.4762798482727,
                35.6917581838914
              ],
              [
                51.4758246834596,
                35.6917322704454
              ],
              [
                51.474929471544,
                35.6916695276176
              ],
              [
                51.4739495809972,
                35.6916084757109
              ],
              [
                51.4731758446813,
                35.6915488245894
              ],
              [
                51.4716263728396,
                35.6914293520487
              ],
              [
                51.4701586032445,
                35.6913228575667
              ],
              [
                51.4680378104226,
                35.6911437313071
              ],
              [
                51.4673438765804,
                35.6910851118621
              ],
              [
                51.4663756229884,
                35.6910133498852
              ],
              [
                51.465242163995,
                35.6909066430324
              ],
              [
                51.4650159651797,
                35.6908328853834
              ],
              [
                51.464750373472,
                35.6908569188574
              ],
              [
                51.4639457803163,
                35.6907771399435
              ],
              [
                51.4634667465064,
                35.6907426512185
              ],
              [
                51.4628850891106,
                35.6906939406865
              ],
              [
                51.4619782573496,
                35.6906078632992
              ],
              [
                51.4611656367935,
                35.6905736253719
              ],
              [
                51.4610608457502,
                35.6905175025811
              ],
              [
                51.4609374755579,
                35.6905613786632
              ],
              [
                51.4607157360212,
                35.6905489879301
              ],
              [
                51.4603633336591,
                35.690529296522
              ],
              [
                51.4595983992206,
                35.6904834654093
              ],
              [
                51.4593008362298,
                35.6904699171105
              ],
              [
                51.4584088477813,
                35.6904142646848
              ],
              [
                51.4578075980872,
                35.6903918885675
              ],
              [
                51.4572930545428,
                35.6903670026689
              ],
              [
                51.4572515419897,
                35.6903649946345
              ],
              [
                51.457028018766,
                35.6903541835377
              ],
              [
                51.4569755382948,
                35.6903516454124
              ],
              [
                51.4563141957042,
                35.6903196531289
              ],
              [
                51.4548492859467,
                35.690216987654
              ],
              [
                51.4531218521757,
                35.6900895917454
              ],
              [
                51.4521014521265,
                35.690020976667
              ],
              [
                51.4520682484541,
                35.6900261369741
              ],
              [
                51.4520399984083,
                35.6900332640649
              ],
              [
                51.4520267885398,
                35.6900369319165
              ],
              [
                51.4520149836162,
                35.690041421288
              ],
              [
                51.4519998359473,
                35.6900471818875
              ],
              [
                51.4519867969273,
                35.6900521402302
              ],
              [
                51.4519723734562,
                35.690060106204
              ],
              [
                51.4519585162976,
                35.6900677589868
              ],
              [
                51.4519466774758,
                35.6900762327906
              ],
              [
                51.4519289462012,
                35.6900889231061
              ],
              [
                51.4519191017086,
                35.6900982730195
              ],
              [
                51.4519073751582,
                35.6901094098188
              ],
              [
                51.4518961591239,
                35.6901222938665
              ],
              [
                51.4518884174333,
                35.6901335284094
              ],
              [
                51.4518756483702,
                35.6901520615995
              ],
              [
                51.451858088232,
                35.6901886336898
              ],
              [
                51.4518458533292,
                35.6902258466859
              ],
              [
                51.4516858126105,
                35.6916891709595
              ],
              [
                51.4517095760936,
                35.6919596245092
              ],
              [
                51.4516723341624,
                35.6920653552389
              ],
              [
                51.4516343382555,
                35.6921732247497
              ],
              [
                51.4515932364958,
                35.6923001122939
              ],
              [
                51.451484358578,
                35.6923607424713
              ],
              [
                51.4513047597299,
                35.6924311490166
              ],
              [
                51.4509781922433,
                35.6923763554031
              ],
              [
                51.4507540395861,
                35.6923446983263
              ],
              [
                51.449891798336,
                35.6922957987053
              ],
              [
                51.4496598863272,
                35.6922785081381
              ],
              [
                51.4492065830936,
                35.6922448466413
              ],
              [
                51.4474951624419,
                35.6921311315123
              ],
              [
                51.4474567554703,
                35.6918515898733
              ],
              [
                51.4474094977227,
                35.6912466388488
              ],
              [
                51.4474045798496,
                35.6911843732899
              ],
              [
                51.4473604197778,
                35.6905198434379
              ],
              [
                51.4473351763566,
                35.6900792059323
              ],
              [
                51.4473025167019,
                35.6900262716453
              ],
              [
                51.4472845786001,
                35.6900010556278
              ],
              [
                51.4472718465661,
                35.6899844389671
              ],
              [
                51.4472389880385,
                35.6899455591416
              ],
              [
                51.4472110612738,
                35.6899162291068
              ],
              [
                51.4471637745143,
                35.6898726512568
              ],
              [
                51.4471211089022,
                35.6898386135257
              ],
              [
                51.4470479620579,
                35.6897894243425
              ],
              [
                51.4469282919212,
                35.6897282574465
              ],
              [
                51.446860513037,
                35.6897113176369
              ],
              [
                51.4467919296144,
                35.6896989412308
              ],
              [
                51.446610980813,
                35.6897245292753
              ],
              [
                51.4463343906034,
                35.6897831630685
              ],
              [
                51.4461288838063,
                35.6898337995203
              ],
              [
                51.4458446712905,
                35.6899452627265
              ],
              [
                51.4456404277546,
                35.6900627920744
              ],
              [
                51.4452703538219,
                35.6903194613348
              ],
              [
                51.4450031471936,
                35.6905492124033
              ],
              [
                51.4445023037921,
                35.6910214118131
              ],
              [
                51.4443554973152,
                35.6911587719652
              ],
              [
                51.4440430120233,
                35.691427309426
              ],
              [
                51.4439014548789,
                35.6915287412581
              ],
              [
                51.4437119670941,
                35.6916408707449
              ],
              [
                51.4435609013354,
                35.6917098685507
              ],
              [
                51.4433401034168,
                35.6917603014282
              ],
              [
                51.4431243241926,
                35.691802553854
              ],
              [
                51.4421154727611,
                35.6919052453056
              ],
              [
                51.4411884302162,
                35.6920071578596
              ],
              [
                51.440303342176,
                35.6921063672325
              ],
              [
                51.4397750980198,
                35.6921647205166
              ],
              [
                51.4390053020227,
                35.6922555331921
              ],
              [
                51.4390033326381,
                35.6922557657822
              ],
              [
                51.4384509088833,
                35.6923209312191
              ],
              [
                51.4375714241541,
                35.6924375448941
              ],
              [
                51.4375017815205,
                35.6924438885449
              ],
              [
                51.4374633773343,
                35.6924465193224
              ],
              [
                51.4374411837176,
                35.6924477044719
              ],
              [
                51.4374200628477,
                35.6924486044101
              ],
              [
                51.4373938153301,
                35.6924494147762
              ],
              [
                51.437357844634,
                35.6924499719404
              ],
              [
                51.437295551834,
                35.6924538741976
              ],
              [
                51.436867181664,
                35.6925071895459
              ],
              [
                51.436052621296,
                35.6925607641288
              ],
              [
                51.4355557158376,
                35.6926316975037
              ],
              [
                51.4338612484334,
                35.6928132155091
              ],
              [
                51.4337375089524,
                35.6928031339581
              ],
              [
                51.4336538990541,
                35.6927873148988
              ],
              [
                51.4335783481425,
                35.6927630166572
              ],
              [
                51.4335247860532,
                35.6927390728663
              ],
              [
                51.4334607868695,
                35.6927014068227
              ],
              [
                51.4334062996456,
                35.6926590558794
              ],
              [
                51.4333801681027,
                35.6926341305632
              ],
              [
                51.4332806089089,
                35.6925251975819
              ],
              [
                51.433229780852,
                35.6924512726471
              ],
              [
                51.4329745987406,
                35.6916286982809
              ],
              [
                51.4327503989498,
                35.6910006400914
              ],
              [
                51.432684494537,
                35.690702172411
              ],
              [
                51.4326311373715,
                35.690683371445
              ],
              [
                51.4325772123797,
                35.6906683727715
              ],
              [
                51.4325227195543,
                35.6906571763899
              ],
              [
                51.4324676588877,
                35.6906497822994
              ],
              [
                51.4324121433715,
                35.6906461939239
              ],
              [
                51.4323560622917,
                35.6906463924846
              ],
              [
                51.4322994156401,
                35.6906503779807
              ],
              [
                51.4322422034086,
                35.6906581504115
              ],
              [
                51.4321717453073,
                35.6906999012165
              ],
              [
                51.4320985659259,
                35.6907378799064
              ],
              [
                51.4320133476939,
                35.6907759487149
              ],
              [
                51.4319247138138,
                35.6908092828684
              ],
              [
                51.4311700147529,
                35.6910070989245
              ],
              [
                51.4306146331796,
                35.6910605349051
              ],
              [
                51.4304063311328,
                35.6910702258352
              ],
              [
                51.4302674954681,
                35.6910826498386
              ],
              [
                51.4300752752694,
                35.6911375789382
              ],
              [
                51.4291008595858,
                35.6914905740965
              ],
              [
                51.4288300222004,
                35.6915907791977
              ],
              [
                51.4287141650617,
                35.6915636650107
              ],
              [
                51.4286524297371,
                35.6916653077079
              ],
              [
                51.4280525544717,
                35.6918804484537
              ],
              [
                51.4279667342725,
                35.6919093804207
              ],
              [
                51.4278651848266,
                35.6919498189682
              ],
              [
                51.4277251193571,
                35.6920061394985
              ],
              [
                51.4266095684384,
                35.6924037174541
              ],
              [
                51.4257830370386,
                35.692711520879
              ],
              [
                51.425677953516,
                35.6927476756069
              ],
              [
                51.4255494861599,
                35.6928015506458
              ],
              [
                51.4247551039344,
                35.6930915956288
              ],
              [
                51.4246237155124,
                35.6931307058358
              ],
              [
                51.4244550755151,
                35.6931010381797
              ],
              [
                51.4244253756394,
                35.6932102774079
              ],
              [
                51.4242712906691,
                35.693263444359
              ],
              [
                51.4238965547369,
                35.6934036772483
              ],
              [
                51.4231084922041,
                35.6936986670349
              ],
              [
                51.4225471791068,
                35.6938885794425
              ],
              [
                51.4215112551746,
                35.6942425928789
              ],
              [
                51.4205525204868,
                35.6945675512604
              ],
              [
                51.4199284326206,
                35.6947774733198
              ],
              [
                51.4197741579879,
                35.694760794727
              ],
              [
                51.4196129570448,
                35.6948224811274
              ],
              [
                51.417469866318,
                35.6949181987231
              ],
              [
                51.4171823835182,
                35.6949307398824
              ],
              [
                51.4166292866533,
                35.6949545083169
              ],
              [
                51.4161965931222,
                35.6949774756899
              ],
              [
                51.4160898850669,
                35.6949838088806
              ],
              [
                51.415191025086,
                35.6950238767291
              ],
              [
                51.4142880021346,
                35.6950687389634
              ],
              [
                51.4133708136348,
                35.6951064913206
              ],
              [
                51.4132348792723,
                35.6951165000192
              ],
              [
                51.4131471669056,
                35.6951203796713
              ],
              [
                51.4130345981049,
                35.6951243445493
              ],
              [
                51.4126442989528,
                35.6951459599262
              ],
              [
                51.4124970328446,
                35.6951512180647
              ],
              [
                51.4120054408088,
                35.6951708116454
              ],
              [
                51.4118936078498,
                35.6951117668411
              ],
              [
                51.4117195995239,
                35.6951209465673
              ],
              [
                51.411719087026,
                35.6951214460215
              ],
              [
                51.4116487600645,
                35.6951899239085
              ],
              [
                51.4104895284785,
                35.6952487504913
              ],
              [
                51.4101503870777,
                35.6952666056448
              ],
              [
                51.409934014037,
                35.6952733060839
              ],
              [
                51.4097950973943,
                35.6952810417282
              ],
              [
                51.4091794224679,
                35.6953302518121
              ],
              [
                51.4088727920391,
                35.6953462626196
              ],
              [
                51.4088107609697,
                35.6953493323777
              ]
            ],
            [
              [
                51.4088105012901,
                35.6953493449808
              ],
              [
                51.4084971358405,
                35.6953631263273
              ],
              [
                51.4083359204908,
                35.6953714706255
              ],
              [
                51.407058737432,
                35.6954176239193
              ],
              [
                51.406779565399,
                35.6954291329664
              ],
              [
                51.405775237465,
                35.6954847794826
              ],
              [
                51.4041565579894,
                35.6955642941521
              ],
              [
                51.4040513487811,
                35.6955696793548
              ],
              [
                51.4026957848228,
                35.6956460449657
              ],
              [
                51.4019472747775,
                35.6956812245314
              ],
              [
                51.4002995566152,
                35.6957735694726
              ],
              [
                51.3996462335486,
                35.6958071495637
              ],
              [
                51.3988517967374,
                35.6958525994175
              ],
              [
                51.3988516133278,
                35.6958526135497
              ],
              [
                51.3986903616308,
                35.6958631720891
              ],
              [
                51.3985905880516,
                35.6958673335425
              ],
              [
                51.3978973080958,
                35.6959020607
              ],
              [
                51.3977533240169,
                35.6959094475667
              ],
              [
                51.3976042193914,
                35.6959171261728
              ],
              [
                51.3976860273352,
                35.6965093397827
              ],
              [
                51.397688908595,
                35.6965299866772
              ],
              [
                51.3977351426003,
                35.6968645453498
              ],
              [
                51.3977769986181,
                35.6971667876974
              ],
              [
                51.397854207799,
                35.6976858054729
              ],
              [
                51.3978613099291,
                35.6977323946153
              ],
              [
                51.3979431355305,
                35.6982835537567
              ],
              [
                51.3979977650087,
                35.6986502421024
              ],
              [
                51.3980142293012,
                35.698761954056
              ],
              [
                51.39809254622,
                35.6992859286517
              ],
              [
                51.398152588344,
                35.6997060865101
              ],
              [
                51.3982080519582,
                35.7000945228916
              ],
              [
                51.3982565642097,
                35.7004351118486
              ],
              [
                51.3982978859328,
                35.7010994223047
              ],
              [
                51.3977359446518,
                35.7024927929803
              ],
              [
                51.3974276182523,
                35.7032041153977
              ],
              [
                51.3972602864461,
                35.7035901776986
              ],
              [
                51.3971510525974,
                35.7038380857473
              ],
              [
                51.396893986234,
                35.7044213491527
              ],
              [
                51.3967535680222,
                35.7047414685495
              ],
              [
                51.3965442151664,
                35.7052204858691
              ],
              [
                51.3963014279534,
                35.7057760802716
              ],
              [
                51.3960396249394,
                35.7063754974075
              ],
              [
                51.3958303967736,
                35.7068537195361
              ],
              [
                51.395722252893,
                35.707100271953
              ],
              [
                51.3955734500802,
                35.707442025026
              ],
              [
                51.395438767868,
                35.7077512294964
              ],
              [
                51.3952886106597,
                35.7080956671879
              ],
              [
                51.3952127690907,
                35.7082719760087
              ],
              [
                51.3954761712537,
                35.7081939104187
              ],
              [
                51.3971008954624,
                35.7086484063849
              ],
              [
                51.3971740278324,
                35.7088435206159
              ],
              [
                51.3973730829189,
                35.7087335218563
              ],
              [
                51.3986769631946,
                35.7091030424097
              ],
              [
                51.3987243753558,
                35.7092862085978
              ],
              [
                51.3989612227994,
                35.7091682648746
              ],
              [
                51.4019163776649,
                35.709987807953
              ],
              [
                51.4040713434043,
                35.7106333126321
              ],
              [
                51.4042662504461,
                35.7108520140368
              ],
              [
                51.4046717301384,
                35.7107747088139
              ],
              [
                51.4054593134266,
                35.7109924707494
              ]
            ]
          ]
        },
      },
    ],
  },
  {
    status: "200",
    BRT: {
      title: "BRT",
      id: 302,
      value: [
        {
          name: "میدان انقلاب - سامانه ۱ تندرو",
          dist: 35.7009754,
          lon: "1",
          lat: 51.3925198,
        },
        {
          name: "دانشگاه تهران - سامانه ۱ تندرو",
          dist: 35.7011279,
          lon: "1",
          lat: 51.3999952,
        },
        {
          name: "طالقانی، شمال به جنوب - سامانه ۷ تندرو",
          dist: 35.7070521,
          lon: "7",
          lat: 51.4061266,
        },
      ],
    },
    HOSPITAL: {
      title: "HOSPITAL",
      id: 503,
      value: [
        {
          name: "  بیمارستان آریا ",
          dist: 224.056643756833,
          lon: 51.3978047610809,
          lat: 35.7085992209773,
        },
        {
          name: "  بیمارستان یاس سپید ",
          dist: 355.852050411772,
          lon: 51.3977517496436,
          lat: 35.7103362498181,
        },
        {
          name: "  بیمارستان پارس ",
          dist: 451.469396670681,
          lon: 51.3994320294647,
          lat: 35.7102696352355,
        },
      ],
    },
    FUEL: {
      title: "FUEL",
      id: 204,
      value: [
        {
          name: "پمپ بنزین وصال",
          dist: 826.85418447271,
          lon: 51.4006007254432,
          lat: 35.7013851913736,
        },
        {
          name: "جایگاه شرکتی شماره ۲۲",
          dist: 1206.73183218021,
          lon: 51.3898334114828,
          lat: 35.7174325905416,
        },
      ],
    },
    FIRE: {
      title: "FIRE",
      id: 502,
      value: [
        {
          name: "ایستگاه آتش نشانی",
          dist: 237.099035002903,
          lon: 51.3930940627408,
          lat: 35.7081802762988,
        },
      ],
    },
    POLICE: {
      title: "POLICE",
      id: 501,
      value: [
        {
          name: "کلانتری ۱۰۷ فلسطین",
          dist: 1156.1600950492,
          lon: 51.4082983,
          lat: 35.7063006,
        },
      ],
    },
    PHARMACY: {
      title: "PHARMACY",
      id: 404,
      value: [
        {
          name: "داروخانه",
          dist: 292.879967258113,
          lon: 51.3984567,
          lat: 35.7089196,
        },
        {
          name: "داروخانه دکتر غفوری",
          dist: 534.159992641765,
          lon: 51.4010259,
          lat: 35.709585,
        },
        {
          name: "داروخانه فرانس پاستور",
          dist: 723.319057463895,
          lon: 51.4035392,
          lat: 35.7067076,
        },
      ],
    },
    CNG: {
      title: "CNG",
      id: 205,
      value: [
        {
          name: "جایگاه گاز طبیعی بیهقی",
          dist: 3752.25657088839,
          lon: 51.418992,
          lat: 35.7355774,
        },
        {
          name: "جایگاه CNG",
          dist: 5162.18823828324,
          lon: 51.366439,
          lat: 35.6676671,
        },
        {
          name: "جایگاه CNG فدایان اسلام",
          dist: 8554.51614228776,
          lon: 51.4348101,
          lat: 35.637478,
        },
      ],
    },
    GYM: {
      title: "GYM",
      id: 405,
      value: [
        {
          name: "فدراسیون شطرنج",
          dist: 496.881962466303,
          lon: 51.3950676,
          lat: 35.7120919,
        },
        {
          name: "مجموعه فرهنگی و ورزشی شهرد خت",
          dist: 532.096451433996,
          lon: 51.3900626,
          lat: 35.7060899,
        },
        {
          name: "باشگاه اندیشه",
          dist: 754.207657121102,
          lon: 51.4004817,
          lat: 35.7021113,
        },
      ],
    },
    HOTEL: {
      title: "HOTEL",
      id: 409,
      value: [
        {
          name: "هتل",
          dist: 191.910233449935,
          lon: 51.3935117,
          lat: 35.7075261,
        },
        {
          name: "رستوران هتل",
          dist: 199.568297975788,
          lon: 51.3934324,
          lat: 35.7074686,
        },
        {
          name: "هتل امید",
          dist: 501.713593544614,
          lon: 51.3907651,
          lat: 35.7054655,
        },
      ],
    },
    PARK: {
      title: "PARK",
      id: 403,
      value: [
        {
          name: "بوستان لاله",
          dist: 424.865538525265,
          lon: 51.3928453669202,
          lat: 35.7107211902308,
        },
        {
          name: null,
          dist: 955.434488595044,
          lon: 51.4044202172193,
          lat: 35.7124046365648,
        },
        {
          name: "بوستان اقاقیا",
          dist: 1213.37806974252,
          lon: 51.3851997265862,
          lat: 35.7145114153696,
        },
      ],
    },
    POOL: {
      title: "POOL",
      id: 406,
      value: [
        {
          name: "استخر سازمان آب",
          dist: 819.498250804448,
          lon: 51.3942338724952,
          lat: 35.7149349079197,
        },
        {
          name: "استخر آریان",
          dist: 1608.38769071063,
          lon: 51.378342600131,
          lat: 35.7110110003574,
        },
        {
          name: null,
          dist: 1721.05027107105,
          lon: 51.4107965957863,
          lat: 35.698281378283,
        },
      ],
    },
    SCHOOL: {
      title: "SCHOOL",
      id: 401,
      value: [
        {
          name: "دانشگاه علوم پزشکی و خدمات بهداشتی درمانی تهران",
          dist: 50.2021738736061,
          lon: 51.3951856996604,
          lat: 35.707910100171,
        },
        {
          name: "مدرسه سعیدی",
          dist: 295.373464975109,
          lon: 51.3960583001505,
          lat: 35.7102758999129,
        },
        {
          name: "مدرسه نرجس",
          dist: 439.047526487466,
          lon: 51.4003769003737,
          lat: 35.706827200415,
        },
      ],
    },
    SHOP: {
      title: "SHOP",
      id: 407,
      value: [
        {
          name: "سوپر مارکت یاس",
          dist: 381.425046979719,
          lon: 51.3982974,
          lat: 35.7102974,
        },
        {
          name: "سوپر مارکت زنجیره\u200cای جانبو",
          dist: 388.668086323266,
          lon: 51.3981237,
          lat: 35.7104879,
        },
        {
          name: "دامداران",
          dist: 401.108771444689,
          lon: 51.3985182,
          lat: 35.7048962,
        },
      ],
    },
    ZOO: {
      title: "ZOO",
      id: 410,
      value: [
        {
          name: "باغ پرندگان",
          dist: 3181.59287283162,
          lon: 51.4148274,
          lat: 35.6836168,
        },
      ],
    },
    TARH: {
      title: "TARH",
      id: 203,
      value: [
        {
          name: "زوج و فرد",
          state: true,
        },
        {
          name: "آلودگی هوا",
          state: true,
        },
      ],
    },
    terafic: {
      title: "terafic",
      id: 201,
      value: 39,
    },
  },
];

// ==========================================================================

// const FirstData = {
//   // status: "200",
//   terafic: ["2", "1"],
//   TARH: [
//     { name: "teraffic", state: true },
//     { name: "zojfard", state: false },
//   ],
//   FUEL: [
//     {
//       name: "پمپ بنزین وصال",
//       dist: 51.4006007254432,
//       lon: 35.7013851913736,
//       lat: 830.382521518651,
//     },
//     {
//       name: "جایگاه شرکتی شماره ۲۲",
//       dist: 51.3898334114828,
//       lon: 35.7174325905416,
//       lat: 1203.99872605352,
//     },
//   ], //حمل و نقل شخصی
//   CNG: [
//     {
//       name: null,
//       dist: 51.3978047610809,
//       lon: 35.7085992209773,
//       lat: 230.149516033916,
//     },
//     {
//       name: null,
//       dist: 51.3977517496436,
//       lon: 35.7103362498181,
//       lat: 359.747774678179,
//     },
//     {
//       name: null,
//       dist: 51.3994320294647,
//       lon: 35.7102696352355,
//       lat: 456.807536379685,
//     },
//   ], //حمل و نقل شخصی
//   // TRAFIC: "TRUE", //حمل و نقل شخصی
//   // BUSY: 39, //حمل و نقل شخصی

//   BRT: [
//     {
//       name: "میدان انقلاب - سامانه ۱ تندرو",
//       line: "1",
//       lon: 51.3925198,
//       lat: 35.7009754,
//       dist: 788.247093349294,
//     },
//     {
//       name: "دانشگاه تهران - سامانه ۱ تندرو",
//       line: "1",
//       lon: 51.3999952,
//       lat: 35.7011279,
//       dist: 826.364997149336,
//     },
//     {
//       name: "طالقانی، شمال به جنوب - سامانه ۷ تندرو",
//       line: "7",
//       lon: 51.4061266,
//       lat: 35.7070521,
//       dist: 959.047899768336,
//     },
//   ], //حمل و نقل عمومی
//   taxi: [
//     {
//       dist: 705.38091457,
//       name: "ایستگاه تاکسی انقلاب - ونک",
//       lon: 51.3905766,
//       lat: 35.702745,
//     },
//     {
//       dist: 1635.080411,
//       name: "فاطمی - میدان صنعت",
//       lon: 51.4040623,
//       lat: 35.7206154,
//     },
//     {
//       dist: 1888.71183692,
//       name: null,
//       lon: 51.4144708,
//       lat: 35.7148848,
//     },
//   ], //حمل و نقل عمومی
//   metro: [
//     {
//       dist: 811.35251985,
//       name: "میدان انقلاب اسلامی",
//       lon: 51.3919374,
//       lat: 35.7009551,
//     },
//     {
//       dist: 1120.4224578,
//       name: "تئاترشهر",
//       lon: 51.4052124,
//       lat: 35.7013101,
//     },
//     {
//       dist: 1125.26896422,
//       name: "میدان ولیعصر",
//       lon: 51.4070144,
//       lat: 35.7116098,
//     },
//   ], //حمل و نقل عمومی
//   BUS: [
//     {
//       dist: 151.0546173165236,
//       name: "حجاب",
//       lon: 535862.4483,
//       lat: 3951721.2922,
//     },
//     {
//       dist: 221.6204034161683,
//       name: "شانزده آذر",
//       lon: 535560.1996,
//       lat: 3951581.2339,
//     },
//     {
//       dist: 256.8192041122344,
//       name: "وصال",
//       lon: 535996.4992,
//       lat: 3951734.1953,
//     },
//   ], //حمل و نقل عمومی
//   BUSLINE: [
//     {
//       dist: 5.421776186369631,
//       source: "پایانه شهید براری",
//       destination: "میدان ولی\u200cعصرعج",
//       coor: {
//         type: "MultiLineString",
//         coordinates: [
//           [
//             [544477.8169, 3950020.7301],
//             [544476.4936, 3950015.2247],
//             [544474.2821, 3950014.8744],
//             [544454.1737, 3950011.4348],
//             [544443.8734, 3950009.5608],
//             [544439.107276615, 3950005.17292985],
//             [544434.0965, 3950001.3711],
//             [544429.465346659, 3949998.48768327],
//             [544424.575795543, 3949995.98161102],
//             [544419.427846655, 3949993.85288326],
//             [544414.0215, 3949992.1015],
//             [544367.9424, 3949989.9295],
//             [544346.5278, 3949987.8521],
//             [544321.7224, 3949985.7864],
//             [544276.2824, 3949982.0023],
//             [544221.8258, 3949977.4673],
//             [544208.4898, 3949970.1494],
//             [544193.938, 3949974.9088],
//             [544017.4133, 3949957.0258],
//             [543883.7073, 3949942.1637],
//             [543876.1165, 3949936.2494],
//             [543867.4073, 3949940.5316],
//             [543798.9793, 3949934.4288],
//             [543695.64, 3949924.2848],
//             [543471.2083, 3949902.9852],
//             [543424.8488, 3949898.152],
//             [543325.2683, 3949887.0153],
//             [543313.8515, 3949880.0965],
//             [543296.1066, 3949885.0719],
//             [543092.5536, 3949865.3062],
//             [543051.3851, 3949862.2325],
//             [542970.4217, 3949854.8816],
//             [542881.7957, 3949847.682],
//             [542811.8213, 3949840.7285],
//             [542671.6914, 3949826.8034],
//             [542538.9465, 3949814.3553],
//             [542347.155, 3949793.5718],
//             [542284.3997, 3949786.7713],
//             [542196.8311, 3949778.3957],
//             [542094.3331, 3949766.0744],
//             [542073.9056, 3949757.797],
//             [542049.8625, 3949760.3488],
//             [541977.1055, 3949751.1563],
//             [541933.781, 3949747.1265],
//             [541881.1786, 3949741.4758],
//             [541799.1741, 3949731.5426],
//             [541725.6666, 3949727.3997],
//             [541716.2144, 3949721.1306],
//             [541705.0291, 3949725.9445],
//             [541684.9727, 3949724.4761],
//             [541653.0978, 3949722.1426],
//             [541583.9108, 3949716.7353],
//             [541556.9945, 3949715.1067],
//             [541476.3167, 3949708.5572],
//             [541421.9275, 3949705.8217],
//             [541375.3847, 3949702.8447],
//             [541371.6297, 3949702.6045],
//             [541351.411, 3949701.3113],
//             [541346.6639, 3949701.0077],
//             [541286.8424, 3949697.1812],
//             [541154.3507, 3949685.1797],
//             [540998.1182, 3949670.3277],
//             [540905.8276, 3949662.2921],
//             [540902.8207, 3949662.8506],
//             [540900.261, 3949663.6293],
//             [540899.0639, 3949664.0306],
//             [540897.9935, 3949664.5236],
//             [540896.62, 3949665.1562],
//             [540895.4377, 3949665.7007],
//             [540894.1286, 3949666.5782],
//             [540892.8709, 3949667.4212],
//             [540891.7954, 3949668.3561],
//             [540890.1846, 3949669.7562],
//             [540889.2891, 3949670.7891],
//             [540888.2224, 3949672.0194],
//             [540887.201, 3949673.4437],
//             [540886.4948, 3949674.6865],
//             [540885.33, 3949676.7367],
//             [540883.7225, 3949680.7856],
//             [540882.5965, 3949684.9078],
//             [540867.3696, 3949847.1385],
//             [540864.3733, 3949879.025],
//             [540860.0355, 3949925.2093],
//             [540782.7309, 3949919.4557],
//             [540704.7425, 3949913.6745],
//             [540683.7685, 3949911.6607],
//             [540642.7719, 3949907.7396],
//             [540487.9845, 3949894.4205],
//             [540484.6508, 3949863.4007],
//             [540480.6807, 3949796.2861],
//             [540480.2672, 3949789.3782],
//             [540476.6074, 3949715.657],
//             [540474.546, 3949666.7755],
//             [540471.6177, 3949660.8911],
//             [540470.0074, 3949658.087],
//             [540468.8638, 3949656.2388],
//             [540465.9104, 3949651.9131],
//             [540463.3984, 3949648.6486],
//             [540459.1419, 3949643.7959],
//             [540455.2987, 3949640.0032],
//             [540448.7052, 3949634.5175],
//             [540437.9083, 3949627.6842],
//             [540431.7842, 3949625.7775],
//             [540425.585, 3949624.3766],
//             [540409.1998, 3949627.1401],
//             [540384.1443, 3949633.5294],
//             [540365.5245, 3949639.061],
//             [540339.7528, 3949651.3066],
//             [540321.2137, 3949664.2579],
//             [540287.6004, 3949692.5732],
//             [540263.3082, 3949717.9453],
//             [540217.7552, 3949770.1117],
//             [540204.4034, 3949785.2862],
//             [540175.9955, 3949814.9418],
//             [540163.1368, 3949826.1337],
//             [540145.9361, 3949838.4925],
//             [540132.2334, 3949846.0833],
//             [540112.2308, 3949851.5866],
//             [540092.6864, 3949856.1847],
//             [540001.3564, 3949867.1628],
//             [539917.4289, 3949878.0887],
//             [539837.2989, 3949888.7326],
//             [539789.4757, 3949894.9904],
//             [539719.7815, 3949904.7508],
//             [539719.6032, 3949904.7758],
//             [539669.5891, 3949911.78],
//             [539589.9581, 3949924.3587],
//             [539583.6539, 3949925.0342],
//             [539580.1779, 3949925.3105],
//             [539578.1693, 3949925.433],
//             [539576.2579, 3949925.5243],
//             [539573.8827, 3949925.6036],
//             [539570.6279, 3949925.6509],
//             [539564.9899, 3949926.0586],
//             [539556.3895, 3949926.4091],
//             [539552.5499, 3949926.5001],
//             [539549.1786, 3949926.5404],
//             [539543.0942, 3949926.5194],
//             [539537.3334, 3949926.3882],
//             [539532.1714, 3949926.1787],
//             [539528.2881, 3949925.9637],
//             [539522.2213, 3949925.5287],
//             [539452.4805, 3949937.4137],
//             [539407.4871, 3949945.0814],
//             [539254.088, 3949964.5349],
//             [539242.8974, 3949963.3673],
//             [539235.3404, 3949961.5794],
//             [539228.5167, 3949958.8543],
//             [539223.6823, 3949956.1773],
//             [539217.9103, 3949951.9742],
//             [539213.0012, 3949947.2553],
//             [539210.6491, 3949944.4804],
//             [539201.6946, 3949932.3589],
//             [539197.132, 3949924.1396],
//             [539174.4461, 3949832.8061],
//             [539154.4679, 3949763.0588],
//             [539148.6508, 3949729.9295],
//             [539143.832279321, 3949727.82301759],
//             [539138.960522427, 3949726.13802346],
//             [539134.03552932, 3949724.87451759],
//             [539129.0573, 3949724.0325],
//             [539124.03605687, 3949723.61239552],
//             [539118.961792496, 3949723.61207737],
//             [539113.834506875, 3949724.03154552],
//             [539108.6542, 3949724.8708],
//             [539102.258835677, 3949729.47332186],
//             [539095.6191, 3949733.6564],
//             [539087.890063665, 3949737.84468636],
//             [539079.8543, 3949741.5065],
//             [539011.4736, 3949763.1462],
//             [538961.1974, 3949768.8523],
//             [538942.3458, 3949769.8445],
//             [538929.7781, 3949771.1674],
//             [538912.3596, 3949777.1834],
//             [538863.147, 3949799.4085],
//             [538822.9303, 3949817.9293],
//             [538777.951, 3949837.5085],
//             [538747.2593, 3949851.0023],
//             [538700.8513, 3949871.3753],
//             [538650.0512, 3949893.7591],
//             [538541.0956, 3949942.3896],
//             [538412.5076, 3950000.2566],
//             [538404.7284, 3950003.7574],
//             [538400.8132, 3950005.5193],
//             [538333.4501, 3950034.8881],
//             [538242.2216, 3950074.0465],
//             [538137.711, 3950117.2266],
//             [538076.3276, 3950141.5683],
//             [537978.0785, 3950183.9296],
//             [537977.0158, 3950183.9721],
//             [537972.3101, 3950184.1601],
//             [537954.9365, 3950184.8542],
//             [537867.0144, 3950190.1037],
//             [537751.55, 3950196.242],
//             [537609.0557, 3950204.8146],
//             [537520.4095, 3950209.1537],
//             [537482.1223, 3950211.1381],
//             [537418.0791, 3950212.9637],
//             [537381.2922, 3950215.3474],
//             [537281.8713, 3950221.7744],
//             [537171.8573, 3950228.4419],
//             [537138.996, 3950229.5531],
//             [537108.3504, 3950229.953],
//             [537055.9696, 3950234.6332],
//             [537014.8533, 3950237.0144],
//             [536899.6006, 3950241.9357],
//             [536796.0953, 3950248.9207],
//             [536684.3351, 3950256.0644],
//             [536593.8474, 3950260.5095],
//             [536476.2135, 3950267.3357],
//             [536349.372, 3950274.6382],
//             [536194.5904, 3950284.322],
//             [536149.3466, 3950286.0683],
//             [536050.1276, 3950293.3708],
//             [535972.7512, 3950299.2348],
//             [535979.416, 3950360.6139],
//             [535979.6674, 3950362.9049],
//             [535983.7, 3950400.0277],
//             [535987.351, 3950433.5647],
//             [535994.103, 3950491.1572],
//             [535994.7246, 3950496.327],
//             [536001.8797, 3950557.486],
//             [536006.6572, 3950598.1754],
//             [536008.0965, 3950610.5714],
//             [536014.9462, 3950668.7141],
//             [536020.1892, 3950715.3358],
//             [536025.0322, 3950758.4376],
//             [536029.2678, 3950796.2301],
//             [536032.7072, 3950869.9239],
//             [535981.2439, 3951024.2565],
//             [535953.0316, 3951103.0363],
//             [535937.7207, 3951145.7932],
//             [535927.7277, 3951173.2487],
//             [535904.2109, 3951237.8444],
//             [535891.3647, 3951273.2975],
//             [535872.2114, 3951326.3488],
//             [535849.9995, 3951387.8811],
//             [535826.0481, 3951454.2669],
//             [535806.9072, 3951507.2302],
//             [535797.0142, 3951534.5359],
//             [535783.4007, 3951572.3855],
//             [535771.0792, 3951606.6303],
//             [535757.3422, 3951644.7772],
//             [535750.4029, 3951664.304],
//             [535774.2649, 3951655.7417],
//             [535921.0322, 3951706.7432],
//             [535927.5601, 3951728.4101],
//             [535945.6157, 3951716.283],
//             [536063.3964, 3951757.7448],
//             [536067.6027, 3951778.0772],
//             [536089.0806, 3951765.0831],
//             [536356.0261, 3951857.0692],
//             [536550.6635, 3951929.4625],
//             [536568.1942, 3951953.7913],
//             [536604.9077, 3951945.3685],
//             [536676.0498, 3951969.8145],
//           ],
//         ],
//       },
//     },
//     {
//       dist: 5.421776186369631,
//       source: "میدان خراسان",
//       destination: "میدان انقلاب اسلامی",
//       coor: {
//         type: "MultiLineString",
//         coordinates: [
//           [
//             [540333.0785, 3947042.3231],
//             [540332.7407, 3947036.6413],
//             [540330.6134, 3947000.8463],
//             [540330.3097, 3946995.7476],
//             [540327.2574, 3946955.0685],
//             [540322.5097, 3946954.8482],
//             [540318.3248, 3946952.9722],
//             [540314.6222, 3946950.9134],
//             [540311.6776, 3946948.6146],
//             [540308.2714, 3946944.9252],
//             [540305.187, 3946939.9433],
//             [540302.8502, 3946933.3613],
//             [540302.099, 3946928.3631],
//             [540302.0465, 3946924.8377],
//             [540302.6001, 3946920.0677],
//             [540303.9632, 3946915.188],
//             [540306.7618, 3946909.5333],
//             [540310.1921, 3946905.1616],
//             [540313.9329, 3946901.934],
//             [540318.434, 3946899.3924],
//             [540323.0917, 3946897.9139],
//             [540326.5371, 3946897.4625],
//             [540331.3575, 3946897.692],
//             [540335.9102, 3946898.8545],
//             [540340.0782, 3946900.828],
//             [540346.128, 3946905.773],
//             [540349.5478, 3946910.3859],
//             [540352.1384, 3946915.9457],
//             [540361.0492, 3946916.6193],
//             [540367.1347, 3946916.6193],
//             [540386.8462, 3946913.7089],
//             [540468.6277, 3946901.7333],
//             [540492.5065, 3946898.2367],
//             [540505.449, 3946896.4817],
//             [540513.9045, 3946895.148],
//             [540665.3423, 3946873.7613],
//             [540697.4892, 3946868.9988],
//             [540721.3018, 3946864.6332],
//             [540741.9393, 3946857.8863],
//             [540744.6681, 3946855.9601],
//             [540755.4331, 3946848.3613],
//             [540792.7768, 3946820.3195],
//             [540816.8639, 3946800.5147],
//             [540861.5115, 3946763.8046],
//             [540878.3965, 3946760.8532],
//             [540888.0406, 3946768.665],
//             [540889.6304, 3946775.5592],
//             [540901.2511, 3946824.9223],
//             [540906.5595, 3946847.4881],
//             [540910.5004, 3946864.2273],
//             [540916.0405, 3946887.7584],
//             [540920.0791, 3946904.9311],
//             [540925.2791, 3946927.0416],
//             [540929.4528, 3946944.7779],
//             [540934.6854, 3946967.0141],
//             [540939.314, 3946986.6463],
//             [540949.7822, 3947034.3021],
//             [540955.2771, 3947059.3267],
//             [540965.8566, 3947107.4853],
//             [540972.2271, 3947138.424],
//             [540977.0703, 3947161.9491],
//             [540984.8111, 3947199.5114],
//             [540954.3739, 3947203.4116],
//             [540930.3457, 3947206.4665],
//             [540908.9282, 3947209.1987],
//             [540906.7647, 3947209.4746],
//             [540864.4447, 3947214.4389],
//             [540828.7201, 3947219.4051],
//             [540777.9159, 3947225.2885],
//             [540754.2324, 3947228.0266],
//             [540732.7841, 3947230.5225],
//             [540710.0316, 3947233.158],
//             [540703.3357, 3947233.9311],
//             [540673.0211, 3947237.4412],
//             [540625.0761, 3947242.9911],
//             [540624.499, 3947243.0581],
//             [540610.6969, 3947244.6507],
//             [540606.3756, 3947245.1723],
//             [540574.8502, 3947248.9719],
//             [540553.7838, 3947251.5145],
//             [540551.7534, 3947251.7567],
//             [540521.2963, 3947255.4279],
//             [540487.7157, 3947259.4755],
//             [540449.5875, 3947263.1839],
//             [540445.6015, 3947263.5659],
//             [540424.7677, 3947265.5867],
//             [540362.7736, 3947271.2937],
//             [540357.7762, 3947275.7347],
//             [540355.5059, 3947278.9221],
//             [540354.2026, 3947282.9428],
//             [540353.3438, 3947287.6411],
//             [540356.2717, 3947337.9129],
//             [540357.7185, 3947363.6977],
//             [540360.0609, 3947405.4439],
//             [540361.8242, 3947436.8662],
//             [540363.6021, 3947468.546],
//             [540366.1803, 3947514.4925],
//             [540369.0821, 3947566.2057],
//             [540369.7446, 3947577.9215],
//             [540370.2996, 3947587.8162],
//             [540373.0401, 3947636.6754],
//             [540373.0717, 3947637.2404],
//             [540374.1469, 3947656.4135],
//             [540377.7813, 3947727.5423],
//             [540382.4232, 3947781.1668],
//             [540382.9454, 3947790.4148],
//             [540383.3026, 3947796.7399],
//             [540383.251, 3947840.0589],
//             [540383.2411, 3947848.3503],
//             [540383.1994, 3947883.3719],
//             [540383.6892, 3947906.3915],
//             [540386.6279, 3947955.8592],
//             [540390.9594, 3947980.7071],
//             [540392.9961, 3948018.6231],
//             [540398.1717, 3948114.8161],
//             [540398.7996, 3948124.0344],
//             [540401.8733, 3948169.1565],
//             [540404.6392, 3948214.2224],
//             [540407.6323, 3948270.6263],
//             [540407.7208, 3948272.2931],
//             [540409.9694, 3948314.7909],
//             [540410.0582, 3948316.465],
//             [540412.6939, 3948366.0952],
//             [540415.2172, 3948413.7539],
//             [540408.52, 3948425.3863],
//             [540416.2844, 3948437.4289],
//             [540418.8111, 3948513.0899],
//             [540420.9263, 3948535.1865],
//             [540423.3883, 3948560.9051],
//             [540424.9376, 3948592.4359],
//             [540427.4549, 3948644.0761],
//             [540430.106, 3948698.2013],
//             [540432.452, 3948735.4137],
//             [540425.1543, 3948746.1561],
//             [540433.0676, 3948754.2533],
//             [540434.0351, 3948774.8712],
//             [540434.1428, 3948777.1688],
//             [540435.6737, 3948805.1984],
//             [540435.7155, 3948805.9669],
//             [540436.8364, 3948825.967],
//             [540438.2545, 3948851.2686],
//             [540438.5522, 3948856.5804],
//             [540438.9083, 3948862.9333],
//             [540440.6809, 3948894.5487],
//             [540441.5965, 3948910.8762],
//             [540442.8581, 3948933.3848],
//             [540442.9129, 3948934.351],
//             [540444.6181, 3948964.429],
//             [540452.3545, 3949105.1265],
//             [540456.497, 3949180.465],
//             [540449.7627, 3949191.7266],
//             [540457.9029, 3949202.7808],
//             [540462.2193, 3949275.7968],
//             [540464.2786, 3949312.6536],
//             [540466.1977, 3949347.1131],
//             [540466.2432, 3949347.744],
//             [540466.8234, 3949363.9817],
//             [540467.8754, 3949397.6225],
//             [540469.2041, 3949420.6126],
//             [540470.7149, 3949446.7587],
//             [540472.679, 3949490.2547],
//             [540474.5321, 3949531.2945],
//             [540474.5609, 3949531.8595],
//             [540475.3649, 3949571.18],
//             [540478.0835, 3949576.5511],
//             [540480.1922, 3949580.2026],
//             [540481.7739, 3949588.9356],
//             [540485.7427, 3949594.7564],
//             [540491.5636, 3949602.1648],
//             [540496.3261, 3949607.1919],
//             [540502.1469, 3949610.8961],
//             [540512.0604, 3949615.7218],
//             [540521.9222, 3949622.7832],
//             [540531.2511, 3949628.3586],
//             [540535.6453, 3949628.6467],
//             [540547.3907, 3949629.4169],
//             [540698.3811, 3949638.6781],
//             [540715.4257, 3949644.9342],
//             [540735.8304, 3949648.1516],
//             [540751.3248, 3949649.7549],
//             [540863.0719, 3949657.2482],
//             [540866.2434, 3949657.6813],
//             [540867.9371, 3949658.1133],
//             [540869.9154, 3949658.8094],
//             [540871.6257, 3949659.5938],
//             [540873.3277, 3949660.5649],
//             [540874.6452, 3949661.4671],
//             [540876.5598, 3949663.0623],
//             [540877.3677, 3949663.9293],
//             [540878.592, 3949665.2435],
//             [540880.0345, 3949667.2451],
//             [540880.9757, 3949668.8379],
//             [540881.5726, 3949670.1003],
//             [540882.5566, 3949672.7901],
//             [540883.0408, 3949674.7772],
//             [540883.3758, 3949677.2597],
//             [540882.5965, 3949684.9078],
//             [540867.3696, 3949847.1385],
//             [540869.3817, 3949877.1444],
//             [540865.9582, 3949888.8555],
//             [540862.4654, 3949900.8035],
//             [540858.6819, 3949914.8595],
//             [540848.8, 3949921.5387],
//             [540832.5145, 3949929.2728],
//             [540802.9955, 3949923.0599],
//             [540782.7309, 3949919.4557],
//             [540704.7425, 3949913.6745],
//             [540683.7685, 3949911.6607],
//             [540642.7719, 3949907.7396],
//             [540487.9845, 3949894.4205],
//             [540484.6508, 3949863.4007],
//             [540480.6807, 3949796.2861],
//             [540480.2672, 3949789.3782],
//             [540476.6074, 3949715.657],
//             [540474.546, 3949666.7755],
//             [540471.6177, 3949660.8911],
//             [540470.0074, 3949658.087],
//             [540468.8638, 3949656.2388],
//             [540465.9104, 3949651.9131],
//             [540463.3984, 3949648.6486],
//             [540459.1419, 3949643.7959],
//             [540455.2987, 3949640.0032],
//             [540448.7052, 3949634.5175],
//             [540437.9083, 3949627.6842],
//             [540431.7842, 3949625.7775],
//             [540425.585, 3949624.3766],
//             [540409.1998, 3949627.1401],
//             [540384.1443, 3949633.5294],
//             [540365.5245, 3949639.061],
//             [540339.7528, 3949651.3066],
//             [540321.2137, 3949664.2579],
//             [540287.6004, 3949692.5732],
//             [540263.3082, 3949717.9453],
//             [540217.7552, 3949770.1117],
//             [540204.4034, 3949785.2862],
//             [540175.9955, 3949814.9418],
//             [540163.1368, 3949826.1337],
//             [540145.9361, 3949838.4925],
//             [540132.2334, 3949846.0833],
//             [540112.2308, 3949851.5866],
//             [540092.6864, 3949856.1847],
//             [540001.3564, 3949867.1628],
//             [539917.4289, 3949878.0887],
//             [539837.2989, 3949888.7326],
//             [539789.4757, 3949894.9904],
//             [539719.7815, 3949904.7508],
//             [539719.6032, 3949904.7758],
//             [539669.5891, 3949911.78],
//             [539589.9581, 3949924.3587],
//             [539583.6539, 3949925.0342],
//             [539580.1779, 3949925.3105],
//             [539578.1693, 3949925.433],
//             [539576.2579, 3949925.5243],
//             [539573.8827, 3949925.6036],
//             [539570.6279, 3949925.6509],
//             [539564.9899, 3949926.0586],
//             [539526.2059, 3949931.7993],
//             [539452.4805, 3949937.4137],
//             [539407.4871, 3949945.0814],
//             [539254.088, 3949964.5349],
//             [539252.1663, 3949965.4646],
//             [539250.3765, 3949966.3305],
//             [539248.2436, 3949967.3624],
//             [539245.6432, 3949968.6205],
//             [539243.7558, 3949969.5336],
//             [539242.3336, 3949970.3554],
//             [539240.5719, 3949971.3734],
//             [539238.6941, 3949972.9864],
//             [539236.8119, 3949974.6033],
//             [539234.5697, 3949977.3902],
//             [539233.3001, 3949979.7017],
//             [539231.7988, 3949983.0696],
//             [539231.0303, 3949985.9233],
//             [539230.5859, 3949988.5032],
//             [539231.1684, 3949992.194],
//             [539232.0432, 3949994.1984],
//             [539232.9306, 3949996.2318],
//             [539233.7447, 3949998.0972],
//             [539234.8819, 3950000.7028],
//             [539235.9557, 3950003.1633],
//             [539236.8809, 3950005.0538],
//             [539238.0456, 3950007.4337],
//             [539239.2735, 3950009.9425],
//             [539240.6205, 3950012.6948],
//             [539242.7276, 3950017.0003],
//             [539246.5072, 3950024.7856],
//             [539312.884, 3950162.334],
//             [539312.9338, 3950162.4373],
//             [539358.4061, 3950254.4566],
//             [539388.4288, 3950314.0478],
//             [539396.2635, 3950331.2633],
//             [539396.2734, 3950331.2849],
//             [539439.3921, 3950426.0313],
//             [539439.5917, 3950426.4698],
//             [539455.207, 3950458.5467],
//             [539491.2719, 3950532.6311],
//             [539494.6918, 3950553.1912],
//             [539506.7279, 3950566.0726],
//             [539532.7584, 3950624.3296],
//             [539568.9444, 3950700.1094],
//             [539618.8115, 3950804.127],
//             [539624.319, 3950824.3888],
//             [539670.2863, 3950963.0935],
//             [539672.0462, 3950968.404],
//             [539674.9706, 3950977.2281],
//             [539710.3468, 3951083.9745],
//             [539721.4351, 3951110.6488],
//             [539732.4653, 3951151.8901],
//             [539734.6981, 3951160.2384],
//             [539745.1085, 3951193.8224],
//             [539754.344, 3951222.352],
//             [539767.3474, 3951262.5212],
//             [539788.6992, 3951331.9302],
//             [539803.7764, 3951381.5868],
//             [539811.1672, 3951403.5448],
//             [539819.7471, 3951430.0992],
//             [539824.1763, 3951443.8073],
//             [539828.9202, 3951458.4896],
//             [539832.866791524, 3951458.36080635],
//             [539836.7987, 3951458.5065],
//             [539840.4782, 3951458.8933],
//             [539844.35372868, 3951459.61515954],
//             [539847.616, 3951460.5597],
//             [539851.80422224, 3951462.45196821],
//             [539856.4976, 3951465.3654],
//             [539861.0655, 3951468.9343],
//             [539863.151338989, 3951470.94910878],
//             [539865.0922, 3951473.1041],
//             [539866.877583526, 3951475.38982389],
//             [539868.4995, 3951477.7937],
//             [539869.949046917, 3951480.30519096],
//             [539871.2208, 3951482.9119],
//             [539872.322619321, 3951485.63622634],
//             [539873.2035, 3951488.3591],
//             [539873.8968419, 3951491.20973037],
//             [539874.3698, 3951494.0678],
//             [539874.605841584, 3951496.83003386],
//             [539874.6579, 3951499.9669],
//             [539874.2534, 3951505.7495],
//             [539873.726, 3951508.7171],
//             [539872.676806121, 3951512.58654234],
//             [539871.2321, 3951516.3568],
//             [539869.896535995, 3951519.23745104],
//             [539868.3443, 3951521.9849],
//             [539866.748066017, 3951524.35823789],
//             [539864.937, 3951526.6745],
//             [539862.996292837, 3951528.82926535],
//             [539860.9102, 3951530.8443],
//             [539858.687914717, 3951532.70868201],
//             [539856.3425, 3951534.4133],
//             [539853.883399366, 3951535.94940969],
//             [539851.3223, 3951537.3115],
//             [539848.672460646, 3951538.49091394],
//             [539845.9477, 3951539.4831],
//             [539843.043084213, 3951540.32091964],
//             [539840.3231, 3951540.8855],
//             [539836.821117165, 3951541.27607778],
//             [539833.265, 3951541.3145],
//             [539828.765, 3951541.1339],
//             [539825.949780073, 3951540.74425928],
//             [539823.0562, 3951540.1273],
//             [539820.268986809, 3951539.3275987],
//             [539817.5432, 3951538.3358],
//             [539814.893488756, 3951537.15571163],
//             [539812.3333, 3951535.7949],
//             [539809.874586683, 3951534.25798377],
//             [539807.5277, 3951532.5532],
//             [539805.306256878, 3951530.68869431],
//             [539803.2199, 3951528.6745],
//             [539801.27937407, 3951526.51891128],
//             [539799.4937, 3951524.2341],
//             [539797.845197562, 3951521.79250051],
//             [539796.4218, 3951519.3181],
//             [539795.184254576, 3951516.73866037],
//             [539794.1331, 3951514.0611],
//             [539730.4998, 3951528.6251],
//             [539639.4729, 3951552.46],
//             [539631.6456, 3951557.5846],
//             [539626.0964, 3951563.2266],
//             [539624.1914, 3951567.8304],
//             [539622.6039, 3951572.7516],
//             [539620.0997, 3951585.5992],
//             [539618.4658, 3951720.028],
//             [539617.6262, 3951789.8779],
//             [539593.1247, 3951795.5676],
//             [539588.9057, 3951796.5365],
//             [539552.0347, 3951805.1046],
//             [539535.4757, 3951808.9415],
//             [539428.4312, 3951835.7539],
//             [539399.1395, 3951782.7061],
//             [539395.442, 3951776.0006],
//             [539393.5421, 3951772.8156],
//             [539364.5409, 3951724.2562],
//             [539364.1311, 3951723.567],
//             [539329.2064, 3951665.0615],
//             [539320.7199, 3951650.8601],
//             [539301.9838, 3951619.4361],
//             [539274.7475, 3951573.7111],
//             [539263.4781, 3951560.259],
//             [539254.925, 3951559.4931],
//             [539247.1766, 3951559.2244],
//             [539236.4666, 3951559.0949],
//             [539221.2361, 3951558.7995],
//             [539205.9219, 3951558.2139],
//             [539179.685, 3951556.3749],
//             [539152.0655, 3951555.9401],
//             [539141.3298, 3951555.8627],
//             [539084.0381, 3951554.1115],
//             [539075.5476, 3951554.0221],
//             [539034.9864, 3951552.988],
//             [539003.6429, 3951552.0641],
//             [538977.7505, 3951551.1916],
//             [538963.0694, 3951550.6969],
//             [538884.8987, 3951548.0629],
//             [538850.1233, 3951547.577],
//             [538802.8125, 3951546.2108],
//             [538742.9191, 3951543.8788],
//             [538694.2875, 3951541.9853],
//             [538681.0855, 3951541.4797],
//             [538639.7099, 3951540.3958],
//             [538568.6431, 3951538.9502],
//             [538514.8778, 3951536.937],
//             [538437.7064, 3951534.2661],
//             [538405.9608, 3951533.4346],
//             [538387.7658, 3951532.9581],
//             [538314.0034, 3951530.7465],
//             [538228.746, 3951528.0145],
//             [538169.419, 3951526.6903],
//             [538087.5964, 3951524.4706],
//             [537972.2615, 3951521.604],
//             [537939.1327, 3951520.1029],
//             [537910.5577, 3951518.9388],
//             [537856.6646, 3951516.618],
//             [537843.1765, 3951515.871],
//             [537785.958, 3951513.6327],
//             [537774.9787, 3951513.7822],
//             [537734.0361, 3951511.8911],
//             [537698.6475, 3951511.4392],
//             [537638.4442, 3951508.8096],
//             [537584.2729, 3951506.8737],
//             [537576.5406, 3951499.9674],
//             [537566.6096, 3951507.0886],
//             [537372.6308, 3951500.0877],
//             [537301.127, 3951497.508],
//             [537291.4697, 3951497.2434],
//             [537285.1818, 3951497.0601],
//             [537178.6775, 3951493.9557],
//             [537155.8534, 3951493.4711],
//             [537103.5906, 3951491.6836],
//             [537059.272, 3951489.6968],
//             [537024.6763, 3951488.1832],
//             [536975.3468, 3951486.0877],
//             [536958.1056, 3951485.3463],
//             [536947.2184, 3951484.8781],
//             [536937.5105, 3951484.4749],
//             [536936.0407, 3951484.4333],
//             [536931.655, 3951484.309],
//             [536915.6964, 3951483.8569],
//             [536893.5058, 3951483.2283],
//             [536881.9185, 3951482.9001],
//             [536870.386, 3951482.5734],
//             [536860.6688, 3951482.2981],
//             [536849.6906, 3951482.017],
//             [536836.1472, 3951481.6034],
//             [536814.9947, 3951481.0042],
//             [536791.326, 3951480.3337],
//             [536774.8241, 3951479.8573],
//             [536749.6378, 3951478.0863],
//             [536730.3754, 3951467.2913],
//             [536712.8734, 3951478.0358],
//             [536632.8515, 3951476.9969],
//             [536532.2539, 3951474.01],
//             [536532.0163, 3951474.6247],
//             [536531.7649, 3951475.2301],
//             [536531.3971, 3951476.0402],
//             [536531.1223, 3951476.627],
//             [536530.8148, 3951477.2091],
//             [536530.3819, 3951477.9774],
//             [536529.9254, 3951478.7271],
//             [536529.5669, 3951479.2813],
//             [536529.1945, 3951479.8214],
//             [536528.8125, 3951480.3523],
//             [536528.4074, 3951480.8784],
//             [536527.8535, 3951481.5537],
//             [536527.4157, 3951482.0567],
//             [536526.9779, 3951482.5409],
//             [536526.5214, 3951483.0159],
//             [536526.0418, 3951483.4769],
//             [536525.4087, 3951484.0728],
//             [536524.7473, 3951484.6457],
//             [536524.0582, 3951485.1905],
//             [536523.3551, 3951485.7166],
//             [536522.6287, 3951486.2197],
//             [536521.8928, 3951486.6947],
//             [536521.3155, 3951487.0299],
//             [536520.752, 3951487.3559],
//             [536520.1699, 3951487.663],
//             [536519.5833, 3951487.9613],
//             [536518.7869, 3951488.3291],
//             [536517.9766, 3951488.6737],
//             [536517.3667, 3951488.9019],
//             [536516.7426, 3951489.1207],
//             [536515.9091, 3951489.3909],
//             [536515.0617, 3951489.6283],
//             [536514.2141, 3951489.8379],
//             [536513.5669, 3951489.9729],
//             [536512.9149, 3951490.0938],
//             [536512.3394, 3951490.1861],
//             [536511.7786, 3951490.2617],
//             [536511.0322, 3951490.3473],
//             [536510.1909, 3951490.4107],
//             [536509.3155, 3951490.4478],
//             [536508.6587, 3951490.4571],
//             [536507.7135, 3951490.4387],
//             [536507.0568, 3951490.4105],
//             [536506.4003, 3951490.3549],
//             [536505.5343, 3951490.2617],
//             [536504.8775, 3951490.1685],
//             [536504.2257, 3951490.0661],
//             [536503.3689, 3951489.8936],
//             [536502.7263, 3951489.7493],
//             [536502.0883, 3951489.5819],
//             [536501.2409, 3951489.3349],
//             [536500.6121, 3951489.1347],
//             [536499.9975, 3951488.9159],
//             [536499.1779, 3951488.6038],
//             [536498.3723, 3951488.2547],
//             [536497.5761, 3951487.882],
//             [536496.9893, 3951487.5886],
//             [536496.4072, 3951487.2766],
//             [536495.6483, 3951486.8343],
//             [536494.9077, 3951486.364],
//             [536494.3629, 3951485.9961],
//             [536493.8228, 3951485.6143],
//             [536493.2918, 3951485.223],
//             [536492.7797, 3951484.8134],
//             [536492.1093, 3951484.2498],
//             [536491.4572, 3951483.6585],
//             [536490.8241, 3951483.0438],
//             [536490.0399, 3951482.215],
//             [536489.4921, 3951481.5908],
//             [536488.8729, 3951480.8321],
//             [536488.4677, 3951480.3057],
//             [536488.0813, 3951479.7749],
//             [536487.5922, 3951479.0438],
//             [536487.2382, 3951478.4896],
//             [536486.8985, 3951477.9309],
//             [536486.4746, 3951477.1579],
//             [536486.0742, 3951476.3754],
//             [536485.7855, 3951475.7794],
//             [536485.5247, 3951475.1789],
//             [536485.2733, 3951474.5687],
//             [536485.0358, 3951473.9541],
//             [536484.7565, 3951473.1253],
//             [536484.5003, 3951472.2871],
//             [536484.2675, 3951471.4442],
//             [536484.0719, 3951470.5827],
//             [536483.9323, 3951469.9401],
//             [536483.825, 3951469.288],
//             [536483.6992, 3951468.4221],
//             [536483.6015, 3951467.5513],
//             [536483.5597, 3951466.8947],
//             [536483.5131, 3951465.9693],
//             [536483.5037, 3951465.1345],
//             [536475.103, 3951462.0911],
//             [536431.4707, 3951446.2844],
//             [536339.2139, 3951412.8501],
//             [536254.9015, 3951382.2467],
//             [536212.6378, 3951366.9824],
//             [536085.9336, 3951324.987],
//             [536071.5028, 3951311.8571],
//             [536053.5111, 3951313.7621],
//             [535916.486, 3951266.3875],
//             [535915.5652, 3951266.0568],
//             [535914.1947, 3951265.6335],
//             [535913.5226, 3951265.4324],
//             [535912.7077, 3951265.2313],
//             [535911.4326, 3951264.9846],
//             [535908.9877, 3951264.7715],
//             [535906.7995, 3951264.8184],
//             [535905.0501, 3951265.0304],
//             [535903.0889, 3951265.4592],
//             [535901.1755, 3951266.0853],
//             [535898.8558, 3951267.1516],
//             [535897.202, 3951268.1509],
//             [535896.0387, 3951268.9957],
//             [535894.6488, 3951270.1909],
//             [535891.3647, 3951273.2975],
//             [535872.2114, 3951326.3488],
//             [535849.9995, 3951387.8811],
//             [535826.0481, 3951454.2669],
//             [535806.9072, 3951507.2302],
//             [535797.0142, 3951534.5359],
//             [535783.4007, 3951572.3855],
//             [535771.0792, 3951606.6303],
//             [535757.3422, 3951644.7772],
//             [535750.4029, 3951664.304],
//             [535727.911, 3951672.2376],
//             [535605.7273, 3951631.5097],
//             [535578.3051, 3951621.9561],
//             [535563.0731, 3951616.6494],
//             [535526.473, 3951605.6421],
//             [535500.33, 3951600.9639],
//             [535469.7841, 3951598.2119],
//             [535442.2653, 3951598.2119],
//             [535419.2504, 3951585.9495],
//             [535410.6187, 3951601.2389],
//             [535345.246, 3951620.6583],
//             [535326.6003, 3951625.1129],
//             [535298.5537, 3951619.5468],
//             [535294.8637, 3951604.2117],
//             [535300.83, 3951559.1178],
//             [535302.8938, 3951540.8615],
//             [535305.4901, 3951516.9644],
//             [535306.8335, 3951504.7933],
//             [535315.3738, 3951427.1118],
//             [535315.9512, 3951421.8778],
//             [535319.9556, 3951385.4549],
//             [535323.5989, 3951352.3119],
//             [535327.465, 3951318.9479],
//             [535331.2189, 3951286.4807],
//             [535334.6372, 3951256.9103],
//             [535337.2913, 3951234.0268],
//             [535339.2397, 3951217.2081],
//             [535340.3503, 3951208.1474],
//             [535342.2781, 3951192.3895],
//             [535350.4922, 3951125.343],
//             [535359.0102, 3951055.8496],
//             [535362.4449, 3951025.0192],
//           ],
//         ],
//       },
//     },
//     {
//       dist: 5.421776186369631,
//       source: "پایانه شهید براری",
//       destination: "میدان ولی\u200cعصرعج",
//       coor: {
//         type: "MultiLineString",
//         coordinates: [
//           [
//             [544477.8169, 3950020.7301],
//             [544476.4936, 3950015.2247],
//             [544474.2821, 3950014.8744],
//             [544454.1737, 3950011.4348],
//             [544443.8734, 3950009.5608],
//             [544439.107280175, 3950005.17293256],
//             [544434.0965, 3950001.3711],
//             [544429.465346659, 3949998.48768327],
//             [544424.575795543, 3949995.98161102],
//             [544419.427846655, 3949993.85288326],
//             [544414.0215, 3949992.1015],
//             [544367.9424, 3949989.9295],
//             [544346.5278, 3949987.8521],
//             [544321.7224, 3949985.7864],
//             [544276.2824, 3949982.0023],
//             [544221.8258, 3949977.4673],
//             [544208.4898, 3949970.1494],
//             [544193.938, 3949974.9088],
//             [544017.4133, 3949957.0258],
//             [543883.7073, 3949942.1637],
//             [543876.1165, 3949936.2494],
//             [543867.4073, 3949940.5316],
//             [543798.9793, 3949934.4288],
//             [543695.64, 3949924.2848],
//             [543471.2083, 3949902.9852],
//             [543424.8488, 3949898.152],
//             [543325.2683, 3949887.0153],
//             [543313.8515, 3949880.0965],
//             [543296.1066, 3949885.0719],
//             [543092.5536, 3949865.3062],
//             [543051.3851, 3949862.2325],
//             [542970.4217, 3949854.8816],
//             [542881.7957, 3949847.682],
//             [542811.8213, 3949840.7285],
//             [542671.6914, 3949826.8034],
//             [542538.9465, 3949814.3553],
//             [542347.155, 3949793.5718],
//             [542284.3997, 3949786.7713],
//             [542196.8311, 3949778.3957],
//             [542094.3331, 3949766.0744],
//             [542073.9056, 3949757.797],
//             [542049.8625, 3949760.3488],
//             [541977.1055, 3949751.1563],
//             [541933.781, 3949747.1265],
//             [541881.1786, 3949741.4758],
//             [541799.1741, 3949731.5426],
//             [541725.6666, 3949727.3997],
//             [541716.2144, 3949721.1306],
//             [541705.0291, 3949725.9445],
//             [541684.9727, 3949724.4761],
//             [541653.0978, 3949722.1426],
//             [541583.9108, 3949716.7353],
//             [541556.9945, 3949715.1067],
//             [541476.3167, 3949708.5572],
//             [541421.9275, 3949705.8217],
//             [541375.3847, 3949702.8447],
//             [541371.6297, 3949702.6045],
//             [541351.411, 3949701.3113],
//             [541346.6639, 3949701.0077],
//             [541286.8424, 3949697.1812],
//             [541154.3507, 3949685.1797],
//             [540998.1182, 3949670.3277],
//             [540905.8276, 3949662.2921],
//             [540902.8207, 3949662.8506],
//             [540900.261, 3949663.6293],
//             [540899.0639, 3949664.0306],
//             [540897.9935, 3949664.5236],
//             [540896.62, 3949665.1562],
//             [540895.4377, 3949665.7007],
//             [540894.1286, 3949666.5782],
//             [540892.8709, 3949667.4212],
//             [540891.7954, 3949668.3561],
//             [540890.1846, 3949669.7562],
//             [540889.2891, 3949670.7891],
//             [540888.2224, 3949672.0194],
//             [540887.201, 3949673.4437],
//             [540886.4948, 3949674.6865],
//             [540885.33, 3949676.7367],
//             [540883.7225, 3949680.7856],
//             [540882.5965, 3949684.9078],
//             [540867.3696, 3949847.1385],
//             [540869.3817, 3949877.1444],
//             [540865.9582, 3949888.8555],
//             [540862.4654, 3949900.8035],
//             [540858.6819, 3949914.8595],
//             [540848.8, 3949921.5387],
//             [540832.5145, 3949929.2728],
//             [540802.9955, 3949923.0599],
//             [540782.7309, 3949919.4557],
//             [540704.7425, 3949913.6745],
//             [540683.7685, 3949911.6607],
//             [540642.7719, 3949907.7396],
//             [540487.9845, 3949894.4205],
//             [540484.6508, 3949863.4007],
//             [540480.6807, 3949796.2861],
//             [540480.2672, 3949789.3782],
//             [540476.6074, 3949715.657],
//             [540474.546, 3949666.7755],
//             [540471.6177, 3949660.8911],
//             [540470.0074, 3949658.087],
//             [540468.8638, 3949656.2388],
//             [540465.9104, 3949651.9131],
//             [540463.3984, 3949648.6486],
//             [540459.1419, 3949643.7959],
//             [540455.2987, 3949640.0032],
//             [540448.7052, 3949634.5175],
//             [540437.9083, 3949627.6842],
//             [540431.7842, 3949625.7775],
//             [540425.585, 3949624.3766],
//             [540409.1998, 3949627.1401],
//             [540384.1443, 3949633.5294],
//             [540365.5245, 3949639.061],
//             [540339.7528, 3949651.3066],
//             [540321.2137, 3949664.2579],
//             [540287.6004, 3949692.5732],
//             [540263.3082, 3949717.9453],
//             [540217.7552, 3949770.1117],
//             [540204.4034, 3949785.2862],
//             [540175.9955, 3949814.9418],
//             [540163.1368, 3949826.1337],
//             [540145.9361, 3949838.4925],
//             [540132.2334, 3949846.0833],
//             [540112.2308, 3949851.5866],
//             [540092.6864, 3949856.1847],
//             [540001.3564, 3949867.1628],
//             [539917.4289, 3949878.0887],
//             [539837.2989, 3949888.7326],
//             [539789.4757, 3949894.9904],
//             [539719.7815, 3949904.7508],
//             [539719.6032, 3949904.7758],
//             [539669.5891, 3949911.78],
//             [539589.9581, 3949924.3587],
//             [539583.6539, 3949925.0342],
//             [539580.1779, 3949925.3105],
//             [539578.1693, 3949925.433],
//             [539576.2579, 3949925.5243],
//             [539573.8827, 3949925.6036],
//             [539570.6279, 3949925.6509],
//             [539564.9899, 3949926.0586],
//             [539526.2059, 3949931.7993],
//             [539452.4805, 3949937.4137],
//             [539407.4871, 3949945.0814],
//             [539254.088, 3949964.5349],
//             [539242.8974, 3949963.3673],
//             [539235.3404, 3949961.5794],
//             [539228.5167, 3949958.8543],
//             [539223.6823, 3949956.1773],
//             [539217.9103, 3949951.9742],
//             [539213.0012, 3949947.2553],
//             [539210.6491, 3949944.4804],
//             [539201.6946, 3949932.3589],
//             [539197.132, 3949924.1396],
//             [539174.4461, 3949832.8061],
//             [539154.4679, 3949763.0588],
//             [539148.6508, 3949729.9295],
//             [539143.832279321, 3949727.82301759],
//             [539138.960522427, 3949726.13802346],
//             [539134.03552932, 3949724.87451759],
//             [539129.0573, 3949724.0325],
//             [539124.03605687, 3949723.61239552],
//             [539118.961792496, 3949723.61207737],
//             [539113.834506875, 3949724.03154552],
//             [539108.6542, 3949724.8708],
//             [539102.258835677, 3949729.47332186],
//             [539095.6191, 3949733.6564],
//             [539087.890063665, 3949737.84468636],
//             [539079.8543, 3949741.5065],
//             [539011.4736, 3949763.1462],
//             [538961.1974, 3949768.8523],
//             [538942.3458, 3949769.8445],
//             [538929.7781, 3949771.1674],
//             [538912.3596, 3949777.1834],
//             [538824.0248, 3949815.9484],
//             [538799.4714, 3949826.9551],
//             [538789.002, 3949823.9021],
//             [538783.3671, 3949835.1509],
//             [538728.9876, 3949858.7754],
//             [538721.2088, 3949861.9504],
//             [538712.0013, 3949866.3954],
//             [538699.3013, 3949872.5867],
//             [538598.1774, 3949916.243],
//             [538523.2472, 3949950.0569],
//             [538513.7222, 3949954.0256],
//             [538502.073, 3949959.9505],
//             [538430.0608, 3949991.8082],
//             [538418.1545, 3949996.0945],
//             [538402.9108, 3949992.7381],
//             [538400.1713, 3950004.8422],
//             [538386.2048, 3950010.6787],
//             [538352.233, 3950026.0855],
//             [538280.7913, 3950058.4953],
//             [538229.9155, 3950079.3398],
//             [538136.0213, 3950118.2006],
//             [538049.1254, 3950153.8698],
//             [537992.5617, 3950176.9106],
//             [537978.6117, 3950175.0011],
//             [537963.9979, 3950181.7804],
//             [537770.058, 3950191.57],
//             [537744.0423, 3950192.8504],
//             [537693.9901, 3950195.2741],
//             [537654.8317, 3950197.6554],
//             [537645.1744, 3950198.3169],
//             [537563.832, 3950202.4166],
//             [537482.1108, 3950207.0472],
//             [537399.1114, 3950210.8846],
//             [537386.8082, 3950211.9429],
//             [537378.8707, 3950212.3398],
//             [537368.6843, 3950212.7367],
//             [537333.3623, 3950214.9856],
//             [537320.0361, 3950215.5128],
//             [537275.5507, 3950217.4992],
//             [537265.4602, 3950210.9081],
//             [537249.7127, 3950211.8602],
//             [537249.6661, 3950211.9154],
//             [537243.2715, 3950219.4836],
//             [537138.364, 3950225.569],
//             [537107.6723, 3950227.4211],
//             [537088.0931, 3950228.0825],
//             [537075.5212, 3950228.888],
//             [537019.796, 3950234.1136],
//             [536992.0466, 3950235.7738],
//             [536986.433, 3950236.0909],
//           ],
//           [
//             [536986.4095, 3950236.0922],
//             [536958.0518, 3950237.5027],
//             [536943.4622, 3950238.3675],
//             [536827.8895, 3950243.0066],
//             [536802.6265, 3950244.1784],
//             [536711.7358, 3950249.9742],
//             [536565.2518, 3950258.1892],
//             [536555.7307, 3950258.7473],
//             [536433.0534, 3950266.7132],
//             [536365.3172, 3950270.3375],
//             [536216.2009, 3950279.9705],
//             [536157.0775, 3950283.4541],
//             [536085.1818, 3950288.2027],
//             [536085.1652, 3950288.2042],
//             [536070.5715, 3950289.316],
//             [536061.5428, 3950289.7409],
//             [535998.804, 3950293.3381],
//             [535985.774, 3950294.1046],
//             [535972.2806, 3950294.9016],
//             [535979.416, 3950360.6139],
//             [535979.6674, 3950362.9049],
//             [535983.7, 3950400.0277],
//             [535987.351, 3950433.5647],
//             [535994.103, 3950491.1572],
//             [535994.7246, 3950496.327],
//             [536001.8797, 3950557.486],
//             [536006.6572, 3950598.1754],
//             [536008.0965, 3950610.5714],
//             [536014.9462, 3950668.7141],
//             [536020.1892, 3950715.3358],
//             [536025.0322, 3950758.4376],
//             [536029.2678, 3950796.2301],
//             [536032.7072, 3950869.9239],
//             [535981.2439, 3951024.2565],
//             [535953.0316, 3951103.0363],
//             [535937.7207, 3951145.7932],
//             [535927.7277, 3951173.2487],
//             [535904.2109, 3951237.8444],
//             [535891.3647, 3951273.2975],
//             [535872.2114, 3951326.3488],
//             [535849.9995, 3951387.8811],
//             [535826.0481, 3951454.2669],
//             [535806.9072, 3951507.2302],
//             [535797.0142, 3951534.5359],
//             [535783.4007, 3951572.3855],
//             [535771.0792, 3951606.6303],
//             [535757.3422, 3951644.7772],
//             [535750.4029, 3951664.304],
//             [535774.2649, 3951655.7417],
//             [535921.0322, 3951706.7432],
//             [535927.5601, 3951728.4101],
//             [535945.6157, 3951716.283],
//             [536063.3964, 3951757.7448],
//             [536067.6027, 3951778.0772],
//             [536089.0806, 3951765.0831],
//             [536356.0261, 3951857.0692],
//             [536550.6635, 3951929.4625],
//             [536568.1942, 3951953.7913],
//             [536604.9077, 3951945.3685],
//             [536676.0498, 3951969.8145],
//           ],
//         ],
//       },
//     },
//   ], //حمل و نقل عمومی

//   PHARMACY: [
//     {
//       name: "داروخانه",
//       dist: 51.3984567,
//       lon: 35.7089196,
//       lat: 298.935946468397,
//     },
//     {
//       name: "داروخانه دکتر غفوری",
//       dist: 51.4010259,
//       lon: 35.709585,
//       lat: 540.462406392638,
//     },
//     {
//       name: "داروخانه فرانس پاستور",
//       dist: 51.4035392,
//       lon: 35.7067076,
//       lat: 730.00625333082,
//     },
//   ], //امکانات رفاهی
//   GYM: [
//     {
//       name: "فدراسیون شطرنج",
//       dist: 51.3950676,
//       lon: 35.7120919,
//       lat: 496.456251088175,
//     },
//     {
//       name: "مجموعه فرهنگی و ورزشی شهرد خت",
//       dist: 51.3900626,
//       lon: 35.7060899,
//       lat: 525.604264648116,
//     },
//     {
//       name: "باشگاه اندیشه",
//       dist: 51.4004817,
//       lon: 35.7021113,
//       lat: 758.001290679478,
//     },
//   ], //امکانات رفاهی
//   HOTEL: [
//     {
//       name: "هتل",
//       dist: 51.3935117,
//       lon: 35.7075261,
//       lat: 185.122934465193,
//     },
//     {
//       name: "رستوران هتل",
//       dist: 51.3934324,
//       lon: 35.7074686,
//       lat: 192.790624720853,
//     },
//     {
//       name: "هتل امید",
//       dist: 51.3907651,
//       lon: 35.7054655,
//       lat: 495.663116283064,
//     },
//   ], //امکانات رفاهی
//   PARK: [
//     {
//       name: "بوستان لاله",
//       dist: 51.3928453669202,
//       lon: 35.7107211902308,
//       lat: 421.058938370331,
//     },
//     {
//       name: null,
//       dist: 51.4044202172193,
//       lon: 35.7124046365648,
//       lat: 961.215772364211,
//     },
//     {
//       name: "بوستان اقاقیا",
//       dist: 51.3851997265862,
//       lon: 35.7145114153696,
//       lat: 1208.24744776497,
//     },
//   ], //امکانات رفاهی
//   POOL: [
//     {
//       name: "استخر سازمان آب",
//       dist: 51.3942338724952,
//       lon: 35.7149349079197,
//       lat: 818.700468763458,
//     },
//     {
//       name: "استخر آریان",
//       dist: 51.378342600131,
//       lon: 35.7110110003574,
//       lat: 1601.83975920446,
//     },
//     {
//       name: null,
//       dist: 51.4107965957863,
//       lon: 35.698281378283,
//       lat: 1726.33569709159,
//     },
//   ], //امکانات رفاهی
//   SCHOOL: [
//     {
//       name: "دانشگاه علوم پزشکی و خدمات بهداشتی درمانی تهران",
//       dist: 51.3951856996604,
//       lon: 35.707910100171,
//       lat: 45.1276384144161,
//     },
//     {
//       name: "مدرسه سعیدی",
//       dist: 51.3960583001505,
//       lon: 35.7102758999129,
//       lat: 296.563830959651,
//     },
//     {
//       name: "مدرسه نرجس",
//       dist: 51.4003769003737,
//       lon: 35.706827200415,
//       lat: 445.64855290147,
//     },
//   ], //امکانات رفاهی
//   SHOP: [
//     {
//       name: "سوپر مارکت یاس",
//       dist: 51.3982974,
//       lon: 35.7102974,
//       lat: 385.928997242558,
//     },
//     {
//       name: "سوپر مارکت زنجیره\u200cای جانبو",
//       dist: 51.3981237,
//       lon: 35.7104879,
//       lat: 392.829503626305,
//     },
//     {
//       name: "دامداران",
//       dist: 51.3985182,
//       lon: 35.7048962,
//       lat: 405.400876419717,
//     },
//   ], //امکانات رفاهی
//   ZOO: [
//     {
//       name: "باغ پرندگان",
//       dist: 51.4148274,
//       lon: 35.6836168,
//       lat: 3185.1198426046,
//     },
//   ], //امکانات رفاهی

//   HOSPITAL: [
//     {
//       name: "  بیمارستان آریا ",
//       dist: 51.3978047610809,
//       lon: 35.7085992209773,
//       lat: 230.149516033916,
//     },
//     {
//       name: "  بیمارستان یاس سپید ",
//       dist: 51.3977517496436,
//       lon: 35.7103362498181,
//       lat: 359.747774678179,
//     },
//     {
//       name: "  بیمارستان پارس ",
//       dist: 51.3994320294647,
//       lon: 35.7102696352355,
//       lat: 456.807536379685,
//     },
//   ], //ایمنی محیطی
//   BOHRAN: [
//     {
//       dist: 104.20676040254634,
//       name: "پارکینگ دانشگاه تهران",
//       lon: 535701.4426,
//       lat: 3951527.0311,
//     },
//     {
//       dist: 267.6902170619457,
//       name: "مدرسه آیت ا.. سعیدی",
//       lon: 535835.6263,
//       lat: 3951855.9346,
//     },
//     {
//       dist: 322.17596679550724,
//       name: "دانشگاه تهران",
//       lon: 535543.6829,
//       lat: 3951376.3936,
//     },
//   ], //ایمنی محیطی
//   FIRE: [
//     {
//       name: "ایستگاه آتش نشانی",
//       dist: 51.3930940627408,
//       lon: 35.7081802762988,
//       lat: 230.599503507524,
//     },
//   ], //ایمنی محیطی
//   POLICE: [
//     {
//       name: "کلانتری ۱۰۷ فلسطین",
//       dist: 51.4082983,
//       lon: 35.7063006,
//       lat: 1162.86331626605,
//     },
//   ], //ایمنی محیطی
//   ALUDEGI: [{ name: "aqi", value: 34 }],
//   // ALUDEGI: "TRUE", //آلودگی هوا
//   // message: "done",
// };
export default data;


